import { React, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker'
import { fetchGridLayout, getHyphenDDMMMYYYYHHMM,getHyphenDDMMYYYYHHMMSS, saveGridLayout,getHyphenDDMMMYYYY } from '../common/utils';
import RoutemapTransitAction from './RoutemapTransitAction.js'
import RoutemapenrouteAction from './routemapenroute.js';
import moment from "moment";
import { Modal } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import SweetAlert from "react-bootstrap-sweetalert";
import Filter from '../../assets/icons/filters.svg'
import redirectURL from "../redirectURL";
import MainCounters from './mainCounters.js'
import ViewMap from './ViewMap';
import TransitDelay from './TransitDelay';

import EnrouteException from './EnrouteException';
// import Overspeeding from './Overspeeding';
// import NightDriving from './NightDriving';
import LoadingException from './LoadingException';
import UnloadingException from './UnloadingException';
import DrawMap from '../common/drawmap';
import RoutemapAction from './routemapActionComponent.js';
import RouteNightDrivemap from './routenightdrivemap.js';
import NoGPS from './NoGPS.js';
import NoGPSMap from './NoGPSMap.js';
import ForceClose from './forceClose.jsx';
import ConsignmentActions from './ConsignmentActionsComponent';
import ShipmentLegs from "../layouts/shipmentlegs.js";
import AddDealerConsignments from "./addDealerConsignments.js";
import CourierConsignments from './CourierConsignments';
import BulkForceFileHandler from "../layouts/changebulkuploadhandler";
import GroupIconRenderer from './GroupIconRenderer.js';
import UpdatePTLConsignments from "./updatePTLConsignments.js";
import SendEmail from "./SendEmail.js";
import CustomDialog from './CustomDialog.js';
import CustomDialogForDocumentsViewing from './CustomDialogForDocumentsViewing.js';
import UpdateFTLConsignments from "./updateFTLConsignments.js";
import CryptoJS from 'crypto-js';





var map = ''
function FTLConsignments() {
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
    const user = useMemo(() => JSON.parse(decode(localStorage.getItem("k"))), []);

    const navigate = useNavigate();
    const gridApi = useRef();
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    const reloadPage = useRef(false);
    var [rowData, setRowData] = useState([])
    var [filterToggle, setFilterToggle] = useState(false)
    var [key, setKey] = useState('')
    const [gridColumnState, setGridColumnState] = useState([]);
    const [overly, setOverlay] = useState("show-n")
    const [loadshow, setLoadShow] = useState("show-n")
    const [forcecloseModal, setForcecloseModal] = useState(false);
    const [searchConsignee, setSearchConsignee] = useState([{ label: 'All', value: 'all' }]);
    const [movementtype, setMovementtype] = useState({ label: '', value: '' });
    const [searchValue, setSeachValue] = useState('');
    const [counter, setCounter] = useState({ label: "Consignments", value: "consignments" });
    var [detailCellRendererParams, setdetailCellRendererParams] = useState(null);
    const [basicTitle, setBasicTitle] = useState('');
    const [basicType, setBasicType] = useState('');
    const [maptruckno, setMaptruckno] = useState('');
    const [deptcode, setDeptcode] = useState('');
    const [sliderRouteTranslate, setSliderRouteTranslate] = useState('');
    const [showDiv, setShowDiv] = useState('');
    const [mapinfo, setMapinfo] = useState({});
    const [dealer, setDealer] = useState('');
    const [consignment_code, setConsignment_code] = useState('');
    const [routeTruck, setRouteTruck] = useState({});
    const [leg_no, setLeg_no] = useState(0);
    const [tolls, setTolls] = useState([]);
    const [devation_flag, setDevation_flag] = useState(false);
    const [sliderCreateConsignmentTranslate, setSliderCreateConsignmentTranslate] = useState("show-n")
    var [selected_row, setselected_row] = useState({});
    const [showAddForm, setshowAddForm] = useState("");
    const [showAddForm1, setshowAddForm1] = useState("");
    const [showAddForm2, setshowAddForm2] = useState("");
    const [showAddForm3, setshowAddForm3] = useState("");

    const [manualUploadSlider, setManualUploadSlider] = useState('show-n');
    const [bulkMarkDeliverSlide, setBulkMarkDeliverSlide] = useState('show-n');
    const [shipmentSlider, setShipmentSlider] = useState('show-n');
    const [shipmentCsvContent, setShipmentCsvContent] = useState([]);
    const [shipmentFile, setShipmentFile] = useState('');
    const [bulkSliderShow, setBulkSliderShow] = useState('show-n');
    const [sliderScanShow, setSliderScanShow] = useState('show-n');
    const [sliderSupportShow, setSliderSupportShow] = useState('show-n');
    const [selectedRowNodes, setSelectedRowNodes] = useState([]);
    const [multiplePodDocs, setMultiplePodDocs] = useState([]);
    const [deliveredDate1, setDeliveredDate1] = useState("");
    const [podremarks, setPodRemarks] = useState("");
    const [docremarks, setDocRemarks] = useState("");
    const [updateRowSlider, setUpdateRowSlider] = useState("");
    const [customerDocument, setCustomerDocument] = useState(null);
    var [gateOutRow, setGateOutRow] = useState({});
    var [gateOutSlide, setGateOutSlide] = useState("");
    var [invoiceCount, setInvoiceCount] = useState('');
    var [deliveredRow, setDeliveredRow] = useState({});
    var [deliveredSlide, setDeliveredSlide] = useState("");
    var [addDealer, setAddDealer] = useState(false);
    var [dispatchTime, setDispatchTime] = useState(false);
    var [updateCurrentStatus, setCurrentStatus] = useState(false);
    var [customerDocument1, setCustomerDocument1] = useState('');
    var [customerDocument2, setCustomerDocument2] = useState('');
    var [epodDoc, setEpodDoc] = useState("");

    var [uploadDoc, setUploadDoc] = useState([]);
    var [short, setShort]= useState(0);
    var [damage, setDamage]= useState(0);
    var [excess, setExcess]= useState(0);
    var [pilferage, setPilferage]= useState(0);
    var [shipmentId, setShipmentId] = useState("");
    const [error1, setError1] = useState('');


    var [tabActive, settabActive] = useState('ftl')
    var [csvcontent, setcsvcontent] = useState("")
    var [filteredData, setFilteredData] = useState([])
    var [rawRowData, setRawRowData] =useState([])
    const [file, setFile] = useState(null);
    var [vehicleTypeList, setVehicleTypeList] = useState([]);
    var [courierPartnerList, setCourierPartnerList] = useState([]);
    var [vehicleCapacityList, setVehicleCapacityList] = useState([]);

    const [reasonForceClose, setReasonForceClose] = useState("");
    const [filterCities, setFilterCities] = useState([]);
    const [filterStates, setFilterStates] = useState([]);
    const [filterTransporters, setFilterTransporters] = useState([]);
    const [filteredInvoices, setFilteredInvoices] = useState([]);
    const [filteredvehicles, setFilteredvehicles] = useState([]);
    const [filteredLrnos, setFilteredLrnos] = useState([]);
    const [searchCity, setSearchCity] = useState({ label: '', value: '' });
    const [searchState, setSearchStates] = useState({ label: '', value: '' });
    const [searchInvoice, setSearchInvoice] = useState({ label:"", value:"" });
    const [searchVehicle, setSearchVehicle] = useState({ value: "", label: "" })
    const [lrNo, setLrNo] = useState({ label:"", value:"" })
    const [searchTransporters, setSearchTransporters] = useState({ label: '', value: '' });
    const [searchConsigner, setSearchConsigner] = useState([{ label: 'All', value: 'all' }]);
    const [consignersList, setConsignersList] = useState([]);
    const [searchType, setSearchType] = useState({ label: 'Vehicle', value: 'truck_no' });
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [tabName, setTabName] = useState({ label: "Active", value: "active" });
    const [destinationPincodeDetails, setDestinationPincodeDetails] = useState({ label: "", value: "" });
    const [destinationPincodeList, setDestinationPincodeList] = useState({ label: "", value: "" });
    var [deliveredStatusList, setDeliveredStatusList] = useState([
        { label: 'In Transit', value: 'In Transit' }, { label: 'Near Destination', value: 'near_destination' },
        { label: 'Reached Destination', value: 'reached_destination' }, { label: 'Delivered', value: 'delivered' },
    ]);

    
    var filterCardStyle1 = { minHeight: "234px" };
    var filterCardStyle2 = { padding: '10px' };
    var mnFilterClass = { marginLeft: "0px", padding: "0px" };
    const [manualUpdateConsignment, setManualUpdateConsignment] = useState({
        driver_number: '',
        source: "",
        truck_no: "",
        truck_seal_no: "",
        vehicle_type: "",
        courier_partner:"",
        vehicle_capacity: "",
        consignee_name: "",
        lr_no: "",
        invoice_no: "",
        // destination_pincode: "",
        // destination_city:""
      });
    const [manualUploadDetails, setmanualUploadDetails] = useState({
        lr_no: '',
        consignee_name: "",
        invoice_no: "",
        no_of_boxes: "",
        destination_pincode: "",
        destination_city: "",
        eway_bill_no: "",
        customer_mail_id: "",
      });
      const [manualUploadDetails2, setmanualUploadDetails2] = useState({
        delivered_status:"",
        current_location:""
      });

      const [manualUploadDetails1, setmanualUploadDetails1] = useState({
        dispatch_time:'',
      }); 
      const [deliveredDate, setDeliveredDate] = useState({
        delivered_date:'',
      });  

    const [formData, setFormData] = useState({
        driver_mobile_no:'',
        source:'',
        truck_no:'',
        truck_seal_no:'',
        entity:'',
        vehicle_type:{label:'', value:''},
        courier_partner:{label:'', value:''},
        eway_bill_expiry_date:'',
        vehicle_capacity:{label:'', value:''},
        consignee_name:'',
        movement_type:'',
        lr_no:'',
        invoice_no:'',
        number_of_boxes:'',
        destination_pincode:'',
        destination_city:'',
        show: false,
        basicType: '',
        basicTitle: '',
        sliderCreateConsignmentTranslate: '',
        loadshow: 'show-n',
        overly: 'show-n',
    });
    
    var [filterToggle, setFilterToggle] = useState(false);
    const [counterOptions, setCounterOptions] = useState([
        { label: "Consignments", value: "consignments" },
        { label: "Transit Delays", value: "transit_delays" },
        { label: "GPS Not Available", value: "no_gps_data" },
        { label: "No GPS Available Lifetime", value: "no_gps_data_lifetime" },
        // { label: "Overspeeding", value: "overspeeding" },
        // { label: "Night Driving", value: "night_driving" },
        { label: "Stoppages", value: "stoppages" },
        { label: "Accidents", value: "accidents" },
        { label: "Trip Deviations", value: "trip_deviations" },
        { label: "Loading Delay", value: "loading_delay" },
        { label: "Unloading Delay", value: "unloading_delay" },
        { label: "POD Pending", value: "pod_pending" },
        { label: "Disabled", value: "disabled" }
    ]);

    var filterCardStyle1 = { minHeight: "234px" };
    var filterCardStyle2 = { padding: '10px' };
    var mnFilterclassName = { marginLeft: "0px", padding: "0px" };
    const [rownode, setRownode] = useState([]);
    var [mapDetails, setMapDetails] = useState([]);
    var [sliderShow, setSliderShow]=useState('')
    var [sliderShow1, setSliderShow1]=useState('')
    const [activeTrips, setActiveTrips] = useState({
        all: [],
        transit_delays: [],
        // overspeeding: [],
        // night_driving: [],
        stoppages: [],
        accidents: [],
        trip_deviations: [],
        loading_delay: [],
        unloading_delay: [],
        no_gps_data: [],
        no_gps_data_lifetime: []
    })
    const [completedTrips, setCompletedTrips] = useState({
        all: [],
        transit_delays: [],
        // overspeeding: [],
        // night_driving: [],
        stoppages: [],
        accidents: [],
        trip_deviations: [],
        loading_delay: [],
        unloading_delay: [],
        no_gps_data: [],
        no_gps_data_lifetime: []
    })
    const [allTrips, setAllTrips] = useState({
        all: [],
        transit_delays: [],
        // overspeeding: [],
        // night_driving: [],
        stoppages: [],
        accidents: [],
        trip_deviations: [],
        loading_delay: [],
        unloading_delay: [],
        no_gps_data: [],
        no_gps_data_lifetime: [],
        cancelled: []
    })
    var [rowData1, setrowData1] = useState([]);

    const [modalloadData, setModalLoadData] = useState([])
    const [plantData, setPlantData] = useState([])
    const [transporters, setTransporters] = useState([])
    const [dealers, setDealers] = useState([])
    const [previousData, setPreviousData] = useState([])
    const fileRef = useRef()
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [loader, setLoader] = useState(false)
    const [bulkUploadModal, setBulkUploadModal] = useState({
        overly: "show-n",
        bulkPrioritySlide: ""
    })
    const [openMap, setOpenMap] = useState({
        sliderRouteTranslate: "",
        showDiv: 'show-n',
        mapinfo: [],
        dealer: "",
        consignment_code: "",
        maptruckno: "",
        geofence_coordinates: [],
        parking_coordinates: [],
        routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
        loadshow: 'show-n',
        sidebarSubHeader: "",
        overly: 'show-m',
        rownode: {},
        leg_no: 0,
        tolls: []
    })
    const [countersActive, setCountersActive] = useState({
        consignments: 0,
        transit_delays: 0,
        // overspeeding: 0,
        // night_driving: 0,
        stoppages: 0,
        accidents: 0,
        trip_deviations: 0,
        loading_delay: 0,
        unloading_delay: 0,
        no_gps_data: 0,
        no_gps_data_lifetime: 0
    })
    const [countersCompleted, setCountersCompleted] = useState({
        consignments: 0,
        transit_delays: 0,
        // overspeeding: 0,
        // night_driving: 0,
        stoppages: 0,
        accidents: 0,
        trip_deviations: 0,
        loading_delay: 0,
        unloading_delay: 0,
        no_gps_data: 0,
        no_gps_data_lifetime: 0,
        pod_pending: 0,
    })
    const [countersAll, setCountersAll] = useState({
        consignments: 0,
        transit_delays: 0,
        // overspeeding: 0,
        // night_driving: 0,
        stoppages: 0,
        accidents: 0,
        trip_deviations: 0,
        loading_delay: 0,
        unloading_delay: 0,
        no_gps_data: 0,
        no_gps_data_lifetime: 0,
        cancelled:0
    })    
    const [tabOptions, setTabOptions] = useState([
        { label: "Active", value: "active" },
        { label: "Delivered", value: "completed" },
        { label: "All", value: "all" },
        { label: "In Active", value: "inactive" },
    ])

    var [data, setData] = useState([]);
    var [isSliderEmailOpen, setSliderEmailOpen] = useState(false);
    var [isSliderDocumentOpen, setSliderDocumentOpen] = useState(false);
    var [email, setEmail] = useState("");
    var [whatsapp_no, setWhatsapp_no] = useState("")
    var [expired_time, setexpired_time] = useState({ label: "1 Day", value: 1 })
    const [documents, setDocuments] = useState([]);
    const [cancelModal, setCloseCancelModal] = useState(false);
    const [reasonForCancellation, setReasonForCancellation] = useState("")
    const [lrNoOption, setLrOptions] = useState([]);
    const [invoiceNoList, setInvoiceNoList] = useState([]);
    const [shouldReload, setShouldReload] = useState(false);





    const transitdelaycols = [
        {
            headerName: "", field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RoutemapTransitAction,
                            params: {
                                onShowTransitRouteMap: onShowTransitRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Truck No", field: "truck_no", width: 100, resizable: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }
            }
        },
        {
            headerName: "Leg Start Time", field: "leg_start", width: 120, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.leg_start);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Leg End Time", field: "leg_end_eta",
            width: 120, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.leg_end_eta);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }
            }
        },
        {
            headerName: "Exp. Leg Distance (KM)",
            field: "leg_expected_distance", width: 140, resizable: true,
            valueGetter: function (params) {
                return Math.round(params.data.leg_expected_distance);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Actual Leg Distance Covered (KM)",
            field: "actual_leg_distance", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.actual_leg_distance != '' && params.data.actual_leg_distance != undefined) {
                    return Math.round(params.data.actual_leg_distance);
                }
                else {
                    return 0;
                }
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Exp. Distance from Trip Start(KM)",
            field: "expected_distance_start_to_leg", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.expected_distance_start_to_leg != '' && params.data.expected_distance_start_to_leg != undefined) {
                    return Math.round(params.data.expected_distance_start_to_leg);
                }
                else {
                    return 0;
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }

        },
        {
            headerName: "Actual Distance from Trip Start (KM)",
            field: "actual_distance_traveled_start_to_leg", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.actual_distance_traveled_start_to_leg != '' && params.data.actual_distance_traveled_start_to_leg != undefined) {
                    return Math.round(params.data.actual_distance_traveled_start_to_leg);
                }
                else {
                    return 0;
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },

        {
            headerName: "Google Distance from Start (KM)",
            field: "actual_start_to_leg_google_distance",
            width: 140,
            resizable: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },
        {
            headerName: "GPS Data Available",
            field: "no_gps_data",
            width: 140,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.no_gps_data == 1) {
                    return "Not Available";
                }
                if (params.data.no_gps_data == 0) {
                    return "Available";
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },


        {
            headerName: "Trip Completed",
            field: "trip_completed",
            width: 140,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.trip_completed == 1) {
                    return "Yes";
                }
                if (params.data.trip_completed == 2) {
                    return "";
                }
                if (params.data.trip_completed == 0) {
                    return "";
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        }
    ]
    const stoppagescols = [
        // {
        //     headerName: "",
        //     field: "_id",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: RoutemapenrouteAction,
        //                     params: {
        //                         onShowEnrouteRouteMap: onShowEnrouteRouteMap
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     width: 50,
        //     suppressSizeToFit: true,
        // },
        {
            headerName: "Break Start",
            field: "stoppage_start_time",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.stoppage_start_time != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.stoppage_start_time)
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Break End",
            field: "reset_datetime",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.reset_datetime != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.reset_datetime)
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Exception Closed On",
            field: "modified_date",
            width: 220,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.exception_closed == 1) {

                    if (params.data.modified_date != undefined) {
                        return getHyphenDDMMMYYYYHHMM(params.data.modified_date)
                    }
                    else {
                        return '';
                    }
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Break Time",
            field: "elaped_time_from_last_moved_seconds",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.exception_closed == 1) {
                    var sdate = moment.parseZone(params.data.stoppage_start_time).format("x");
                    if (typeof params.data.reset_datetime == 'undefined') {
                        var edate = moment.parseZone().format("x");
                    }
                    else {
                        var edate = moment.parseZone(params.data.reset_datetime).format("x");
                    }
                    var diff = (edate - sdate) / 1000;
                    return secondsToString(diff);
                }
                else {
                    return '';
                }
            }
        }
    ]
    const overspeedcols = [
        {
            headerName: "", field: "_id",
            width: 50,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RoutemapAction,
                            params: {
                                onShowRouteMap: onShowRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            resizable: true
        },
        { headerName: "Truck No", field: "truck_no", filter: true, resizable: true },
        { headerName: "Speed (km/h)", field: "speed", filter: true, resizable: true },
        {
            headerName: "Reported At", field: "first_instance", filter: true, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.first_instance);
            }
        },
    ]
    const nightdrivingcols = [
        {
            headerName: "", field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RouteNightDrivemap,
                            params: {
                                onShowNightDriveRouteMap: onShowNightDriveRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            suppressSizeToFit: true
        },
        { headerName: "Truck No", field: "truck_no", width: 150, resizable: true },
        {
            headerName: "Traveled From", field: "first_instance", width: 180, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.first_instance);
            }
        },
        {
            headerName: "Traveled Until", field: "recent_instance", resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.recent_instance);
            }
        },
        {
            headerName: "Distance Traveled (km)", field: "distance_from_first_instance", width: 180,
            resizable: true,
            valueGetter: function (params) {
                return Math.round(params.data.distance_from_first_instance)
            }
        }
    ]
    const unloadingcols = [
        {
            headerName: "From Date",
            field: "from_date",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                // console.log("child params ", params)
                if (params.data.from_date != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.from_date);
                }
                else {
                    return "NA"
                }

            }
        },
        {
            headerName: "To Date",
            field: "to_date",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.to_date != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.to_date);
                }
                else {
                    return "NA"
                }
            }
        },
        {
            headerName: "Unloading Time",
            field: "unloading_time",
            width: 180,
        }
    ]
    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        pivot: false,
    }
    let gridLegColumns = [];
    const columnDef = [
        {
            headerName: "AWB No",
            field: "lr_no",
            editable: true,
            cellStyle: params => {
                if (params.data.lr_no == undefined || params.data.lr_no == "") {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Entity",
            field: "entity",
            editable: true,
            cellStyle: params => {
                if (params.data.entity == undefined || params.data.entity == "") {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        // {
        //     headerName: "Origin City",
        //     field: "origin_city",
        //     editable: true,
        //     cellStyle: params => {
        //         if (params.data.origin_city == undefined || params.data.origin_city == "" ) {
        //             return {
        //                 "backgroundColor": '#c85f62'
        //             };
        //         }
        //     }
        // },
        {
            headerName: "Customer Name",
            field: "customer_name",
            editable: true,
            cellStyle: params => {
                if (params.data.customer_name == undefined || params.data.customer_name == "") {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Destination City",
            field: "destination_city",
            editable: true,
            cellStyle: params => {
                if (params.data.destination_city == undefined || params.data.destination_city == "") {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Destination Pincode",
            field: "destination_pincode",
            editable: true,
            cellStyle: params => {
                if (params.data.destination_pincode == undefined || params.data.destination_pincode == "") {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Invoice No",
            field: "invoice_no",
            editable: true,
            cellStyle: params => {
                if (params.data.invoice_no == undefined || params.data.invoice_no == "" 
                    // || !plantData.some(e => e.consigner_code == params.data.plant_code)
                ) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        // {
        //     headerName: "Invoice Type",
        //     field: "invoice_type",
        //     editable: true,
        //     cellStyle: params => {
        //         if (params.data.invoice_type == undefined || params.data.invoice_type == "" ) {
        //             return {
        //                 "backgroundColor": '#c85f62'
        //             };
        //         }
        //     }
        // },
        {
            headerName: "Invoice Date",
            field: "invoice_date",
            editable: true,
            valueGetter: (params) => {
                const date = params.data.invoice_date;
                // Check if date is in DD-MM-YYYY format
                const datePattern = /^\d{2}-\d{2}-\d{2}$/;
                console.log(typeof data,"dddddddd");
                
                if (date && datePattern.test(date)) {
                  return date;
                } else {
                  return "Invalid Date Format";
                }
              },
              cellStyle: (params) => {
                const date = params.value;
                // Apply red color if the date format is invalid
                if (date === "Invalid Date Format") {
                  return {"backgroundColor": "#c85f62" };
                }
                return null;
              },
        },
        {
            headerName: "Total CBM",
            field: "total_cbm",
            editable: true,
            cellStyle: params => {
                if (params.data.total_cbm == undefined || params.data.total_cbm == "") {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Total Weight",
            field: "total_weight",
            editable: true,
            cellStyle: params => {
                if (params.data.total_weight == undefined || params.data.total_weight == "") {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Courier Partner",
            field: "courier_partner",
            editable: true,
            cellStyle: params => {
                if (params.data.courier_partner == undefined || params.data.courier_partner == "" ) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Vehicle Type",
            field: "vehicle_type",
            editable: true,
            cellStyle: params => {
                if (params.data.vehicle_type == undefined || params.data.vehicle_type == "" ) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Vehicle No",
            field: "truck_no",
            editable: true,
            cellStyle: params => {
                if (params.data.truck_no == undefined || params.data.truck_no == "" ) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
	// {
    //         headerName: "Vehicle Capacity",
    //         field: "vehicle_capacity",
    //         editable: true,
    //         cellStyle: params => {
    //             if (params.data.vehicle_capacity == undefined || params.data.vehicle_capacity == "" ) {
    //                 return {
    //                     "backgroundColor": '#c85f62'
    //                 };
    //             }
    //         }
    //     },

	// {
    //         headerName: "Truck Seal No.",
    //         field: "truck_seal_no",
    //         editable: true,
    //         cellStyle: params => {
    //             if (params.data.truck_seal_no == undefined || params.data.truck_seal_no== "" ) {
    //                 return {
    //                     "backgroundColor": '#c85f62'
    //                 };
    //             }
    //         }
    //     },
	// {
    //         headerName: "Consignee Name",
    //         field: "consignee_name",
    //         editable: true,
    //         cellStyle: params => {
    //             if (params.data.consignee_name == undefined || params.data.consignee_name== "" ) {
    //                 return {
    //                     "backgroundColor": '#c85f62'
    //                 };
    //             }
    //         }
    //     },
	// {
    //         headerName: "Movement Type",
    //         field: "movement_type",
    //         editable: true,
    //         cellStyle: params => {
    //             if (params.data.movement_type == undefined || params.data.movement_type == "" ) {
    //                 return {
    //                     "backgroundColor": '#c85f62'
    //                 };
    //             }
    //         }
    //     },

        {
            headerName: "Dispatch Date",
            field: "dispatch_date",
            editable: true,
            valueGetter: (params) => {
                const date = params.data.dispatch_date;
                // Check if date is in DD-MM-YYYY format
                const datePattern = /^\d{2}-\d{2}-\d{2}$/;
                if (date && datePattern.test(date)) {
                  return date;
                } else {
                  return "Invalid Date Format";
                }
              },
              cellStyle: (params) => {
                const date = params.value;
                // Apply red color if the date format is invalid
                if (date === "Invalid Date Format") {
                  return {"backgroundColor": "#c85f62" };
                }
                return null;
              },
        },
        {
            headerName: "E-Way Bill No.",
            field: "eway_bill_no",
            editable: true,
            cellStyle: params => {
                if (params.data.eway_bill_no == undefined || params.data.eway_bill_no == "" ) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        // {
        //     headerName: "ODA",
        //     field: "oda",
        //     editable: true,
        //     cellStyle: params => {
        //         if (params.data.oda == undefined || params.data.oda == "" ) {
        //             return {
        //                 "backgroundColor": '#c85f62'
        //             };
        //         }
        //     }
        // },
        // {
        //     headerName: "Driver Mobie No.",
        //     field: "driver_number",
        //     editable: true,
        //     cellStyle: params => {
        //         if (params.data.driver_number == undefined || params.data.driver_number == "" ) {
        //             return {
        //                 "backgroundColor": '#c85f62'
        //             };
        //         }
        //     } 
        // },
        {
            headerName: "Mode (Road)",
            field: "shipment_mode",
            editable: true,
            cellStyle: params => {
                if (params.data.shipment_mode == undefined || params.data.shipment_mode =="" ) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        
        {
            headerName: "Number Of Boxes",
            field: "no_of_boxes",
            editable: true,
            cellStyle: params => {
                if (params.data.no_of_boxes == undefined || params.data.no_of_boxes == "" ) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Customer Mail ID",
            field: "customer_mail_id",
            editable: true,
            cellStyle: params => {
                if (params.data.customer_mail_id == undefined || params.data.customer_mail_id == "" ) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        // {
        //     headerName: "Mode (FTL/PTL)",
        //     field: "mode",
        //     editable: true,
        //     cellStyle: params => {
        //         if (params.data.mode == undefined || params.data.mode == "" ) {
        //             return {
        //                 "backgroundColor": '#c85f62'
        //             };
        //         }
        //     }
        // },
        
        
       
        // {
        //     headerName: "Fuel type",
        //     field: "fuel_type",
        //     editable: true,
        //     cellStyle: params => {
        //         if (params.data.fuel_type == undefined || params.data.fuel_type == "" ) {
        //             return {
        //                 "backgroundColor": '#c85f62'
        //             };
        //         }
        //     }
        // },
        // {
        //     headerName: "Driver name",
        //     field: "driver_name",
        //     editable: true,
        //     cellStyle: params => {
        //         if (params.data.driver_name == undefined || params.data.driver_name == "" ) {

        //             return {
        //                 "backgroundColor": '#c85f62'
        //             };
        //         }
        //     }
        // },
        // {
        //     headerName: "Driver Mobile No",
        //     field: "driver_mobile_no",
        //     editable: true
        // },
        // {
        //     headerName: "Movement Type",
        //     field: "movement_type",
        //     editable: true
        // },
        // 
        //     headerName: "Quantity",
        //     field: "quantity",
        //     editable: true,
        //     cellStyle: params => {
        //         if (params.data.quantity == undefined || params.data.quantity == "" || isNaN(params.data.quantity)) {
        //             return {
        //                 "backgroundColor": '#c85f62'
        //             };
        //         }
        //     }
        // },
        // {
        //     headerName: "Gross Weight (VU)",
        //     field: "gross_weight",
        //     editable: true
        // },
        // {
        //     headerName: "Gross Volume (VU)",
        //     field: "gross_volume",
        //     editable: true
        // },
        // {
        //     headerName: "Execution Date",
        //     field: "execution_date",
        //     editable: true,
        //     cellStyle: params => {
        //         if (params.data.execution_date == undefined || params.data.execution_date == "" || (!moment(params.data.execution_date, "YYYY-MM-DD HH:mm:ss", true).isValid())) {
        //             return {
        //                 "backgroundColor": '#c85f62'
        //             };
        //         }
        //     }
        // },
        // {
        //     headerName: "Expected Delivery Date",
        //     field: "expected_date",
        //     editable: true,
        //     cellStyle: params => {
        //         if (params.data.expected_date == undefined || params.data.expected_date == "" || (!moment(params.data.expected_date, "YYYY-MM-DD HH:mm:ss", true).isValid())) {
        //             return {
        //                 "backgroundColor": '#c85f62'
        //             };
        //         }
        //     }
        // },
        // {
        //     headerName: "Expected Return To Plant Date",
        //     field: "expected_return_to_plant_date",
        //     editable: true,
        //     cellStyle: params => {
        //         if (params.data.execution_date == undefined || params.data.execution_date == "" || (!moment(params.data.execution_date, "YYYY-MM-DD HH:mm:ss", true).isValid())) {
        //             return {
        //                 "backgroundColor": '#c85f62'
        //             };
        //         }
        //     }
        // }
    ]
    const nogpscols = [
        {
            headerName: "",
            field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: NoGPSMap,
                            params: {
                                onShowNoGPSRouteMap: onShowNoGPSRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            suppressSizeToFit: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Truck No", field: "truck_no", width: 100, resizable: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Last Data Receieved",
            field: "last_packet_datetime",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.last_packet_datetime);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Data Received on",
            field: "packet_received_on",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.packet_received_on);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        }
    ]
    const columnDefs2 = [
        {
            headerName: "",
            field: "_id",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: ViewMap,
                            params: {
                                onClickShowRoute: onClickShowRoute
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "transit_delay",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: TransitDelay,
                            params: {
                                onShowTransitData: onShowTransitData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "no_gps_data",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: NoGPS,
                            params: {
                                onShowNoGPSData: onShowNoGPSData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "enroute_exception",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: EnrouteException,
                            params: {
                                onShowStoppagesData: onShowStoppagesData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        // {
        //     headerName: "",
        //     field: "overspeeding_exception",
        //     width: 50,
        //     pinned: "left",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: Overspeeding,
        //                     params: {
        //                         onShowOverspeedingData: onShowOverspeedingData
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        // {
        //     headerName: "",
        //     field: "nightdriving_exception",
        //     width: 50,
        //     pinned: "left",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: NightDriving,
        //                     params: {
        //                         onShowNightDrivingData: onShowNightDrivingData
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        {
            headerName: "",
            field: "loading_delay_exception",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: LoadingException,
                            params: {
                                onShowLoadingData: onShowLoadingData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "unloading_delay_exception",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: UnloadingException,
                            params: {
                                onShowUnloadingData: onShowUnloadingData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "Consignment Code",
            field: "consignment_code"
        },
        {
            headerName: "Status",
            field: "status",
            valueGetter: function (params) {
                if (params.data.status == 1) {
                    return "Open";
                }
                else if (params.data.status == 2) {
                    return "InTransit";
                }
                else if (params.data.status == 3) {
                    return "Near Dealer";
                }
                else if (params.data.status == 4) {
                    return "Reached Dealer";
                }
                else if (params.data.status == 5) {
                    return "Left Dealer";
                }
                else if (params.data.status == 6) {
                    return "Force Closed";
                }
                else if (params.data.status == 7) {
                    return "Proximity Trip Closure";
                }
                else if (params.data.status == 8) {
                    return "Force Closed";
                }
                else {
                    return "NA";
                }
            }
        },
        {
            headerName: "Plant Location Code",
            field: "consigner_code"
        },
        {
            headerName: "FO Number",
            field: "fo_number"
        },
        {
            headerName: "Order Number",
            field: "order_number"
        },
        {
            headerName: "Quantity",
            field: "quantity"
        },
        {
            headerName: "Gross Weight (VU)",
            field: "gross_weight"
        },
        {
            headerName: "Gross Volume (VU)",
            field: "gross_volume"
        },
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            valueGetter: function (params) {
                if (params.data.invoice_time != undefined && params.data.invoice_time != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time)
                }
            }
        },
        {
            headerName: "Vehicle No.",
            field: "truck_no"
        },
        {
            headerName: "Vehicle Type",
            field: "truck_type"
        },
        {
            headerName: "Gate In Time",
            field: "gate_in_time"
        },
        {
            headerName: "Transporter Code",
            field: "transporter_code"
        },
        {
            headerName: "Transporter Name",
            field: "transporter_name"
        },
        {
            headerName: "Consigner Code",
            field: "consigner_code"
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code"
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name"
        },
        {
            headerName: "Consignee Zone",
            field: "consignee_zone"
        },
        {
            headerName: "Consignee Area",
            field: "consignee_area"
        },
        {
            headerName: "Consignee City",
            field: "consignee_city"
        },
        {
            headerName: "Consignee State",
            field: "consignee_state"
        },
        {
            headerName: "Dealer Distance from Plant",
            field: "dealer_distance_from_plant"
        },
        {
            headerName: "Execution Date",
            field: "execution_date",
            valueGetter: function (params) {
                if (params.data.execution_date != undefined && params.data.execution_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.execution_date)
                }
            }
        },
        {
            headerName: "Expected Delivery Date",
            field: "expected_date",
            valueGetter: function (params) {
                if (params.data.expected_date != undefined && params.data.expected_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_date)
                }
            }
        },
        {
            headerName: "Expected Return To Plant Date",
            field: "expected_return_to_plant_date",
            valueGetter: function (params) {
                if (params.data.expected_return_to_plant_date != undefined && params.data.expected_return_to_plant_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_return_to_plant_date)
                }
            }
        },
        {
            headerName: "Created Date",
            field: "created_date",
            valueGetter: function (params) {
                if (params.data.created_date != undefined && params.data.created_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.created_date)
                }
            }
        },
        {
            headerName: "",
            field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: ForceClose,
                            params: {
                                onShowForceCloseModal: onShowForceCloseModal
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        }
    ];
    const isDelivered = window.location.pathname.includes("completedconsignments")
    // let showdistance = (this.props.match.path == "/activecosnignments")
			// || (this.props.match.path == "/prtconsignments")
			// || (this.props.match.path == "/tnpconsignments")) 
            // ? false : true;
    console.log(rowData, "rowData");
    
    const columnwithDefs =
			[
				// {
				// 	headerName: "Actions",
				// 	field: "_id",
				// 	colId: "_id",
				// 	width: 40,
				// 	pinned: 'left',
				// 	filter: false, resizable: true,
					// headerCheckboxSelection: checkboxSelectionval,
					//headerCheckboxSelectionFilteredOnly: true,
				// 	checkboxSelection: true
				// },
                {
                    headerName: "",
                    field: "view_route",
                    width: 50,
                    pinned: "left",
                    cellRendererSelector: function (param) {
                        try {
                            if (param.data._id != null && param.data._id != undefined) {
                                return {
                                    component: ViewMap,
                                    params: {
                                        onClickShowRoute: onClickShowRoute
                                    }
                                }
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    },
                    cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                },
                // {
				// 	headerName: "",
				// 	field: "update",
				// 	width: 50,
                //     pinned:"left",
				// 	hide: tabName.value !== 'active',
				// 	cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 if(param.data.status == 1){
                //                     return {
                //                         component: UpdateFTLConsignments,
                //                         params: {
                //                             onClickActive1: onClickActive1
                //                         }
                //                     }
                //                 }else if(param.data.status == 2 || param.data.status == 3){
                //                     return {
                //                         component: UpdateFTLConsignments,
                //                         params: {
                //                             onClickActive1:updateDeliveredDate

                //                         }
                //                     }
                //                 }
                //                 else{
                //                     return ''
                //                 }
                               
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
				// },
             
                // {
                //     headerName: "",
                //     field: "transit_delay",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: TransitDelay,
                //                     params: {
                //                         onShowTransitData: onShowTransitData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "",
                //     field: "no_gps_data",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: NoGPS,
                //                     params: {
                //                         onShowNoGPSData: onShowNoGPSData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "",
                //     field: "enroute_exception",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: EnrouteException,
                //                     params: {
                //                         onShowStoppagesData: onShowStoppagesData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "",
                //     field: "loading_delay_exception",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: LoadingException,
                //                     params: {
                //                         onShowLoadingData: onShowLoadingData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "",
                //     field: "unloading_delay_exception",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: UnloadingException,
                //                     params: {
                //                         onShowUnloadingData: onShowUnloadingData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
				// 	pinned: "left",
				// 	headerName: 'Deviation',
				// 	colId: 'deviation_identified',
				// 	field: 'deviation_identified',
				// 	width: 40,
				// 	cellStyle: { color: "#464855", fontWeight: "500", display: "flex", alignItems: "center" },
				// 	// cellRenderer: 'kpiDeviationActions',
				// 	// valueGetter: function (params) {
				// 	// 	if(params.data.deviation_identified != undefined && params.data.deviation_identified != null && params.data.deviation_identified != ""){
				// 	// 		if ([1,1.0,"1","1.0"].includes(params.data.deviation_identified))
				// 	// 		{
				// 	// 		   return "Deviated";
				// 	// 	   }
				// 	// 	   else {
				// 	// 		   return "Not Deviated";
				// 	// 	   }
				// 	// 	}else{
				// 	// 		return "Not Deviated";
				// 	// 	}
				// 	// }
				// },
                {
                    headerName: "",
                    field: "shipmentlegs",
                    width: 50,
                    pinned: "left",
                    cellRendererSelector: function (param) {
                        try {
                            if (param.data._id != null && param.data._id != undefined) {
                                return {
                                    component: ShipmentLegs,
                                    params: {
                                        onClickShowShipmentLegs: onClickShowShipmentLegs
                                    }
                                }
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    },
                    cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                },
                {
                    headerName: "",
                    field: "",
                    width: 50,
                    pinned: "left",
                    cellRendererSelector: function (param) {
                        try {
                            if (param.data._id != null && param.data._id != undefined) {
                                return {
                                    component: GroupIconRenderer,
                                    params: {
                                        onShowTransitData: onShowTransitData,
                                        onShowNoGPSData: onShowNoGPSData,
                                        onShowStoppagesData: onShowStoppagesData,
                                        onShowUploadDoc: onShowUploadDoc,
                                        onShowDocs: onShowDocs,
                                    }
                                }
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    },
                    cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                },
                {
					headerName: "Edit",
					field: "edit",
					width: 80,
                    pinned:"left",
					hide: tabName.value !== 'active',
					cellRendererSelector: function (param) {
                        try {
                           
                                if (param.data._id != null && param.data._id != undefined) {
                                    if(param.data.status == 1){
                                        return {
                                            component: UpdatePTLConsignments,
                                            params: {
                                                onClickActive: onClickActive1
                                            }
                                        }
                                    }else if(param.data.status == 2 || param.data.status == 3){
                                        return {
                                            component: UpdatePTLConsignments,
                                            params: {
                                                onClickActive:updateDeliveredDate
    
                                            }
                                        }
                                    }
                                    else{
                                        return ''
                                    }
                                   
                                }   
                            
                        } catch (err) {
                            console.log(err);
                        }
                    },
                    cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
				},
                {
                    headerName: "Upload",
                    field: "upload_document",
                    width: 80,
                    filter: false,
                    pinned:"left",

                    hide:tabName.value !=='active',
                    cellRenderer: (params) => {
                      const handleClick = (e) => {
                        e.stopPropagation();
                        onShowUploadDoc(params);  // Assuming this is a function defined in your functional component or passed as a prop
                      };
                
                      return (
                        <span onClick={handleClick} title="Upload Document">
                        <i className="icofont icofont-upload-alt f20" style={{ color:"#3a3fa6"}}></i>
                    </span>
                      );
                    },
                  },
                  {
                    headerName: "View",
                    field: "view_document",
                    width: 80,
                    filter: false,
                    pinned:"left",

                    hide:tabName.value !=='active',
                    cellRenderer: (params) => {
                      const handleClick = (e) => {
                        e.stopPropagation();
                        onShowDocs(params);  // Assuming this is a function defined in your functional component or passed as a prop
                      };
                
                      return (
                        <span onClick={handleClick} title="View Documents">
                        <i className="fa fa-eye f20" 
                        // style={{ color: "#00C292" }}
                        ></i>
                    </span> 
                      );
                    },
                  },
				// {
				// 	headerName: "View Route",
				// 	field: "_id",
				// 	colId: "_id",
				// 	width: 40,
				// 	pinned: 'left',
				// 	cellRenderer: ConsignmentActions,
				// 	filter: false, resizable: true

				// },

				// {
				// 	headerName: "Transit Delay",
				// 	field: "transit_delay",
				// 	colId: "transit_delay",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
				// 	cellRendererSelector: function (params) {
				// 		if (params.data.transit_delay == 1) {
				// 			var rendComponent = {
				// 				component: 'kpiTransitDelayActions'
				// 			};
				// 			return rendComponent
				// 		}
				// 		else {
				// 			rendComponent = {
				// 				component: 'notransit'
				// 			};
				// 			return rendComponent
				// 		}
				// 	},
				// 	filter: true, resizable: true
				// },
				// {
				// 	headerName: "Gps Data",
				// 	field: "no_gps_data",
				// 	colId: "no_gps_data",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
					// cellRendererSelector: function (params) {
					// 	var comp = 'gps';
					// 	if (params.data.no_gps_data == 0 && params.data.no_gps_data_lifetime == 1) {
					// 		comp = 'noGpsLifetime'

					// 	}
					// 	else if (params.data.no_gps_data == 1) {
					// 		comp = 'nogps'
					// 	}

					// 	else if (params.data.no_gps_data == 0) {
					// 		comp = 'gps'

					// 	}
					// 	var rendComponent = {
					// 		component: comp
					// 	};
					// 	return rendComponent
					// },
				// 	filter: false, resizable: true
				// },
				// {
				// 	headerName: "Overspeed",
				// 	field: "overspeeding_exception",
				// 	colId: "overspeeding_exception",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
					// cellRendererSelector: function (params) {
					// 	if (params.data.overspeeding_exception == 1) {
					// 		var rendComponent = {
					// 			component: 'kpiActions'
					// 		};
					// 		return rendComponent
					// 	}
					// 	else {
					// 		var rendComponent = {
					// 			component: 'nooverspeed'
					// 		};
					// 		return rendComponent
					// 	}
					// },
				// 	filter: false, resizable: true
				// },
				// {
				// 	headerName: "Night Drive",
				// 	field: "nightdriving_exception",
				// 	colId: "nightdriving_exception",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: true,
					// hide: hideonlyPRT,
					// cellRendererSelector: function (params) {
					// 	//console.log("Except ",params.data.nightdriving_exception)
					// 	//console.log("Consignemnt code ", params.data.consignment_code)
					// 	if (params.data.nightdriving_exception != undefined && params.data.nightdriving_exception == 1) {
					// 		var rendComponent = {
					// 			component: 'kpiNightDriveActions'
					// 		};
					// 		return rendComponent
					// 	}
					// 	else {
					// 		var rendComponent = {
					// 			component: 'nonightdrive'
					// 			//component: 'kpiNightDriveActions'
					// 		};
					// 		return rendComponent
					// 	}
					// },
				// 	filter: false, resizable: true
				// },
				// {
				// 	headerName: "Loading Delay",
				// 	field: "loading_delay_exception",
				// 	colId: "loading_delay_exception",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
					// hide: hideonlyPRT,
					// cellRendererSelector: function (params) {
					// 	var rendComponent = {
					// 		component: 'kpiLoadingDelayActions'
					// 	};
					// 	return rendComponent;
					// },
				// 	filter: false, resizable: true
				// },
				// {
				// 	headerName: "Unloading Delay",
				// 	field: "unloading_delay_exception",
				// 	colId: "unloading_delay_exception",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
					// hide: hideonlyCol,
					// cellRendererSelector: function (params) {
					// 	if (params.data.unloading_delay_exception != undefined && params.data.unloading_delay_exception == 1) {
					// 		var rendComponent = {
					// 			component: 'kpiUnLoadingDelayActions'
					// 		};
					// 		return rendComponent;
					// 	}
					// 	else {
					// 		var rendComponent = {
					// 			component: 'kpiUnLoadingDelayActions'
					// 		};
					// 		return rendComponent;
					// 	}

					// },
				// 	filter: true, resizable: true
				// },
				// {
				// 	headerName: "Enroute Stoppages",
				// 	field: "enroute_exception",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
					// cellRendererSelector: function (params) {

					// 	var rendComponent = {
					// 		component: 'kpiEnrouteStoppagesActions'
					// 	};
					// 	return rendComponent

					// },
				// 	filter: false, resizable: true,
				// },
				
				// {
				// 	headerName: "Day Wise Distance Trip",
				// 	field: "day_wise_distance_trip",
				// 	colId: "day_wise_distance_trip",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
				// 	hide: true,
				// 	cellRenderer: 'kpiDayWiseDistanceActions',
				// 	filter: true, resizable: true
				// },
				// {
				// 	headerName: "Tolls",
				// 	field: "toll_details",
				// 	// colId: "breaks_at_tolls",
				// 	width: 40,
				// 	pinned: 'left',
				// 	filter: true,
				// 	resizable: true,
				// 	hide: showForDeliveryPrt,
				// 	cellRenderer: (params) => `<img style="height: 25px; width: 24px" src=${tollImg} />`,			

				// },
				/*	{
						headerName: "Actions",
						field: "comment_exists",
						//colId: "_id",
						width: 40,
						pinned: 'left',
						cellRenderer:'commentActions',
						filter: true,
						resizable: true,
						hide: (this.state.tnpReturnConsignmentsVisibilty)?true:false
	
					},
					{
						headerName: "",
						field: "tickets",
						//colId: "_id",
						width: 40,
						pinned: 'left',
						filter: true,
						resizable: true,
						hide: (this.state.tnpReturnConsignmentsVisibilty)?true:false,
						cellRendererSelector:function(params){
	
							var rendComponent = {
								component: 'Consignmenttickets'
							};
							return rendComponent
	
						},
	
					},*/
				/*			filter: true,
						resizable: true,
						hide: hideTNPconsignment,
						cellRenderer:function(params){
							return "<i className='fa fa-file'><i>"
						},
	
					},
					// {
					// 	headerName: "Actions",
					// 	field: "_id",
					// 	colId: "_id",
					// 	width: 40,
					// 	pinned: 'left',
					// 	resizable: true,
					// 	cellRenderer : "SegmentAction"
	
					// },
	
					{
						pinned:"left",
						headerName : "",
						field:"delete",
						width:40,
						resizable : true,
						editable : false,
						cellRenderer:function(params){
							if(params.data.consigner_code == "SMG")
							{
								return '<i className="icofont icofont-ui-delete"></i>';
							}
						},
						hide:hideDeleteOpt
					},*/

				// {
				// 	headerName: "Invoice No",
				// 	field: "invoice_no",
				// 	pinned: 'left',
				// 	width: 100,
				// 	resizable: true,
				// 	// hide:hideTNPconsignment,
				// 	// comparator: dateComparator,
				// 	valueGetter: function (params) {
				// 		if (params.data.invoice_no != '' && params.data.invoice_no != undefined) {
				// 			return parseInt(params.data.invoice_no).toString();
				// 		}
				// 		else {
				// 			return "";
				// 		}
				// 	},
				// },

				// {
				// 	headerName: "",
				// 	field: "shipmentlegs",
				// 	width: 50,
				// 	pinned: 'left',
				// 	cellRenderer:ShipmentLegs,
				// 	filter: false,resizable: true
					
				// },
              
				{
					headerName: "Vehicle No",
					field: "truck_no",
					width: 120,
					pinned: "left",
					filter: "agSetColumnFilter",
					resizable: true
				},
				{
					headerName: "Status",
					field: "status",
					width: 120,
					pinned: 'left',
					// hide : hideStatus,
					filter: "agSetColumnFilter",
					resizable: true,
                    valueFormatter: (params) => {
                        const statusMap = {
                            1: "At Source",
                            2: "In Transit",
                            3: "Near Destination",
                            4: "Reached Dealer",
                            5: "Left Dealer",
                            6: "Force Closure",
                            7: "Provision",
                            8: "Trip Completed"
                        };
                        return statusMap[params.value] || "Not Available";
                    }
					// valueGetter: (params) => {
					// 	//console.log("GPS ", params.data.gps_data_available);
					// 	if (params.data.status == 1) {
					// 		return "Inside Plant"
					// 	}
					// 	else if (params.data.status == 2) {
					// 		return "In Transit"
					// 	}
					// 	else if (params.data.dest_geofence_id != undefined && screen_type == "LOG-PRT") {
					// 		if (screen_url != "/prtconsignments") {
					// 			return "Reached Plant Gate";
					// 		}
					// 	}
					// 	else if (params.data.status == 3) {
					// 		return "Near Destination"
					// 	}
					// 	else if (params.data.status == 4) {
					// 		return "Reached Destination"
					// 	}

					// 	else if (params.data.status == 5) {
					// 		return "Trip Completed"
					// 	}
					// 	else if (params.data.status == 6) {
					// 		return "Force Closed"
					// 	}
					// 	else if (params.data.status == 7) {
					// 		return "Proximity Trip Closure"
					// 	}
					// 	else if (params.data.status == 8) {
					// 		return "Crossdock"
					// 	}
					// 	else if (params.data.status == 9) {
					// 		return "Trip Completed"
					// 	}
					// 	else {
					// 		return ""
					// 	}

					// }
				},
				{
					headerName: "Invoice Date",
					field: "invoice_time",
					width: 180,
					pinned: 'left',
					//filter: "agDateColumnFilter",
					cellRenderer: '', resizable: true,
					comparator: dateComparator,

					valueGetter: function (params) {
						if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
							return getHyphenDDMMMYYYY(params.data.invoice_time);
						}
						else {
							return "NA";
						}
					},
					// hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : hideonlyPRT, // this logic was imported from msil so for hero we are commenting this as of 27-07-2022
				},{
					// headerName: "Trip Started On" ,
					headerName: "Dispatch Date" ,
					field: "gate_out_time",
					width: 150,
					pinned: 'left',
					//filter: "agDateColumnFilter",
					cellRenderer: '', resizable: true,
					comparator: dateComparator,

					valueGetter: function (params) {
						if (params.data.gate_out_time != '' && params.data.gate_out_time != undefined && params.data.gate_out_time !== ' ') {
							return getHyphenDDMMMYYYYHHMM(params.data.gate_out_time);
						}
						else {
							return "NA";
						}
					},
				
				},
				{
					headerName: "Shipment Id" ,
					field: "shipment_id",
					width: 150,
					cellRenderer: '', resizable: true,
					hide:true,
					
				},
                {
					headerName: "Source" ,
					field: "consigner_name",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Current City" ,
					field: "current_city",
					width: 150,
					cellRenderer: '', resizable: true,
				},

                {
					headerName: "Truck Seal No" ,
					field: "truck_seal_no",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Entity" ,
					field: "truck_seal_entity",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Truck Type" ,
					field: "truck_type",
					width: 150,
					cellRenderer: '', resizable: true,
				},
				
				
				// {
				// 	headerName: "Truck Starting Point",
				// 	field: "truck_starting_point",
				// 	width: 200,
				// 	filter: "agSetColumnFilter",
				// 	hide: last_consignment_zone,
				// 	cellRenderer: '', resizable: true
				// },
				// {
				// 	headerName: "GR No",
				// 	field: "consignment_code",
				// 	//colId : "consignment_code",
				// 	width: 120,
				// 	editable: false,
				// 	filter: "agSetColumnFilter", resizable: true,
				// 	//cellRenderer : "agGroupCellRenderer"
				// },
				/*	{
						headerName: "VIN No(s)",
						field: "vin_list",
						width: 120,
						pinned: "left",
						editable: false,
						resizable: true,
						hide: hideVinsbvh
					},
					{
						headerName: "SBVH Code",
						field: "sbvh",
						width: 120,
						pinned: "left",
						editable: false,
						resizable: true,
						hide: hideVinsbvh
					},*/
				
				// {
				// 	headerName: "Original ETA",
				// 	field: "expected_trip_end",
				// 	id: "expected_trip_end",
				// 	width: 120,
				// 	//pinned: 'left',
				// 	resizable: true,
				// 	valueGetter: function (params) {
				// 		if (params.data.expected_trip_end != "" && params.data.expected_trip_end != undefined && params.data.expected_trip_end != null) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end);
				// 		}
				// 		else {
				// 			return "";
				// 		}


				// 	},
				// 	//filter: "agDateColumnFilter",
				// 	comparator: dateComparator,

				// },
				// {
				// 	headerName: "Revised ETA",
				// 	field: "revised_trip_end",
				// 	width: 120,
				// 	//pinned: 'left',
				// 	resizable: true,
				// 	// cellclassName : "dateFormat",
				// 	valueGetter: function (params) {
				// 		//console.log(" ETA ", params.data)
				// 		if (params.data.revised_trip_end == '' || params.data.revised_trip_end == undefined) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end);
				// 		}
				// 		else {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end);
				// 		}

				// 	},
				// 	//filter: "agDateColumnFilter",
				// 	comparator: dateComparator,

				// 	cellclassName: function (params) {
				// 		let hourDifference = 0;
				// 		if (params.data.revised_trip_end && params.data.expected_trip_end) {
				// 			let revisedDateOnlyMoment = moment(params.data.revised_trip_end);
				// 			let expectedDateOnlyMoment = moment(params.data.expected_trip_end);
				// 			hourDifference = revisedDateOnlyMoment.diff(expectedDateOnlyMoment, 'hours');
				// 			//console.log("diff= ", params.data.consignment_code, hourDifference);
				// 		} else {
				// 			//console.log("ELSE = ", params.data.revised_trip, params.data.expected_trip_end);
				// 		}

				// 		if (hourDifference >= 1) {
				// 			return 'bgColorDangerMedium'
				// 		}

				// 		if (hourDifference <= -1) {
				// 			return 'bgColorSuccessMedium'
				// 		}
				// 		else {
				// 			return ''
				// 		}
				// 	}
				// },
				// {
				// 	headerName: "Transit Delay (Days)",
				// 	field: "consignment_code",
				// 	width: 120,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '',
				// 	resizable: true,
				// 	valueGetter: function (params) {
				// 		var expected = params.data.expected_trip_end;
				// 		if (params.data.revised_trip_end == '' || params.data.revised_trip_end == undefined) {
				// 			var revised = params.data.expected_trip_end;
				// 		}
				// 		else {
				// 			var revised = params.data.revised_trip_end;
				// 		}
				// 		//console.log("Exp ", expected)
				// 		//console.log("revised ", revised)
				// 		var s = moment.parseZone(expected).format("x");
				// 		var ed = moment.parseZone(revised).format("x");
				// 		//console.log("Exp ", s)
				// 		//console.log("revised ", ed)
				// 		var diff = (ed - s)
				// 		// console.log("Diff",diff/1000)
				// 		var days = secondsToDays(diff)
				// 		//console.log("Days ", Math.round(days/1000))
				// 		var totaldays = Math.round(days / 1000);
				// 		if (totaldays > 0) {
				// 			return totaldays;
				// 		}
				// 		else {
				// 			return 0;
				// 		}
				// 		//return Math.round(days/1000);

				// 	}
				// },
				
				// {
				// 	headerName: "Duration from Gate Out",
				// 	field: "duration_from_gate_out",
				// 	width: 170,
				// 	pinned: "left",
				// 	filter: true,
				// 	resizable: true,
				// 	hide: hideDuration,
				// 	valueGetter: function (params) {
				// 		if (params.data.gate_out_time != undefined &&
				// 			params.data.gate_out_time != "" &&
				// 			params.data.gate_out_time != null
				// 		) {
				// 			var gateout = new Date(params.data.gate_out_time);
				// 			var lastpacket = new Date();
				// 			var diff = lastpacket.getTime() - gateout.getTime();
				// 			var diffdate = new Date(diff);
				// 			var days = Math.floor(diff / (1000 * 60 * 60 * 24))
				// 			days = (days < 0) ? 0 : days;
				// 			return days + " Day(s) : " + diffdate.getHours() + " hours : " + diffdate.getMinutes() + " Minutes"
				// 		}
				// 		else {
				// 			return "";
				// 		}

				// 	}
				// },

				{
					headerName: "Courier Partner",
					field: "transporter_name",
					width: 180,
					filter: "agSetColumnFilter",
					cellRenderer: '',
					resizable: true,
					valueGetter: function (params) {
						if (params.data.courier_partner != "" && params.data.courier_partner != "") {
							return params.data.courier_partner
						}
					}
				},
                {
					headerName: "E-Way Bill Expiry Date" ,
					field: "eway_bill_expiry_date",
					width: 180,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Vehicle Capacity" ,
					field: "vehicle_capacity",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Movement Type" ,
					field: "movement_type",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "LR No." ,
					field: "lr_no",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Invoice No." ,
					field: "invoice_list",
					width: 150,
                    cellRenderer: (params) => {
                        return Array.isArray(params.value) && params.value.length > 0 ? params.value[0] : '';
                    },  
                    resizable: true,
				},
                {
					headerName: "Number Of Boxes" ,
					field: "number_of_boxes",
					width: 180,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Destination Pincode" ,
					field: "consignee_pincode",
					width: 180,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Destination City" ,
					field: "destination_city",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                


				// {
				// 	headerName: "Transporter Code",
				// 	field: "transporter_code",
				// 	width: 110,
				// 	filter: "agSetColumnFilter",
				// 	// hide: hideTransporterCode,
				// 	cellRenderer: '', resizable: true,
				// 	valueGetter: function (params) {
				// 		if (params.data.truck_no != "" && params.data.truck_no != "") {
				// 			return params.data.transporter_code
				// 		}
				// 	}
				// },

				// {
				// 	headerName: "Travel Status",
				// 	field: "elaped_time_from_last_moved_seconds",
				// 	width: 150,
				// 	filter: "agSetColumnFilter",
				// 	hide:isDelivered,
					// valueGetter: function (params) {
					// 	// console.log(window.location.pathname.includes("prtallconsignments"),"paathname")
					// 	try {
					// 		if (params.data.truck_no != "" && params.data.truck_no != "") {
					// 			if (params.data.elaped_time_from_last_moved_seconds != "" && params.data.elaped_time_from_last_moved_seconds != undefined) {
					// 				if(params.data.status==9 || params.data.status==6 ||  params.data.status==5){
					// 					return "Trip Closed"
					// 				}
					// 				return "Idle (" + secondsToDhms(params.data.elaped_time_from_last_moved_seconds) + ")";
					// 			}

					// 			else {
					// 				if (params.data.elaped_time_from_last_moved_seconds == "" && params.data.elaped_time_from_last_moved_seconds == undefined) {

					// 					return "";
					// 				}
					// 				else if (params.data.no_gps_data == 1) {
					// 					return "Not Active";
					// 				}
									
					// 				else if(window.location.pathname.includes("prtallconsignments") && (params.data.status==4)){
										
					// 					return "Delivered"
					// 				}
					// 				else if(window.location.pathname.includes("prtallconsignments") && params.data.status==5){
					// 					return "Trip Completed "
					// 				}
					// 				else if(params.data.status==9 || params.data.status==6){
					// 					return "Trip Closed"
					// 				}else if (params.data.status == 8 ) {
					// 					return "Crossdock"
					// 				}
					// 				else{
					// 					return "Running";
					// 				}
									
					// 			}
					// 		}
					// 	}
					// 	catch (e) {

					// 	}
					// }
				// },

				// {
				// 	headerName: "Speed",
				// 	field: "speed",
				// 	width: 150,
				// 	filter: "agSetColumnFilter",
				// 	hide: isDelivered,
				// 	valueGetter: function (params) {
				// 		if (
				// 			params.data.truck_no &&
				// 			!['',null,undefined,"undefined"].includes(params.data.elaped_time_from_last_moved_seconds) &&
				// 			params.data.status !== 9 &&
				// 			params.data.status !== 6 &&
				// 			params.data.status !== 5 &&
				// 			['',null,undefined,"undefined"].includes(params.data.speed)
				// 		) {
				// 			return "0";
				// 		}else{
				// 			return params.data.speed
				// 		}
				// 	}
				// }
				// ,

				{
					headerName: "Travelled Distance (KM)",
					field: "aprox_dist_travelled_from_start",
					width: 200,
					filter: "agSetColumnFilter",
					valueGetter: params => {
						let data = params.data.aprox_dist_travelled_from_start
						if (data == 0) {
							return 0
						}
						return data
						// console.log("params",params.data.aprox_dist_travelled_from_start)
					}
				},
				{
					headerName: "Last Data Received",
					field: "timestamp",
					width: 180,
					hide:isDelivered,
					valueGetter: function (params) {
						return getHyphenDDMMMYYYYHHMM(params.data.timestamp)
					},
					comparator: dateComparator,
				},
				// {
				// 	headerName: "GPS Provider",
				// 	field: "truck",
				// 	width: 150,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true,
				// 	hide: showOnlyCol,
				// 	valueGetter: function (params) {
				// 		//console.log(params.data.transporter);
				// 		if (params.data.hasOwnProperty('truck')) {
				// 			if (params.data.truck.length > 0) {
				// 				return params.data.truck[0].actual_lspuser;
				// 			}
				// 		}

				// 	},
				// },				
				// {
				// 	headerName: "Plant Code",
				// 	field: "consigner_code",
				// 	width: 120,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },


				// {
				// 	headerName: "Dist. From Destination (km)",
				// 	field: "distance_from_dealer_location",
				// 	width: 150,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true,
				// 	valueGetter: function (params) {
				// 		//console.log("params ", params.data);
				// 		if (typeof params.data.distance_from_dealer_location == 'undefined') {

				// 		}
				// 		else {
				// 			return Math.round(params.data.distance_from_dealer_location);
				// 		}

				// 	},
				// 	hide: showonlyactivencr
				// },
				// {
				// 	headerName: "Dealer Code",
				// 	field: "consignee_code",
				// 	width: 150,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },

				// {
				// 	headerName: "Dealer Name",
				// 	field: "consignee_name",
				// 	width: 150,
				// 	hide: hideonlyTNP,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },
				// {
				// 	headerName: "Dealer City",
				// 	field: "consignee_city",
				// 	width: 150,
				// 	hide: hideonlyTNP,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },

				// {
				// 	headerName: "Dealer State",
				// 	field: "consignee_state",
				// 	width: 150,
				// 	hide: hideonlyTNP,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },

				// {
				// 	headerName: "GPS Gate In Time",
				// 	field: "inside_fence",
				// 	width: 180,
				// 	hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : false,
				// 	//filter: "agDateColumnFilter",
				// 	comparator: dateComparator,

				// 	valueGetter: function (params) {
				// 		return getHyphenDDMMMYYYYHHMM(params.data.inside_fence);
				// 	},
				// 	resizable: true
				// },
				// {
				// 	headerName: "GPS Gate out Time",
				// 	field: "outside_fence",
				// 	width: 180,
				// 	hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : false,
				// 	//filter: "agDateColumnFilter",
				// 	comparator: dateComparator,

				// 	valueGetter: function (params) {
				// 		return getHyphenDDMMMYYYYHHMM(params.data.outside_fence);
				// 	},
				// 	resizable: true
				// },
				// {
				// 	headerName: "Dist. Traveled last 24Hr (KM)",
				// 	field: "distance_travelled_in_24_hrs_kms",
				// 	//colId : "consignment_code",
				// 	width: 220,
				// 	editable: false,
				// 	filter: "agSetColumnFilter", resizable: true,
				// 	// hide: showdistance,
				// 	valueGetter: function (params) {
				// 		//console.log(params.data.distance_travelled_in_24_hrs_kms);
				// 		if (params.data.distance_travelled_in_24_hrs_kms != "" && params.data.distance_travelled_in_24_hrs_kms != undefined) {
				// 			return params.data.distance_travelled_in_24_hrs_kms;
				// 		}
				// 		else {
				// 			return 0;
				// 		}
				// 	}
					//cellRenderer : "agGroupCellRenderer"
				// },
				// {
				// 	headerName: "Truck Reporting Date",
				// 	field: "truck_reporting_date",
				// 	width: 130,
				// 	editable: false,
				// 	// cellEditor:DateEditor,
				// 	valueGetter: (params) => {
				// 		if (params.data.truck_reporting_date != undefined && params.data.truck_reporting_date != null) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.truck_reporting_date)
				// 		}
				// 		else {
				// 			return ""
				// 		}
				// 	},
				// 	resizable: true,
				// 	hide: isHiddenLocalMovement

				// },
				// {
				// 	headerName: "Transshipment",
				// 	field: "is_transshipment",
				// 	width: 110,
				// 	filter: "agSetColumnFilter",
				// 	valueGetter: function (params) {
				// 		if (params.data.is_transshipment == 1) {
				// 			return "Yes";
				// 		}
				// 		else {
				// 			return "No";
				// 		}
				// 	},
				// 	resizable: true,
				// 	// hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : false
				// 	hide: hidePriority
				// },

				// {
				// 	headerName: "Old Truck No",
				// 	field: "old_truck_no",
				// 	width: 200,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true,
				// 	// hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : false
				// 	hide: hidePriority
				// },
				// {
				// 	headerName: "Transshipment Date",
				// 	field: "transshipment_date",
				// 	width: 200,
				// 	filter: "agSetColumnFilter",
				// 	resizable: true,
				// 	valueGetter: function (params) {
				// 		return getHyphenDDMMMYYYYHHMM(params.data.transshipment_date);
				// 	},
				// 	// hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : false
				// 	hide: hidePriority

				// },

				// {
				// 	headerName: "Reached Destination At",
				// 	field: "first_dealer_reported",
				// 	width: 180,

				// 	hide: hideonlyCol,
				// 	//cellRenderer:'dateFormater',
				// 	valueGetter: function (params) {
				// 		if (params.data.status == 4 || params.data.status == 5 || params.data.status == 3) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
				// 		}
				// 		else {
				// 			return "";
				// 		}

				// 	},
				// 	resizable: true,

				// },
				// {
				// 	headerName: "Reached Plant Gate In",
				// 	field: "locked_dealer_reported",
				// 	width: 150,
				// 	//filter: "agDateColumnFilter",
				// 	cellRenderer: '', resizable: true,
				// 	hide: hideDealerGateIn,
				// 	comparator: dateComparator,
				// 	valueGetter: function (params) {

				// 		if (params.data.locked_dealer_reported != '' && params.data.locked_dealer_reported != undefined
				// 			&& params.data.dest_geofence_id != undefined) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.locked_dealer_reported);
				// 		}
				// 		else {
				// 			return "";
				// 		}
				// 	},
				// },
				{
					headerName: "Last Location",
					field: "address",
					width: 170,
					// hide:showOnlyCol,
					// valueGetter: function (params) {
					// 	//console.log(params.data.transporter);
					// 	try {
					// 		// console.log("params.data.truck.length ", params.data.truck.length)
					// 		if (params.data.truck.length > 0) {
					// 			// console.log("params.data.truck ", params.data.truck)
					// 			if (params.data.truck[0].last_known_address != undefined) {
					// 				if (params.data.truck_no != "" && params.data.truck_no != "") {
					// 					return params.data.truck[0].last_known_address;
					// 				}
					// 				else {
					// 					return "";
					// 				}
					// 			}
					// 			else {
					// 				return "";
					// 			}
					// 		}
					// 		else {
					// 			return "";
					// 		}
					// 	}
					// 	catch (e) {

					// 	}
					// },
					filter: "agSetColumnFilter",
					cellRenderer: '', resizable: true
				},
				// {
				// 	headerName: "Left Destination At",
				// 	field: "left_dealer_marked",
				// 	width: 180,
				// 	//filter: "agDateColumnFilter",
				// 	hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : hideonlyCol,
				// 	//cellRenderer:'dateFormater',
				// 	valueGetter: function (params) {
				// 		if (params.data.status == 5) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
				// 		}
				// 		else {
				// 			return "";
				// 		}

				// 	},
				// 	resizable: true,

				// },
				// {
				// 	headerName: "OnTime Delivery",
				// 	field: "ontime_status",
				// 	width: 110,
				// 	hide: hideOnTime,
				// 	valueGetter: function (params) {
				// 		if (params.data.ontime_status == 1) {
				// 			return "On Time";
				// 		}
				// 		else if (params.data.ontime_status == 0) {
				// 			return "Delayed";
				// 		} else {
				// 			return "";
				// 		}
				// 	},
				// 	cellclassName: function (params) {
				// 		if (params.data.ontime_status == 1) {
				// 			return "bgColorSuccessMedium";
				// 		}
				// 		else if (params.data.ontime_status == 0) {
				// 			return "bgColorDangerMedium";
				// 		} else {
				// 			return "";
				// 		}
				// 	}


				// },


				// {
				// 	headerName: transitTimeHeading,
				// 	field: "transit_time",
				// 	width: 200,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true,
				// 	valueGetter: function (params) {
				// 		if (department_code == "LOG-PRT") {
				// 			if (params.data.transit_time == 0) {
				// 				return "-";
				// 			}
				// 			else {
				// 				return params.data.transit_time;
				// 			}
				// 		}
				// 		else {
				// 			return params.data.transit_time;
				// 		}

				// 	}
				// },
				// {

				// 	headerName: "No Of Tolls",
				// 	field: "number_of_tolls",
				// 	width: 100,
				// 	filter: "agSetColumnFilter",
				// 	hide: showForDeliveryPrt,
				// 	cellRenderer: '', resizable: true,
				// 	valueGetter: function (params) {
				// 		if (department_code == "LOG-PRT") {
				// 			if (params.data.number_of_tolls !== 0 && params.data.number_of_tolls !== undefined) {
				// 				return params.data.number_of_tolls;
				// 			}
				// 			else if(params.data.status === 6){
				// 				return 'NA'
				// 			}
				// 			else {
				// 				return 0;
				// 			}
				// 		}						
				// 	}
				// },
				
				
				// {
				// 	headerName: "Sim Tracking State",
				// 	field: "sim_tracking_state",
				// 	width: 120,
				// 	// pinned: 'left',
				// 	// hide : hideStatus,
				// 	filter: "agSetColumnFilter",
				// 	resizable: true,
				// 	valueGetter: (params) => {
				// 		//console.log("GPS ", params.data.gps_data_available);
				// 		if(params.data.sim_tracking_state != undefined && params.data.sim_tracking_state != "" && params.data.sim_tracking_state != null){
				// 			if (params.data.sim_tracking_state == 4 
				// 				|| params.data.sim_tracking_state == 17
				// 				|| params.data.sim_tracking_state == 20
				// 				||params.data.sim_tracking_state == 23 ) {
				// 				return "DEACTIVATED"
				// 			}
				// 			else if (params.data.sim_tracking_state == 1) {
				// 				return "YET TO REGISTER"
				// 			}
				// 			else if (params.data.sim_tracking_state == 6) {
				// 				return "PENDING FOR CONSENT APPROVAL"
				// 			}
				// 			else if (params.data.sim_tracking_state == 8 || params.data.sim_tracking_state == 10) {
				// 				return "CONSENT DECLINED"
				// 			}
				// 			else if (params.data.sim_tracking_state == 3 || params.data.sim_tracking_state == 7 || params.data.sim_tracking_state == 9 || params.data.sim_tracking_state == 16 || params.data.sim_tracking_state == 19) {
				// 				return "ENABLED"
				// 			}
				// 			else {
				// 				return "YET TO TRACK"
				// 			}
				// 		}else{
				// 			return ""
				// 		}
				// 	}
				// },
				// {
				// 	headerName: "Driver Name",
				// 	field: "driver_name",
				// 	width: 150,
				// 	// hide: hideonlyTNP,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },
				{
					headerName: "Driver Number",
					field: "driver_number",
					width: 150,
					// hide: hideonlyTNP,
					filter: "agSetColumnFilter",
					cellRenderer: '', resizable: true
				},
                {
					headerName: "Revised ETA",
					field: "revised_trip_end",
					width: 150,
					// hide: hideonlyTNP,
					filter: "agSetColumnFilter",
					cellRenderer: '', resizable: true
				},
                {
					headerName: "Expected ETA",
					field: "expected_trip_end",
					width: 150,
					// hide: hideonlyTNP,
					filter: "agSetColumnFilter",
					cellRenderer: '', resizable: true
				},
				// {
				// 	headerName: "Sim Operator",
				// 	field: "sim_operator_name",
				// 	width: 150,
				// 	hide: hideonlyTNP,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },
				// {
				// 	headerName:"Resend Consent",
				// 	field : "recent_consent",
				// 	width : 120,
				// 	cellRendererSelector : function(params){
				// 					if (params.data.transporter_code == '141750'){
				// 						return ""
				// 					}else{
				// 						var rendComponent = {
				// 							component: 'RecentConsent'
				// 						};
				// 						return rendComponent
				// 					}
									
				// 	},
				// 	hide:isArcLogin
				// },
				// {
				// 	headerName:"Change Driver Details",
				// 	field : "change_driver_details",
				// 	width : 160,
				// 	cellRendererSelector: function(params){
				// 		if (params.data.transporter_code== '141750'){
				// 			return ""
				// 		}else{
				// 			var rendComponent = {
				// 				component: 'ChangeDriverDetails'
				// 			};
				// 			return rendComponent
				// 		}
				// 	},
				// 	hide:isHideChangeDriverButton
				// },
				// {
				// 	headerName: "Remarks",
				// 	field: "transit_time_remarks",
				// 	width: 110,
				// 	editable:true,
				// 	// hide: (localStorage.getItem("transportercode").includes("T305")|| localStorage.getItem("transportercode").includes("T329"))?false:true,	
				// 	// valueSetter:(params)=>{
				// 	// // console.log(params)
				// 	// 	if(params.oldValue != params.newValue)
				// 	// 	{
				// 	// 		var data = {
				// 	// 			truck_no:params.data.truck_no,
				// 	// 			transit_time_remarks:params.newValue,
				// 	// 			email:localStorage.getItem("email")
				// 	// 		}
				// 	// 		params.data.transit_time_remarks = params.newValue;
				// 	// 		redirectURL.post("/consignments/updatetransittimeremarks", data,{
				// 	// 		headers:{
				// 	// 			'Content-Type': 'application/json'
				// 	// 			}
				// 	// 			}).then((response)=>{
				// 	// 		})
				// 	// 	}
				// 	// }
				// },
				

				

				// {
				// 	headerName: "Force Close",
				// 	field: "",
				// 	width: 80,
				// 	// hide: showOnlyCol,
				// 	// cellRendererSelector: function (params) {
				// 	// 	var rendComponent = {
				// 	// 		component: 'consignmentforceclose'
				// 	// 	};
				// 	// 	return rendComponent;
				// 	// },
				// 	filter: false, resizable: true,


				// },
               
                {
                    headerName: "Share Tracking Link",
                    field: "sendemail",
                    width: 150,
                    cellRenderer:SendEmail,
                    filter: false,
                    pinned: "right",
                    hide: tabName.value !== 'active',
					cellRendererSelector: function (param) {
                        try {
                            if (param.data._id != null && param.data._id != undefined) {
                                if(param.data.status == 2 || param.data.status == 3){
                                    return {
                                        component: SendEmail,
                                        params: {
                                            onClickEmail: onClickEmail
                                        }
                                    }
                                }
                                else{
                                    return ''
                                }
                               
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    },
                },
                // {
				// 	headerName: "Add Dealer",
				// 	field: "add_dealer",
				// 	width: 80,
				// 	hide: tabName.value !== 'active',
				// 	cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: AddDealerConsignments,
                //                     params: {
                //                         onClickActive: onClickActive
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
				// },

				
				// {
				// 	headerName: "Force Closed Reason",
				// 	field: "force_closure_reason",
				// 	width: 200,
				// 	// hide: showOnlyColDeliver,
				// 	cellclassName: ['wraptext'],
				// 	filter: false, resizable: true,

				// {
				// 	headerName: "Route",
				// 	field: "parent_route",
				// 	width: 120,
				// 	filter: "agSetColumnFilter",
				// 	resizable: true,
				// 	pinned:"left",
				// },



			];
    useEffect(() => {
        let key = ''
        redirectURL.post('/details')
            .then((response) => {
                if (response.data.status === 'success') {
                    setKey(response.data.output[0].g_key);
                    key = response.data.output[0].g_key
                    loadScript("https://maps.googleapis.com/maps/api/js?key=" + key + "&libraries=places,drawing&callback=initMap");
                    window.initMap = async () => {
                        var lt = 28.4519751;
                        var ln = 77.0310713;
                        map = new window.google.maps.Map(document.getElementById('map_canvas'), {
                            zoom: 13,
                            center: new window.google.maps.LatLng(lt, ln),
                            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                        });
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });

        redirectURL.post('consignments/getConsigner')
            .then((response) => {
                setConsignersList(response.data.records)
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });

        redirectURL.post("/consignments/getConsignmentsNewFilterKeys", { dept_code: "SNDG" })
            .then((resp) => {
                console.log(resp, "responseseeee")
                var vehicles = resp.data.vehicles;
                var filteredVehicles = [];
                if(vehicles != undefined){
                    if (vehicles.length > 0) {
                        vehicles.map(function (c) {
                            filteredVehicles.push({
                                label: c._id,
                                value: c._id,
                            });
                        });
                    }
                }
                console.log(filteredVehicles,"filteredVehicles")
                var cities = resp.data.cities;
                var filterCities = [];
                if (cities != undefined) {
                    if (cities.length > 0) {
                        cities.map(function (c) {
                            filterCities.push({
                                label: c._id,
                                value: c._id,
                            });
                        });
                    }
                }

                var states = resp.data.states;
                var filterStates = [];
                if (states != undefined) {
                    if (states.length > 0) {
                        states.map(function (s) {
                            filterStates.push({
                                label: s._id,
                                value: s._id,
                            });
                        });
                    }
                }
                var clusters = resp.data.clusters;
                var filterClusters = [];
                if (clusters != undefined) {
                    if (clusters.length > 0) {
                        clusters.map(function (cl) {
                            filterClusters.push({
                                label: cl,
                                value: cl,
                            });
                        });
                    }
                }

                var transporters = resp.data.transporters;
                var filterTransporters = [];
                if (transporters != undefined) {
                    if (transporters.length > 0) {
                        transporters.map(function (t) {
                            filterTransporters.push({
                                label: t,
                                value: t,
                            });
                        });
                    }
                }

                var invoiceNumbers = resp.data.invoices;
                var filteredInvoices = [];
                if(invoiceNumbers != undefined){
                    if(invoiceNumbers.length > 0){
                        invoiceNumbers.map(function (t){
                            filteredInvoices.push({
                                label: t._id,
                                value: t._id
                            })
                        })
                    }
                }

                var lrNos = resp.data.lrNos;
                var filteredLrnos = [];
                if(lrNos != undefined){
                    if(lrNos.length > 0){
                        lrNos.map(function (t){
                            filteredLrnos.push({
                                label: t._id,
                                value: t._id
                            })
                        })
                    }
                }
                setFilteredvehicles(filteredVehicles)
                setFilterCities(filterCities)
                setFilterStates(filterStates)
                setFilterTransporters(filterTransporters)
                setFilteredInvoices(filteredInvoices)
                setFilteredLrnos(filteredLrnos)
            })
        fetchGridLayout(user.email, "consignments")
            .then(res => {
                if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                    setGridColumnState(res.data.data[0].columnState)
                }
            })
            .catch(err => console.log(err))
    }, [])
    
    useEffect(async()=>{
        loadConsignmentsData()
        await redirectURL.post('/consignments/getVehicleMaster')
        .then(resp => {
            console.log(resp, "resppppppvehiclemaster")
            var records = resp.data.vehicleMaster
            var vehicleArr = records.map((e)=> e.vehicle_type);
            var vehicleCapacityArr = records.map((e)=> e.vehicle_capacity);
            var vehicleTypeList=[]
            var vehicleCapacityList=[]
            for (let i of vehicleArr){
                vehicleTypeList.push({label:i, value: i})
            }
            for (let i of vehicleCapacityArr){
                vehicleCapacityList.push({label:i, value: i})
            }
            console.log(vehicleTypeList, "vehicleTypeList")
            setVehicleTypeList(vehicleTypeList)
            setVehicleCapacityList(vehicleCapacityList)
        }) 
        await redirectURL.post('/consignments/getTransportersList')
        .then(resp => {
            console.log(resp, "respppppptptmaster")
            var records = resp.data.tptMaster
            var tptNames = records.filter((e)=> e.transporter_type == "FTL").map((e)=> e.transporter_name);

            var tptNamesList=[]
            for (let i of tptNames){
                tptNamesList.push({label:i, value: i})
            }
            console.log(tptNamesList, "tptNamesList")
            setCourierPartnerList(tptNamesList)
        }) 
           

    },[])
    useEffect(() => {
        if (shouldReload && !show) { // If modal is closed and reload flag is true
            window.location.reload(); // Reload the page
        }
    }, [shouldReload, show]);
    useEffect(() => {
        if (gridColumnState.length > 0 && columnApiConsignments.current) {
            columnApiConsignments.current.applyColumnState({
                state: gridColumnState,
                applyOrder: true,
            })
        }
    }, [gridColumnState, columnApiConsignments])
    useEffect(() => {
        console.log(tabName,"tabName");
        if ( tabName.value == "active") {
            // window.location.href = "/activeftlconsignments"
            setRowData(activeTrips.all)
        }
        else if (tabName.value == "completed") {
            // window.location.href = "/deliveredftlconsignments"
            setRowData(completedTrips.all)
            setCounter({label:counterOptions[0].label, value:counterOptions[0].value})

        }
        else if (tabName.value == "all") {
            // window.location.href = "/allftlconsignments"
            setRowData(allTrips.all)
            setCounter({label:counterOptions[0].label, value:counterOptions[0].value})

        }
       
    }, [tabName.value])
    

    const onClickActive = (e) => {
        console.log(e,"adddeal")
        setselected_row(e.data);
        // setshowAddForm("slide30");
        setmanualUploadDetails((prev)=>({
            ...prev,
            lr_no:e.data.lr_no
        }))
        setshowAddForm("slider-translate-30p");
        setOverlay("show-m");
      };
      const onClickActive1 = (e) => {
        console.log(e,"adddeal")
        setselected_row(e.data);
        setShipmentId(e.data.shipment_id)

        // setshowAddForm("slide30");
        // setmanualUploadDetails1((prev)=>({
        //     ...prev,
        //     lr_no:e.data.lr_no
        // }))
        setshowAddForm1("slider-translate-30p");
        setOverlay("show-m");
      };
      const onClickUpdate = (e) => {
        console.log(e,"adddeal")
        setselected_row(e.data);
        setShipmentId(e.data.shipment_id)

        // setshowAddForm("slide30");
        // setmanualUploadDetails1((prev)=>({
        //     ...prev,
        //     lr_no:e.data.lr_no
        // }))
        setshowAddForm3("slider-translate-30p");
        setOverlay("show-m");
      };
      const updateDeliveredDate = (e) => {
        console.log(e,"adddeal")
        setselected_row(e.data);
        setInvoiceCount(e.data.invoice_count)
        setShipmentId(e.data.shipment_id)

        let query = {
            truck_no: e.data.truck_no,
            shipment_id: e.data.shipment_id,
        }
        redirectURL.post('/consignments/getShipmentDetails', query)
        .then(resp => {
            console.log(resp, "respppppp")
            if (resp.data.consignmentsForDelivered?.length > 0) {
                console.log(resp.data.consignmentsForDelivered, "response")
                var records = resp.data.consignmentsForDelivered

            const destinationPincodeList =    records.map(each => ({
                    label : each.consignee_pincode,
                    value: each.consignee_pincode
            }))
            console.log(destinationPincodeList, "destinationPincodeList");
            
            setDestinationPincodeList(destinationPincodeList)

                // }
        // })
        // .catch(err => {
        //     console.log(err);
        // })
            }})
        // setshowAddForm("slide30");
        // setmanualUploadDetails1((prev)=>({
        //     ...prev,
        //     lr_no:e.data.lr_no
        // }))
        setshowAddForm2("slider-translate-30p");
        setOverlay("show-m");
      };
    

    const onClickHideAll = () => {
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setLoadShow("show-n")
        setSliderCreateConsignmentTranslate("")
    }
    const saveConsignmentData = async (event) => {
        event.preventDefault();
        let specialCharcters = 0;
        const { driver_mobile_no, source, truck_no, truck_seal_no, entity, vehicle_type, courier_partner, eway_bill_expiry_date, vehicle_capacity, consignee_name, movement_type, lr_no, invoice_no, number_of_boxes, destination_pincode, destination_city } = formData;
        // const invoice_date = document.getElementById('invoice_date').value;
        // const created_by = localStorage.getItem('email');
        // const encode = cipher('V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x');
        // let transporter_code = '';

        // if (localStorage.getItem('user_type') === 'TRANSPORTER') {
        //     const tpt_code = JSON.parse(localStorage.getItem('transportercode'));
        //     transporter_code = tpt_code[0];
        // } else {
        //     transporter_code = formData.transporter_code;
        // }

        // const gate_out_time = document.getElementById('gate_out_time').value;

        // if (truck_no && truck_no.match(/[^a-zA-Z0-9]/g)) {
        //     specialCharcters = 1;
        // }
        console.log(eway_bill_expiry_date,"eway_bill_expiry_date");
        
        if (specialCharcters === 0) {
            let fieldsChk = 0;
            if (truck_no && driver_mobile_no && lr_no && invoice_no && courier_partner && consignee_name) {
                fieldsChk = 1;
            }

            if (fieldsChk === 1) {
                const add_consignment_params = {
                    driver_mobile_no, 
                    source,
                    truck_no,
                    truck_seal_no,
                    entity, 
                    vehicle_type: vehicle_type.value, 
                    courier_partner: courier_partner.value, 
                    eway_bill_expiry_date: formatDateForSubmission(eway_bill_expiry_date),                    
                    vehicle_capacity: vehicle_capacity.value, 
                    consignee_name, 
                    movement_type, 
                    lr_no, 
                    invoice_no, 
                    number_of_boxes, 
                    destination_pincode, 
                    destination_city 
                };
                if (addDealer){
                    add_consignment_params.add_dealer=1
                }
                var add_drop_point_params = {
                    lr_no: manualUploadDetails.lr_no,
                    consignee_name:manualUploadDetails.consignee_name,
                    invoice_no:manualUploadDetails.invoice_no,
                    number_of_boxes:manualUploadDetails.no_of_boxes,
                    destination_pincode:manualUploadDetails.destination_pincode,
                    destination_city:manualUploadDetails.destination_city,
                    // eway_bill_no:manualUploadDetails.eway_bill_no,
                    // customer_mail_id:manualUploadDetails.customer_mail_id,
                    // shipment_id: selected_row.shipment_id
                }
                const combinedParams = {
                    add_consignment_params,            // First set of params for updating the collection
                    add_drop_point_params     // Second set of params to be sent to the backend API
                };

                try {
                    const response = await redirectURL.post('/consignments/saveConsignmentData', combinedParams);
                    if (response.data.status === 'Success') {
                        // document.getElementById('invoice_date').value = '';
                        // document.getElementById('gate_out_time').value = '';
                        setShow(true)
                        setTitle('Successfully created consignment')
                        setType('success')
                        setLoadShow('show-n')
                        setOverlay('show-n')
                        setSliderCreateConsignmentTranslate('')
                        setFormData({
                            ...formData,
                            driver_mobile_no:'', 
                            source:'',
                            truck_no:'', 
                            truck_seal_no:'',
                            entity:'', 
                            vehicle_type:{label:'', value:''}, 
                            courier_partner:{label:'', value:''}, 
                            eway_bill_expiry_date:'', 
                            vehicle_capacity:{label:'', value:''}, 
                            consignee_name:'', 
                            movement_type:'', 
                            lr_no:'', 
                            invoice_no:'', 
                            number_of_boxes:'', 
                            destination_pincode:'', 
                            destination_city:'', 
                           
                        });
                        setmanualUploadDetails({
                            lr_no: '',
                            consignee_name: "",
                            invoice_no: "",
                            no_of_boxes: "",
                            destination_pincode: "",
                            destination_city: "",
                            eway_bill_no: "",
                            customer_mail_id: "",
                        })
                        loadConsignmentsData()
                        // Call componentDidMount equivalent
                    } else {
                      
                            setShow(true)
                            setTitle(response.data.message === 'Consignment Code Already Exists' ? 'Consignment Code Already Exists' : 'Failed to create consignment')
                            setType('danger')
                        
                    }
                } catch (error) {
                    console.error(error);
                }
            } else {
                setShow(true)
                setTitle('All fields are mandatory')
                setType('danger')

               
            }
        } else {
            setShow(true)
            setTitle('Special characters are not allowed')
            setType('danger')
           
        }
    };

    const closeForceCloseModal = (e) => {
        setForcecloseModal(false)
        setReasonForceClose('')
        setRownode([])
    }

    const onShowForceCloseModal = (e) => {
        setForcecloseModal(true)
        setRownode(e)
        setReasonForceClose('')
    }
    const onClickHideAll1 =()=>{
        setOverlay('show-n')
        setLoadShow('show-n')
        setSliderCreateConsignmentTranslate('')
        setFormData({
            ...formData,
            driver_mobile_no:'', 
            source:'',
            truck_no:'', 
            truck_seal_no:'',
            entity:'', 
            vehicle_type:{label:'', value:''}, 
            courier_partner:{label:'', value:''}, 
            eway_bill_expiry_date:'', 
            vehicle_capacity:{label:'', value:''}, 
            consignee_name:'', 
            movement_type:'', 
            lr_no:'', 
            invoice_no:'', 
            number_of_boxes:'', 
            destination_pincode:'', 
            destination_city:'', 
           
        }); 
        setmanualUploadDetails({
            lr_no: '',
            consignee_name: "",
            invoice_no: "",
            no_of_boxes: "",
            destination_pincode: "",
            destination_city: "",
            eway_bill_no: "",
            customer_mail_id: "",
        })   }

    const saveGrid = async (e) => {
        let coloumnState = columnApiConsignments.current.getColumnState()
        let temp = await saveGridLayout(user.email, "consignments", coloumnState)
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully updated")
            setType("success")
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }

    const resetGrid = async (e) => {
        let coloumnState = []
        let temp = await saveGridLayout(user.email, "consignments", coloumnState)
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully updated")
            setType("success")
            reloadPage.current = true
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }

    const formForceCloseHandler = (e) => {
        e.preventDefault()
        var consignemnt = rownode;
        var consignment_code = consignemnt.consignment_code;
        var truck_no = consignemnt.truck_no;
        var dept_code = "SNDG";
        var email = user?.email;
        var reqdata = {
            dept_code: dept_code,
            consignment_code: [consignment_code],
            truck_no: truck_no,
            email: email,
            reasonforceclose: reasonForceClose,
        }
        redirectURL.post("/consignments/updateConsignmentForceClose", reqdata)
            .then((response) => {
                if (response.data.status == 'Success') {
                    setShow(true)
                    setTitle("Successfully Force Closed the consignment")
                    setType("success")
                    closeForceCloseModal()
                    reloadPage.current = true
                }
                else {
                    setShow(true)
                    setTitle("Failed to Force Close")
                    setType("danger")
                }
            })
            .catch(function (e) {
                console.log("Error ", e)
            })

    }

    const handleStartDateChange = (date) => {
        if (endDate && date > endDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setStartDate(date)
        }
    };
    // async onClickShowShipmentLegs(params) {
	// 	console.log("params", params)
	// 	if (params != 0) {
	// 		var transitedelaydata = [];

	// 		await this.setState({

	// 			detailCellRendererParams: {
	// 				suppressRefresh: true,
	// 				detailGridOptions: {
	// 					headerHeight: 50,
	// 					columnDefs: [
	// 						{
	// 							headerName: "",
	// 							field: "legs_map",
	// 							colId: "legs_map",
	// 							width: 40,
	// 							pinned: 'left',
	// 							cellRenderer:function(params){
	// 								var htmloption = '<i className="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
	// 								return htmloption;
	// 							} ,
	// 							filter: false, resizable: true
			
	// 						},
	// 						{
	// 							headerName: "Invoice No",
	// 							field: "invoice_no",
	// 							width: 140,
	// 							// cellclassName: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Consignment",
	// 							field: "consignment_code",
	// 							width: 140,
	// 							// cellclassName: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Original ETA",
	// 							field: "expected_trip_end",
	// 							width: 140,
	// 							valueGetter: function (params) {
	// 								return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
	// 							},
	// 							cellclassName: function (params) {
	// 								if (params.data.transit_delay == 1) {
	// 									return 'lightred';
	// 								}
	// 								else {
	// 									return '';
	// 								}
	// 							},

	// 						},
	// 						{
	// 							headerName: "Revised ETA",
	// 							field: "revised_trip_end",
	// 							width: 140,
	// 							valueGetter: function (params) {
	// 								return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
	// 							},
	// 							cellclassName: function (params) {
	// 								if (params.data.transit_delay == 1) {
	// 									return 'lightred';
	// 								}
	// 								else {
	// 									return '';
	// 								}

	// 							}
	// 						},
							
	// 						{
	// 							headerName: "Status",
	// 							field: "status",
	// 							width: 140,
	// 							// cellclassName: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// },
								

	// 							valueGetter: function (params) {
	// 								//console.log("GPS ", params.data.gps_data_available);
	// 								if (params.data.status == 1) {
	// 									return "Inside Plant"
	// 								}
	// 								else if (params.data.status == 2) {
	// 									return "In Transit"
	// 								}
	// 								else if (params.data.status == 3) {
	// 									return "Near Destination"
	// 								}
	// 								else if (params.data.status == 4) {
	// 									return "Reached Destination"
	// 								}

	// 								else if (params.data.status == 5) {
	// 									return "Left Destination"
	// 								}
	// 								else if (params.data.status == 6) {
	// 									return "Force Closed"
	// 								}
	// 								else if (params.data.status == 8) {
	// 									return "Crossdock"
	// 								}else if(params.data.status == 9){
	// 									return "Trip Completed"
	// 								}
	// 								else {
	// 									return ""
	// 								}

	// 							}
	// 						},
	// 						{
	// 							headerName: "Zone",
	// 							field: "zone",
	// 							width: 100,
	// 							// cellclassName: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
							
	// 						{
	// 							headerName: "Dealer Code",
	// 							field: "consignee_code",
	// 							width: 100,
	// 							// cellclassName: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Dealer City",
	// 							field: "consignee_city",
	// 							width: 120,
	// 							resizable: true,
	// 							// cellclassName: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},

	// 						{
	// 							headerName: "Dealer Name",
	// 							field: "consignee_name",
	// 							width: 120,
	// 							resizable: true,
	// 							// cellclassName: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Trip Distance (KM)",
	// 							field: "distance_in_km",
	// 							width: 120,
	// 							resizable: true,
	// 							valueGetter: params =>{
	// 								if(params.data.distance_in_km>0){
	// 									return params.data.distance_in_km
	// 								}else{
	// 									return 0
	// 								}
	// 							}
	// 							,
	// 							// cellclassName: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Distance from Dealer (KM)",
	// 							field: "distance_from_dealer_location",
	// 							width: 160,
	// 							valueGetter: function (params) {
	// 								if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
	// 									return params.data.distance_from_dealer_location;
	// 								}
	// 								else {
	// 									return "";
	// 								}
	// 							},
	// 							// cellclassName: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Reached Destination At",
	// 							field: "first_dealer_reported",
	// 							width: 180,


	// 							//cellRenderer:'dateFormater',
	// 							valueGetter: function (params) {
	// 								if (params.data.status == 4 || params.data.status == 5 || params.data.status == 3) {
	// 									return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
	// 								}
	// 								else {
	// 									return "";
	// 								}

	// 							},
	// 							resizable: true,

	// 						},
	// 						{
	// 							headerName: "Left Destination At",
	// 							field: "left_dealer_marked",
	// 							width: 180,
	// 							//filter: "agDateColumnFilter",
	// 							//cellRenderer:'dateFormater',
	// 							valueGetter: function (params) {
	// 								if (params.data.status == 5) {
	// 									return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
	// 								}
	// 								else {
	// 									return "";
	// 								}

	// 							},
	// 							resizable: true,

	// 						},
	// 						{
	// 							headerName: "Transit Time (Days)",
	// 							field: "transit_time",
	// 							width: 200,
	// 							filter: "agSetColumnFilter",
	// 							cellRenderer: '', resizable: true
	// 						},
							
	// 					],
	// 					overlayNoRowsTemplate: 'No rows to show',
	// 					onCellClicked:(leg_params) =>{
	// 						if(leg_params.colDef.field =="legs_map"){
	// 							if(leg_params.data.status==8){
	// 								this.setState({
	// 									show: true,
	// 									basicTitle: 'No Route data available',
	// 									basicType: "danger",
	// 									loadshow: 'show-n'
	// 								});
	// 							}else{
								
	// 								var leg_params = leg_params.data
	// 								this.setState({
	// 									loadshow: 'show-m',
	// 									maptruckno: leg_params.truck_no
	// 								});
							
	// 								// If gateouttime is current time - It shows "No Route data available"
	// 								if (leg_params.invoice_time) {
	// 									var gateouttime = moment.parseZone(leg_params.invoice_time).format('YYYY-MM-DD HH:mm:ss');
	// 								}
	// 								else {
	// 									if (leg_params.gate_in_time) {
	// 										var gateouttime = moment.parseZone(leg_params.gate_in_time).format('YYYY-MM-DD HH:mm:ss');
	// 									}
	// 									else {
	// 										if (leg_params.gate_out_time) {
	// 											var gateouttime = moment.parseZone(leg_params.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
	// 										}
	// 									}
	// 								}
							
	// 								var edate = '';
	// 								var end_date;
	// 								if (leg_params.status <= 2) {
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 									edate = getHyphenYYYYMMDDHHMMSS(end_date);
	// 								}
	// 								else if (leg_params.status == 3 || leg_params.status == 4) {
	// 									if (leg_params.recent_dealer_reported) {
	// 										edate = getHyphenYYYYMMDDHHMMSS(leg_params.recent_dealer_reported);
	// 										end_date = getHyphenYYYYMMDDHHMMSS(leg_params.recent_dealer_reported);
	// 									}
	// 								}
	// 								else if (leg_params.status == 5) {
	// 									if (leg_params.left_dealer_marked) {
	// 										edate = getHyphenYYYYMMDDHHMMSS(leg_params.left_dealer_marked);
	// 										end_date =  getHyphenYYYYMMDDHHMMSS(leg_params.left_dealer_marked);
	// 									}
	// 								}
	// 								else if (leg_params.status == 6) {
	// 									if (leg_params.force_closure_time) {
	// 										let splitT = leg_params.force_closure_time.split('T')
	// 										let yMD = splitT[0]
	// 										let hMS = splitT[1]
	// 										let hms1 = hMS.split('.')
	// 										let finalHms = hms1[0]
	// 										let final_end_date = yMD + ' ' + finalHms
	// 										end_date = final_end_date;
	// 										edate = final_end_date
	// 									}
	// 								}
	// 								else {
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 									edate = getHyphenYYYYMMDDHHMMSS(end_date);
	// 								}							
	// 								if ((leg_params.transit_time) > 0) {
	// 									var seconddate = new Date(new Date(leg_params.gate_out_time).getTime() + ((leg_params.transit_time + 1) * 24 * 60 * 60 * 1000));
	// 								}
	// 								else {
	// 									var seconddate = new Date(new Date(leg_params.gate_out_time).getTime() + 2 * 24 * 60 * 60 * 1000);
	// 								}
							
	// 								var sdate = seconddate.getFullYear() + "-" + (seconddate.getMonth() + 1) + "-" + seconddate.getDate() + " " + seconddate.getHours() + ":" + seconddate.getMinutes() + ":" + seconddate.getSeconds();
							
	// 								if (!end_date) {
	// 									// When end date is unavailable then current date is considered as end date.
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
	// 								}
	// 								var reqData = {
	// 									truck_no: leg_params.truck_no,
	// 									consignment_code: leg_params.invoice_no,
	// 									consignee_code: leg_params.consignee_code,
	// 									gate_out_time: gateouttime,
	// 									seconddate: end_date,
	// 									screen: "consignment"
	// 								}
	// 								if (["2", "3", "4"].includes(leg_params.status)) reqData.mapMode = 2
							
	// 								redirectURL.post('/consignments/maproutes', reqData, {
	// 									headers: {
	// 										'content-type': 'application/json'
	// 									}
	// 								})
	// 									.then((response) => {
	// 										var records = response.data;
	// 										console.log(records,"record3535")
	// 										this.setState({
	// 											loadshow: 'show-m'
	// 										});
	// 										try {
	// 											if (records.coords.length == 0 || records.status == "failure") {
	// 												this.setState({
	// 													show: true,
	// 													basicTitle: 'No Route data available',
	// 													basicType: "danger",
	// 													loadshow: 'show-n'
	// 												});
	// 											}
	// 											else {
	// 												if (records != '') {
	// 													var sdate = leg_params.gate_out_time;
	// 													if (leg_params.invoice_time) {
	// 														var sdate = leg_params.invoice_time;
	// 													}
	// 													else {
	// 														if (leg_params.gate_in_time) {
	// 															var sdate = leg_params.gate_in_time;
	// 														}
	// 														else {
	// 															if (leg_params.gate_out_time) {
	// 																var sdate = leg_params.gate_out_time;
	// 															}
	// 														}
	// 													}
							
							
	// 													var edate = '';
	// 													var end_date = ""
	// 													console.log(leg_params.recent_dealer_reported , "recent_dealer_reported")
	// 													if (leg_params.status < 4) {
	// 														end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 														edate = getHyphenDDMMYYYYHHMMSS(end_date);
							
	// 													}
	// 													else if (leg_params.status == 4 ) {
	// 														console.log("end_time", leg_params)
	// 														edate = getHyphenDDMMYYYYHHMMSS(leg_params.end_time);
	// 														end_date = leg_params.recent_dealer_reported
	// 													}
	// 													else if (leg_params.status == 5) {
	// 														if (leg_params.left_dealer_marked) {
	// 															edate = getHyphenDDMMYYYYHHMMSS(leg_params.left_dealer_marked);
	// 															end_date = leg_params.left_dealer_marked
							
	// 														}
	// 														else {
	// 															end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 															edate = getHyphenDDMMYYYYHHMMSS(end_date);
	// 														}
	// 													}
	// 													if (leg_params.deviation_flag == 1 && this.state.deptcode == "LOG-PRT") {
	// 														var params = {
	// 															"base_route_id": leg_params.base_route_id
	// 														}
	// 														redirectURL.post("/consignments/getLiveRouteDeviationBaseRoute",
	// 															params).then((resp) => {
	// 																this.setState({
	// 																	sliderRouteTranslate: "slider-translate-60p",
	// 																	showDiv: 'show-m',
	// 																	mapinfo: records,
	// 																	dealer: leg_params.consignee_code,
	// 																	consignment_code: "Truck No : " + leg_params.truck_no,
	// 																	maptruckno: leg_params.truck_no,
	// 																	routeTruck: { "truck_no": leg_params.truck_no, "startTime": sdate, "endTime": end_date },
	// 																	loadshow: 'show-n',
	// 																	sidebarSubHeader: "Consignment Information",
	// 																	overly: 'show-m',
	// 																	rownode: leg_params,
	// 																	leg_no: 0,
	// 																	tolls: records.tolls,
	// 																	baseRouteCoords: resp.data.alteredHeroPRTBaseRoute,
	// 																	devation_flag: true
	// 																});
	// 																this.onShowGoogleRoute(leg_params.invoice_no, leg_params.consignee_code, 0, leg_params.truck_no)
	// 																this.renderMap();
	// 															})
	// 													}
	// 													else {
	// 														this.setState({
	// 															sliderRouteTranslate: "slider-translate-60p",
	// 															showDiv: 'show-m',
	// 															mapinfo: records,
	// 															dealer: leg_params.consignee_code,
	// 															consignment_code: "Invoice No : " + leg_params.invoice_no,
	// 															maptruckno: leg_params.truck_no,
	// 															routeTruck: { "truck_no": leg_params.truck_no, "startTime": sdate, "endTime": end_date },
	// 															loadshow: 'show-n',
	// 															sidebarSubHeader: "Consignment Information",
	// 															overly: 'show-m',
	// 															rownode: leg_params,
	// 															leg_no: 0,
	// 															tolls: records.tolls
	// 														});
	// 														this.onShowGoogleRoute(leg_params.invoice_no, leg_params.consignee_code, 0, leg_params.truck_no)
	// 														this.renderMap();
	// 													}
	// 												}
	// 											}
	// 										}
	// 										catch (e) {
	// 											this.setState({
	// 												show: true,
	// 												basicTitle: 'No Route data available',
	// 												basicType: "danger",
	// 												loadshow: 'show-n'
	// 											});
	// 										}
							
	// 									})
	// 									.catch(function (error) {
	// 										console.log(error);
	// 									});
	// 							}
	// 						}
	// 					}
	// 				},
	// 				getDetailRowData: function (params) {
	// 					console.log("Step 4 ", transitedelaydata)
	// 					console.log("Step 4 ", params)
	// 					redirectURL.post('/consignments/getShipmentDetails', {
	// 						shipment_id: params.data.shipment_id
	// 					})
	// 						.then(async (response) => {
	// 							console.log(response.data , "srinu")
	// 							params.successCallback(response.data || []);
	// 							//console.log("Step 2 ",response.data)

	// 						});

	// 				}
	// 			}
	// 		});

	// 		//if( params.column.colId == 'transit_delay' || params.column.colId == 'transit_delay_1' ||   params.column.colId == 'no_gps_data' || params.column.colId == 'no_gps_data_1')
	// 		if (params.column.colDef.field == 'shipmentlegs') {
	// 			params.node.setExpanded(!params.node.expanded);
	// 			//console.log("expanded ",params.node.expanded)
	// 			if (params.node.expanded == false) {
	// 				transitedelaydata = []
	// 			}
	// 		}
	// 		else {

	// 			params.node.setExpanded(false);
	// 		}
	// 		//console.log("detailCellRendererParams ", this.state.detailCellRendererParams);

	// 	}

	// }
    const onClickUploadPOD = (rownode) => {
        setSliderShow("slider-translate-30p")
        setOverlay("show-m")
        setRownode([rownode.data])

    }
    const onShowUploadDoc = (rownode) => {
        setSliderShow1("slider-translate-30p")
        setOverlay("show-m")
        setRownode([rownode.data])

    }
    const onClickShowShipmentLegs = async (params) => {
        let query = {
            truck_no: params.data.truck_no,
            shipment_id: params.data.shipment_id
        }
        redirectURL.post('/consignments/getShipmentDetails', query)
            .then(resp => {
                console.log(resp, "respppppp")
                if (resp.data.consignments?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: [
                                // {
                                //     headerName: "",
                                //     field: "legs_map",
                                //     colId: "legs_map",
                                //     width: 40,
                                //     pinned: 'left',
                                //     cellRenderer:function(params){
                                //         var htmloption = '<i className="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
                                //         return htmloption;
                                //     } ,
                                //     filter: false, resizable: true
                
                                // },
                                {
                                    headerName: "Invoice No",
                                    field: "invoice_no",
                                    width: 140,
                                    // cellclassName: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                               
                                // {
                                //     headerName: "Consignment",
                                //     field: "consignment_code",
                                //     width: 140,
                                //     // cellclassName: function (params) {
                                //     // 	if (params.data.transit_delay == 1) {
                                //     // 		return 'lightred';
                                //     // 	}
                                //     // 	else {
                                //     // 		return '';
                                //     // 	}
    
                                //     // }
                                // },
                                
                                {
                                    headerName: "Original ETA",
                                    field: "expected_trip_end",
                                    width: 10,
                                    valueGetter: function (params) {
                                        return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
                                    },
                                    cellclassName: function (params) {
                                        if (params.data.transit_delay == 1) {
                                            return 'lightred';
                                        }
                                        else {
                                            return '';
                                        }
                                    },
    
                                },
                                {
                                    headerName: "Revised ETA",
                                    field: "revised_trip_end",
                                    width: 180,
                                    valueGetter: function (params) {
                                        return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
                                    },
                                    cellclassName: function (params) {
                                        if (params.data.transit_delay == 1) {
                                            return 'lightred';
                                        }
                                        else {
                                            return '';
                                        }
    
                                    }
                                },
                                
                                {
                                    headerName: "Status",
                                    field: "status",
                                    width: 140,
                                    // cellclassName: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // },
                                    
    
                                    valueGetter: function (params) {
                                        //console.log("GPS ", params.data.gps_data_available);
                                        if (params.data.status == 1) {
                                            return "Inside Plant"
                                        }
                                        else if (params.data.status == 2) {
                                            return "In Transit"
                                        }
                                        else if (params.data.status == 3) {
                                            return "Near Destination"
                                        }
                                        else if (params.data.status == 4) {
                                            return "Reached Destination"
                                        }
    
                                        else if (params.data.status == 5) {
                                            return "Left Destination"
                                        }
                                        else if (params.data.status == 6) {
                                            return "Force Closed"
                                        }
                                        else if (params.data.status == 8) {
                                            return "Crossdock"
                                        }else if(params.data.status == 9){
                                            return "Trip Completed"
                                        }
                                        else {
                                            return ""
                                        }
    
                                    }
                                },
                                // {
                                //     headerName: "Zone",
                                //     field: "zone",
                                //     width: 100,
                                //     // cellclassName: function (params) {
                                //     // 	if (params.data.transit_delay == 1) {
                                //     // 		return 'lightred';
                                //     // 	}
                                //     // 	else {
                                //     // 		return '';
                                //     // 	}
    
                                //     // }
                                // },
                                
                                {
                                    headerName: "Dealer Code",
                                    field: "consignee_code",
                                    width: 200,
                                    // cellclassName: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Dealer City",
                                    field: "consignee_city",
                                    width: 120,
                                    resizable: true,
                                    // cellclassName: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
    
                                {
                                    headerName: "Dealer Name",
                                    field: "consignee_name",
                                    width: 150,
                                    resizable: true,
                                    // cellclassName: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Trip Distance (KM)",
                                    field: "distance_in_km",
                                    width: 150,
                                    resizable: true,
                                    valueGetter: params =>{
                                        if(params.data.distance_in_km>0){
                                            return params.data.distance_in_km
                                        }else{
                                            return 0
                                        }
                                    }
                                    ,
                                    // cellclassName: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Distance from Dealer (KM)",
                                    field: "distance_from_dealer_location",
                                    width: 200,
                                    valueGetter: function (params) {
                                        if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
                                            return params.data.distance_from_dealer_location;
                                        }
                                        else {
                                            return "";
                                        }
                                    },
                                    // cellclassName: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Reached Destination At",
                                    field: "first_dealer_reported",
                                    width: 180,
    
    
                                    //cellRenderer:'dateFormater',
                                    valueGetter: function (params) {
                                        if (params.data.status == 4 || params.data.status == 5 || params.data.status == 3) {
                                            return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
                                        }
                                        else {
                                            return "";
                                        }
    
                                    },
                                    resizable: true,
    
                                },
                                {
                                    headerName: "Left Destination At",
                                    field: "left_dealer_marked",
                                    width: 180,
                                    //filter: "agDateColumnFilter",
                                    //cellRenderer:'dateFormater',
                                    valueGetter: function (params) {
                                        if (params.data.status == 5) {
                                            return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
                                        }
                                        else {
                                            return "";
                                        }
    
                                    },
                                    resizable: true,
    
                                },
                                {
                                    headerName: "Transit Time (Days)",
                                    field: "transit_time",
                                    width: 200,
                                    filter: "agSetColumnFilter",
                                    cellRenderer: '', resizable: true
                                },
                                {
                                    headerName: "Upload POD",
                                    field: "upload_pod",
                                    width: 130,
                                    filter: false,
                                    hide:tabName.value !=='completed',
                                    cellRenderer: (params) => {
                                      const handleClick = (e) => {
                                        e.stopPropagation();
                                        onClickUploadPOD(params);  // Assuming this is a function defined in your functional component or passed as a prop
                                      };
                                
                                      return (
                                        <button
                                          onClick={handleClick}
                                          className="btn btn-info"
                                          style={{ padding: "2px 10px", fontSize: "13px", margin: "0" }}
                                          title="Upload POD"
                                          disabled={params.data.epod_uploaded=== 1}
                                        >
                                          Upload POD
                                        </button>
                                      );
                                    },
                                  },
                                
                            ],
                            defaultColDef: {
                                flex: 3,
                            },
                        },
                        getDetailRowData: (params) => {
                            // params.successCallback(resp.data);
                            params.successCallback(resp.data.consignments);
                        },
                    })
                // }
            // })
            // .catch(err => {
            //     console.log(err);
            // })
                }})}
// })};
    // const handleCellClick = (leg_params) => {
    //     setLoadshow('show-m');
    //     setMaptruckno(leg_params.data.truck_no);

    //     let gateouttime = getGateOutTime(leg_params.data);

    //     let end_date = getEndDate(leg_params.data);
    //     let edate = getHyphenYYYYMMDDHHMMSS(end_date);

    //     let sdate = getSecondDate(leg_params.data);

    //     if (!end_date) {
    //         end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
    //         edate = getHyphenYYYYMMDDHHMMSS(end_date);
    //     }

    //     const reqData = {
    //         truck_no: leg_params.data.truck_no,
    //         consignment_code: leg_params.data.invoice_no,
    //         consignee_code: leg_params.data.consignee_code,
    //         gate_out_time: gateouttime,
    //         seconddate: end_date,
    //         screen: "consignment"
    //     };

    //     if (["2", "3", "4"].includes(leg_params.data.status)) reqData.mapMode = 2;

    //     redirectURL.post('/consignments/maproutes', reqData, {
    //         headers: {
    //             'content-type': 'application/json'
    //         }
    //     })
    //         .then(response => handleRouteResponse(response, leg_params.data))
    //         .catch(error => console.error(error));
    // };

    const handleEndDateChange = (date) => {
        if (startDate && date < startDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setEndDate(date)
        }
    };


    const onShowTransitRouteMap = (rownode) => {
        var d = new Date(rownode.leg_start);
        var r = new Date(rownode.leg_end_eta);
        var fintance = rownode.leg_start.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = rownode.leg_end_eta.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';

                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "Vehicle No. : " + rownode.truck_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }
    const onShowEnrouteRouteMap = (rownode) => {
        var fintance = rownode.stoppage_start_time.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        if (rownode.reset_datetime) {
            var eintance = rownode.reset_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        }
        else {
            var eintance = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                let records = response.data
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    if (response.data.route_details.start_time != "" && response.data.route_details.start_time != undefined) {
                        sdate = records.route_details.start_time;
                    }
                    if (response.data.route_details.end_time != "" && response.data.route_details.end_time != undefined) {
                        edate = records.route_details.end_time;
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "Vehicle No. : " + rownode.truck_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const onShowNightDriveRouteMap = (rownode) => {
        var fintance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        consignment_code: rownode.truck_no,
                        defTransitCoords: { "lat": rownode.first_lat, "lng": rownode.first_lng },
                        maptruckno: rownode.truck_no,
                        routeTruck: {
                            "truck_no": rownode.truck_no, "startTime": response.data['route_details']['start_time'],
                            "endTime": response.data['route_details']['end_time']
                        },
                        loadshow: 'show-n',
                        tolls: response.data.tolls
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }
    const onShowRouteMap = (rownode) => {
        var d = new Date(rownode.first_instance);
        var r = new Date(rownode.recent_instance);
        var finstance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var rinstance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: finstance,
            recent_instance: rinstance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/overspeedgpsroutes', params)
            .then((response) => {
                setOpenMap({
                    overly: "show-m",
                    sliderRouteTranslate: "slider-translate-60p",
                    mapinfo: response.data,
                    dealer: rownode.consignee_code,
                    consignment_code: "Vehicle No. : " + rownode.truck_no,
                    maptruckno: rownode.truck_no,
                    routeTruck: { "truck_no": rownode.truck_no, "startTime": finstance, "endTime": rinstance },
                    loadshow: 'show-n',
                    sidebarSubHeader: "Consignment Leg Information",
                    overly: 'show-m',
                    rownode: rownode,
                    leg_no: rownode.leg_no,
                    tolls: response.data.tolls,
                    defTransitCoords: rownode.consignee_coordinates,
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const onShowNoGPSRouteMap = (rownode) => {
        var fintance = rownode.last_packet_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        eintance = eintance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim()
        if ((rownode.hasOwnProperty("exception_closed") && rownode.exception_closed == 1) || rownode.hasOwnProperty("packet_received_on"))
            eintance = rownode.packet_received_on.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "Vehicle No. : " + rownode.truck_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });


    }
    const onClickOpenBulkUploadModal = (e) => {
        setOverlay("show-m")
        setBulkUploadModal({
            overly: "show-m",
            bulkPrioritySlide: "slider-translate-84p"
        })
    }
    const closeBulkUploadModal = () => {
        setFile(null); 
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setModalLoadData([])
    }
    const closeMapModal = () => {
        setOverlay("show-n")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setMapDetails()
    }
    
    const userClickedTab = (e) => {
        const tabname = e.currentTarget.id;
        console.log("Tabname ", tabname);
    
        if (tabname === "active") {
            setTabName(tabOptions[0]);
            navigate("/activeftlconsignments");
            setSearchConsigner([{ label: 'All', value: 'all' }]);
            setSearchTransporters({value: "", label: ""});
            setSearchStates({value: "", label: ""});
            setSearchCity({value:"", label: ""});
            setStartDate('');
            setEndDate('');
            setSeachValue("");
            setLrNo({value:"", label:""});
            setSearchInvoice({value: "", label:""});
            setSearchVehicle({ value:"", label:"" });
        } else if (tabname === "completed") {
            setTabName(tabOptions[1]);
            navigate("/deliveredftlconsignments");
            setSearchConsigner([{ label: 'All', value: 'all' }]);
            setSearchTransporters({value: "", label: ""});
            setSearchStates({value: "", label: ""});
            setSearchCity({value:"", label: ""});
            setStartDate('');
            setEndDate('');
            setSeachValue("");
            setLrNo({value:"", label:""});
            setSearchInvoice({value: "", label:""});
            setSearchVehicle({ value:"", label:"" });
        } else if (tabname === "all") {
            setTabName(tabOptions[2]);
            navigate("/allftlconsignments");
            setSearchConsigner([{ label: 'All', value: 'all' }]);
            setSearchTransporters({value: "", label: ""});
            setSearchStates({value: "", label: ""});
            setSearchCity({value:"", label: ""});
            setStartDate('');
            setEndDate('');
            setSeachValue("");
            setLrNo({value:"", label:""});
            setSearchInvoice({value: "", label:""});
            setSearchVehicle({ value:"", label:"" });
        }
    };
    var lrBasedSegData = []
    var lrNoOptions = []


    const CounterClick = (ecounter) => {
        console.log(ecounter,"counterss");
        
        if (tabName.value == "active") {
            console.log("counterss-sub");
            switch (ecounter) {
                case "consignments":
                    setRowData(activeTrips.all)
                    lrBasedSegData = activeTrips.all.reduce((acc, cur)=>{
                        let curLrno = cur.truck_no;
                        if(!acc[curLrno]){
                            acc[curLrno] = new Set();
                        }
                        acc[curLrno].add(cur.invoice_no);
                        return acc;
                    }, [])
                    console.log(lrBasedSegData,"lrBasedSegData");
                    lrNoOptions = Object.entries(lrBasedSegData).map(([key, set]) => {
                        return Array.from(set).map(item => ({ value: key, label: item }));
                    }).flat();
                    
                    console.log(lrNoOptions, "lrNoOptions");
                    setLrOptions(lrNoOptions);
                    setCounter({label:counterOptions[0].label, value:counterOptions[0].value})
                    break;
                case "transit_delays":
                    setRowData(activeTrips.transit_delays)
                    setCounter({label:counterOptions[1].label, value:counterOptions[1].value})

                    break;
                // case "overspeeding":
                //     setRowData(activeTrips.overspeeding)
                //     break;
                // case "night_driving":
                //     setRowData(activeTrips.night_driving)
                //     break;
                case "stoppages":
                    setRowData(activeTrips.stoppages)
                    setCounter({label:counterOptions[4].label, value:counterOptions[4].value})

                    break;
                case "accidents":
                    setRowData(activeTrips.accidents)
                    break;
                case "trip_deviations":
                    setRowData(activeTrips.trip_deviations)
                    break;
                case "loading_delay":
                    setRowData(activeTrips.loading_delay)
                    break;
                case "unloading_delay":
                    setRowData(activeTrips.unloading_delay)
                    break;
                case "no_gps_data":
                    setRowData(activeTrips.no_gps_data)
                    setCounter({label:counterOptions[2].label, value:counterOptions[2].value})

                    break;
                case "no_gps_data_lifetime":
                    setRowData(activeTrips.no_gps_data_lifetime)
                    setCounter({label:counterOptions[2].label, value:counterOptions[2].value})

                    break;
                default:
                    break;
            }
        }
        else if (tabName.value == "completed") {
            switch (ecounter) {
                case "consignments":
                    setRowData(completedTrips.all)
                    setCounter({label:counterOptions[0].label, value:counterOptions[0].value})

                    break;
                case "transit_delays":                
                    console.log("transit_delays")
                    setRowData(completedTrips.transit_delays)
                    setCounter({label:counterOptions[1].label, value:counterOptions[1].value})

                    break;
                // case "overspeeding":
                //     setRowData(completedTrips.overspeeding)
                //     break;
                // case "night_driving":
                //     setRowData(completedTrips.night_driving)
                //     break;
                case "stoppages":
                    console.log("stoppages")
                    setRowData(completedTrips.stoppages)
                    setCounter({label:counterOptions[4].label, value:counterOptions[4].value})

                    break;
                case "accidents":
                    setRowData(completedTrips.accidents)
                    break;
                case "trip_deviations":
                    console.log("trip_deviations")
                    setRowData(completedTrips.trip_deviations)
                    break;
                case "loading_delay":
                    setRowData(completedTrips.loading_delay)
                    break;
                case "unloading_delay":
                    setRowData(completedTrips.unloading_delay)
                    break;
                case "no_gps_data":
                    setRowData(completedTrips.no_gps_data)
                    break;
                case "no_gps_data_lifetime":
                    setRowData(completedTrips.no_gps_data_lifetime)
                    setCounter({label:counterOptions[2].label, value:counterOptions[2].value})

                    break;
                case "pod_pending":
                    setRowData(completedTrips.pod_pending)
                    setCounter({label:counterOptions[9].label, value:counterOptions[9].value})

                    break;   
                default:
                    break;
            }
        }
        else if (tabName.value == "all") {
            switch (ecounter) {
                case "consignments":
                    setRowData(allTrips.all)
                    setCounter({label:counterOptions[0].label, value:counterOptions[0].value})

                    break;
                case "transit_delays":
                    setRowData(allTrips.transit_delays)
                    setCounter({label:counterOptions[1].label, value:counterOptions[1].value})

                    break;
                // case "overspeeding":
                //     setRowData(allTrips.overspeeding)
                //     break;
                // case "night_driving":
                //     setRowData(allTrips.night_driving)
                //     break;
                case "stoppages":
                    setRowData(allTrips.stoppages)
                    setCounter({label:counterOptions[4].label, value:counterOptions[4].value})

                    break;
                case "accidents":
                    setRowData(allTrips.accidents)
                    break;
                case "trip_deviations":
                    setRowData(allTrips.trip_deviations)
                    break;
                case "loading_delay":
                    setRowData(allTrips.loading_delay)
                    break;
                case "unloading_delay":
                    setRowData(allTrips.unloading_delay)
                    break;
                case "no_gps_data":
                    setRowData(allTrips.no_gps_data)
                    break;
                case "no_gps_data_lifetime":
                    setRowData(allTrips.no_gps_data_lifetime)
                    setCounter({label:counterOptions[2].label, value:counterOptions[2].value})

                    break;
                case "cancelled":
                    setRowData(allTrips.cancelled)
                    setCounter({label:counterOptions[10].label, value:counterOptions[10].value})

                    break;                
                default:
                    break;
            }
        }
    }

    useEffect(() => {
        let key = ''
        redirectURL.post('/details')
            .then((response) => {
                if (response.data.status === 'success') {
                    setKey(response.data.output[0].g_key);
                    key = response.data.output[0].g_key
                    loadScript("https://maps.googleapis.com/maps/api/js?key=" + key + "&libraries=places,drawing&callback=initMap");
                    window.initMap = async () => {
                        var lt = 28.4519751;
                        var ln = 77.0310713;
                        map = new window.google.maps.Map(document.getElementById('map_canvas'), {
                            zoom: 13,
                            center: new window.google.maps.LatLng(lt, ln),
                            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                        });
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });

        redirectURL.post('consignments/getConsigner')
            .then((response) => {
                setConsignersList(response.data.records)
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });

        
        fetchGridLayout(user.email, "consignments")
            .then(res => {
                if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                    setGridColumnState(res.data.data[0].columnState)
                }
            })
            .catch(err => console.log(err))
    }, [])

    useEffect(() => {
        if (gridColumnState.length > 0 && columnApiConsignments.current) {
            columnApiConsignments.current.applyColumnState({
                state: gridColumnState,
                applyOrder: true,
            })
        }
    }, [gridColumnState, columnApiConsignments])


    const changeFileHandler = (e) => {
        setFile(e.target.files[0])


        setLoader(true)
        const formData = new FormData()
        formData.append("fileUpload", e.target.files[0])
        redirectURL.post("/readExcel", formData, {
            headers: {
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        })
            .then((response) => {
                if (response.data.status == "success") {
                    if (response.data.data.length > 0) {
                        setModalLoadData(response.data.data)
                        // setPlantData(response.data.plantData)
                        // setTransporters(response.data.transporters)
                        // setDealers(response.data.dealers)
                        // setPreviousData(response.data.previousData)
                    }
                    else {
                        setModalLoadData([])
                    }
                }
                else {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("danger")
                }
            })
            .catch(error => {
                console.log(error);
            })
        setLoader(false)
    }
    const changeFileHandler1 = async(e) => {
    
        setFile(e.target.files[0])
        var csvdata = await BulkForceFileHandler(e, [
            { name: 'Invoice No', inputName: 'invoice_no', required: true },
            { name: 'Invoice Date', inputName: 'invoice_date', required: true },
            { name: 'Entity', inputName: 'entity', required: true },
            { name: 'Customer Name', inputName: 'customer_name', required: true },
            { name: 'Destination City', inputName: 'destination_city', required: true },
            { name: 'Destination Pincode', inputName: 'destination_pincode', required: true },
            { name: 'AWB No', inputName: 'lr_no', required: true },
            { name: 'Total CBM', inputName: 'total_cbm', required: true },
            { name: 'Total Weight', inputName: 'total_weight', required: true },
            { name: 'Courier Partner', inputName: 'courier_partner', required: true },
            { name: 'Vehicle Type', inputName: 'vehicle_type', required: true },
            { name: 'Vehicle No', inputName: 'truck_no', required: true },
            { name: 'Dispatch Date', inputName: 'dispatch_date', required: true },
            { name: 'Mode (Air/Road/Rail)', inputName: 'shipment_mode', required: true },
            { name: 'E-Way Bill No.', inputName: 'eway_bill_no"', required: true },
            { name: 'Box', inputName: 'no_of_boxes', required: true },
            { name: 'Customer Mail ID', inputName: 'customer_mail_id', required: true },
            { name: 'Mode (FTL/PTL)', inputName: 'mode', required: true },
            { name: 'Invoice Type', inputName: 'invoice_type', required: true },
            { name: 'Origin City', inputName: 'origin_city', required: true },
            { name: 'Fuel type', inputName: 'fuel_type', required: true },
            { name: 'Driver name', inputName: 'driver_name', required: true },
            { name: 'Driver Mobile No', inputName: 'driver_mobile_no', required: true },
            // { name: 'Movement Type', inputName: 'movement_type', required: true },

        ])
        console.log(csvdata, '1234')
        setcsvcontent(csvdata)
        setrowData1(csvdata)
    }
    const onClickShowRoute = (rownode) => {
        setLoader(true)
        setOverlay("show-m")
        setLoadShow("show-m")
        let e = rownode.data
        console.log(e, "mapdata12345")
        var gateouttime = moment.parseZone(e.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
        var edate = '';
        var end_date;
        if (e.status <= 2) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        else if ((e.status == 3 || e.status == 4)) {
            if (e.recent_dealer_reported) {
                end_date = e.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.recent_dealer_reported);
            }
        }
        else if (e.status == 5) {
            if (e.left_dealer_marked) {
                end_date = e.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
            }
        }
        else if (e.status == 6) {
            if (e.force_closure_time) {
                end_date = getHyphenDDMMMYYYYHHMM(e.force_closure_time);
            }
        }
        else {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        if ((e.transit_time) > 0) {
            var seconddate = new Date(new Date(e.gate_out_time).getTime() + ((e.transit_time + 1) * 24 * 60 * 60 * 1000));
        }
        else {
            var seconddate = new Date(new Date(e.gate_out_time).getTime() + 2 * 24 * 60 * 60 * 1000);
        }

        var sdate = seconddate.getFullYear() + "-" + (seconddate.getMonth() + 1) + "-" + seconddate.getDate() + " " + seconddate.getHours() + ":" + seconddate.getMinutes() + ":" + seconddate.getSeconds();

        if (!end_date) {
            // When end date is unavailable then current date is considered as end date.
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
            //console.log("Defining end_date ", end_date);
        }
        var reqData = {
            truck_no: e.truck_no,
            gate_out_time: gateouttime,
            seconddate: end_date,
            screen: "consignment",
            consignment_code: e.consignment_code
        }
        // if (e.consignee_code !== undefined) reqData.consignee_code = e.consignee_code
        if (e.consignment_code !== undefined) reqData.consignment_code = e.consignment_code
        redirectURL.post('/consignments/maproutes', reqData, {
            headers: {
                'content-type': 'application/json'
            }
        })
            .then((response) => {
                var records = response.data;
                // this.setState({
                //     loadshow: 'show-m'
                // });
                try {
                    if (records.coords.length == 0) {
                        setShow(true)
                        setTitle("No GPS data available")
                        setType("danger")
                    }
                    else {
                        if (records != '') {
                            var sdate = e.gate_out_time;
                            if (e.invoice_time) {
                                var sdate = e.invoice_time;
                            }
                            else {
                                if (e.gate_in_time) {
                                    var sdate = e.gate_in_time;
                                }
                                else {
                                    if (e.gate_out_time) {
                                        var sdate = e.gate_out_time;
                                    }
                                }
                            }
                            var edate = '';
                            if (e.status <= 4) {
                                end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                edate = getHyphenDDMMMYYYYHHMM(end_date);
                            }
                            else if (e.status == 5) {
                                if (e.left_dealer_marked) {
                                    edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
                                }
                                else {
                                    end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                    edate = getHyphenDDMMMYYYYHHMM(end_date);
                                }
                            }
                            if (e.deviation_flag == 1) {
                                let consignee_city;
                                consignee_city = e.consignee_city
                                var params = {
                                    "base_route_id": e.base_route_id,
                                    "consigner_code": e.consigner_code,
                                    "consignee_city": consignee_city
                                }
                                redirectURL.post("/consignments/getDeviationRouteBaseRoute",
                                    params).then((resp) => {
                                        var baseRouteCoords = eval(resp.data.route_coords);
                                        setOpenMap({
                                            overly: "show-m",
                                            sliderRouteTranslate: "slider-translate-60p",
                                            mapinfo: records,
                                            dealer: e.consignee_code,
                                            consignment_code: "Consignment : " + e.consignment_code,
                                            maptruckno: e.truck_no,
                                            routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                            loadshow: 'show-n',
                                            sidebarSubHeader: "Consignment Information",
                                            rownode: e,
                                            leg_no: 0,
                                            tolls: records.tolls,
                                            baseRouteCoords: baseRouteCoords
                                        })
                                    })
                                setLoadShow("show-n")
                            }
                            else {
                                var params =
                                {
                                    consignee_code: e.consignee_code,
                                    dept_code: e.dept_code
                                }
                                redirectURL.post('/consignments/geofencedata', params).then((response) => {
                                    var records1 = response.data.records;
                                    let parkingGeodata = []
                                    if (response.data.parkingGeofence[0] !== undefined) parkingGeodata = response.data.parkingGeofence[0]
                                    var geofence_coords = []
                                    if (records1.length) {
                                        geofence_coords = records1[0].geofence_coordinates;
                                    }
                                    setOpenMap({
                                        sliderRouteTranslate: "slider-translate-60p",
                                        showDiv: 'show-m',
                                        mapinfo: records,
                                        dealer: e.consignee_code,
                                        consignment_code: "Consignment : " + e.consignment_code,
                                        maptruckno: e.truck_no,
                                        geofence_coordinates: geofence_coords,
                                        parking_coordinates: parkingGeodata,
                                        routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                        loadshow: 'show-n',
                                        sidebarSubHeader: "Consignment Information",
                                        overly: 'show-m',
                                        rownode: e,
                                        leg_no: 0,
                                        tolls: records.tolls
                                    })
                                    setLoadShow("show-n")
                                })
                            }
                        }
                    }
                }
                catch (e) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                    setLoadShow("show-n")
                    setOverlay("show-n")
                    
                }

            })
            .catch(function (error) {
                console.log(error);
            });
        setLoader(false)
    }
    
    const onShowTransitData = (params) => {
        let query = {
            truck_no: params.data.truck_no,
            consignment_code: params.data.consignment_code,
            consignee_code: params.data.consignee_code
        }
        redirectURL.post('/consignments/transitdelay', query)
            .then(resp => {
                if (resp.data?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: transitdelaycols,
                            defaultColDef: {
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(resp.data);
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onShowStoppagesData = (params) => {
        console.log("stoppages")
        console.log(params,"stopParams");
        
        let query = {
            truck_no: params.data.truck_no,
            consignment_code: params.data.consignment_code
        }

        redirectURL.post('/consignments/enroutes', query)
            .then(resp => {
                if (resp.data?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: stoppagescols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(resp.data);
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onShowOverspeedingData = (params) => {
        let query = {
            truck_no: params.data.truck_no,
            consignment_code: params.data.consignment_code
        }
        redirectURL.post('/consignments/overspeed', query)
            .then(resp => {
                if (resp.data?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: overspeedcols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(resp.data);
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onShowNightDrivingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: nightdrivingcols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                let nightdriving = []
                redirectURL.post('/consignments/nightdriving', {
                    consignment_code: params.data.consignment_code,
                    gate_out_time: params.data.gate_out_time,
                    truck_no: params.data.truck_no
                })
                    .then(async (response) => {
                        //console.log("Step 1 ",response.data)
                        nightdriving = response.data;
                        params.successCallback(nightdriving);
                        //console.log("Step 2 ",response.data)

                    });
            },
        })
    }

    const onShowLoadingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: [

                    {
                        headerName: "Gate In Time",
                        field: "gate_in_time",
                        width: 180,
                        resizable: true,
                        valueGetter: function (params) {
                            if (params.data.gate_in_time) {
                                return params.data.gate_in_time;
                            }
                            else {
                                return "NA"
                            }

                        }
                    },
                    {
                        headerName: "Gate Out Time",
                        field: "gate_out_time",
                        width: 180,
                        resizable: true,
                        valueGetter: function (params) {
                            if (params.data.gate_out_time) {
                                return params.data.gate_out_time;
                            }
                            else {
                                return "NA"
                            }
                        }
                    },
                    {
                        headerName: "Loading Time",
                        field: "loading_time",
                        width: 180,
                    }
                ],
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                if (params.data.gate_in_time != undefined) {
                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.gate_in_time);
                    var gdate1 = new Date(params.data.gate_in_time);
                    var fromDate = g1;
                    var secondsgate1 = moment.parseZone(new Date(params.data.gate_in_time)).format("x")
                }
                else {

                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.inside_fence);
                    var gdate1 = new Date(params.data.inside_fence);
                    var fromDate = g1;
                    var secondsgate1 = moment.parseZone(new Date(params.data.inside_fence)).format("x")

                }
                if (params.data.gate_out_time != undefined) {
                    var g2 = getHyphenDDMMMYYYYHHMM(params.data.gate_out_time);
                    var gdate2 = new Date(params.data.gate_out_time);
                    var toField = getHyphenDDMMMYYYYHHMM(params.data.gate_out_time);
                    var secondsgate2 = moment.parseZone(new Date(params.data.gate_out_time)).format("x")
                }
                else {
                    var c = new Date();
                    var todaydate = moment(new Date(c)).format("x");
                    var g2 = getHyphenDDMMMYYYYHHMM(todaydate);
                    var gdate2 = new Date(todaydate);
                    var toField = getHyphenDDMMMYYYYHHMM(new Date());
                    var secondsgate2 = todaydate

                }

                var total = secondsgate2 - secondsgate1;
                var diffMs = total;
                var diffDays = Math.ceil(diffMs / 86400000); // days
                var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
                var diffMins = parseInt(((diffMs % 86400000) % 3600000) / 60000);
                let loadingTimeDifference = null;
                var dataarr = []
                dataarr.push({
                    "gate_in_time": fromDate,
                    "gate_out_time": toField,
                    "loading_time": secondsToString(diffMs / 1000)
                })
                params.successCallback(dataarr);
            },
        })
    }

    const onShowUnloadingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: unloadingcols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                if (params.data.locked_dealer_reported == undefined) {
                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.first_dealer_reported);
                    var fromField = g1;
                }
                else {
                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.locked_dealer_reported);
                    var fromField = g1;
                }
                if (params.data.left_dealer_marked == undefined) {
                    var c = new Date();
                    var todaydate = c;
                    var g2 = getHyphenDDMMMYYYYHHMM(todaydate);
                    var toField = g2;
                }
                else {
                    var g2 = getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
                    var toField = g2;
                }
                var fstr = fromField.split("-");
                var gdate1 = new Date(fromField);
                var gdate2 = new Date(toField);
                var frmd = gdate1.getTime();
                var tod = gdate2.getTime();
                var total = tod - frmd;
                var diffMs = total;
                var diffDays = Math.floor(diffMs / 86400000); // days
                var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
                var diffMins = parseInt(((diffMs % 86400000) % 3600000) / 60000);
                var dataarr = []
                let loadingTimeDifference = null;
                loadingTimeDifference = secondsToString(diffMs / 1000)
                dataarr.push({
                    "from_date": fromField,
                    "to_date": toField,
                    "unloading_time": loadingTimeDifference
                })
                params.successCallback(dataarr);
            },
        })
    }

    const onShowNoGPSData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: nogpscols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                let nogpsrecords = []
                redirectURL.post('/consignments/nogpsdata', {
                    consignment_code: params.data.consignment_code,
                    truck_no: params.data.truck_no
                })
                    .then(async (response) => {
                        nogpsrecords = response.data;
                        params.successCallback(nogpsrecords);

                    });
            },
        })
    }
    var active_trips = [];
    var completed_trips = [];
    var cancelled_trips=[];
    const fragmentData = (resp) => {
        console.log(resp,"527666666")
        active_trips = resp.filter(e => (e.status == 2 || e.status == 3 || e.status == 1))
        
        completed_trips = resp.filter(e => (e.status == 4 || e.status == 6 || e.status == 7 || e.status == 8))
        cancelled_trips = resp.filter(e => (e.status == 9))
        const groupedRecords = resp.reduce((acc, record)=>{
            if(!acc[record.status]){
                acc[record.status] = []
            }
            acc[record.status].push(record);
            return acc
        }, {})
        console.log(groupedRecords,"groupedRecords")
        let active_transit_delay = []
        // let active_overspeeding = []
        // let active_night_driving = []
        let active_stoppages = []
        let active_accidents = []
        let active_trip_deviations = []
        let active_loadingdelay = []
        let active_unloadingdelay = []
        let active_no_gps_data = []
        let active_no_gps_data_lifetime = []
        let completed_transit_delay = []
        // let completed_overspeeding = []
        // let completed_night_driving = []
        let completed_stoppages = []
        let completed_accidents = []
        let completed_trip_deviations = []
        let completed_loadingdelay = []
        let completed_unloadingdelay = []
        let completed_no_gps_data = []
        let completed_no_gps_data_lifetime = []
        let completed_pod_pending = []
        let transit_delay = []
        // let overspeeding = []
        // let night_driving = []
        let stoppages = []
        let accidents = []
        let trip_deviations = []
        let loading_delay = []
        let unloading_delay = []
        let no_gps_data = []
        let no_gps_data_lifetime = []
        active_trips.map(each => {
            if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                active_transit_delay.push(each)
            }
            // if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
            //     active_overspeeding.push(each)
            // }
            // if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
            //     active_night_driving.push(each)
            // }
            if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                active_stoppages.push(each)
            }
            if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                active_accidents.push(each)
            }
            if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                active_trip_deviations.push(each)
            }
            if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                active_loadingdelay.push(each)
            }
            if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                active_unloadingdelay.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                active_no_gps_data.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                active_no_gps_data_lifetime.push(each)
            }
        })
        completed_trips.map(each => {
            if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                completed_transit_delay.push(each)
            }
            // if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
            //     completed_overspeeding.push(each)
            // }
            // if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
            //     completed_night_driving.push(each)
            // }
            if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                completed_stoppages.push(each)
            }
            if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                completed_accidents.push(each)
            }
            if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                completed_trip_deviations.push(each)
            }
            if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                completed_loadingdelay.push(each)
            }
            if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                completed_unloadingdelay.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                completed_no_gps_data.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                completed_no_gps_data_lifetime.push(each)
            }
            if (!each.hasOwnProperty("epod_uploaded") || each.epod_uploaded ==0){
                completed_pod_pending.push(each)
            }
        })
        resp.map(each => {
            if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                transit_delay.push(each)
            }
            // if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
            //     overspeeding.push(each)
            // }
            // if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
            //     night_driving.push(each)
            // }
            if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                stoppages.push(each)
            }
            if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                accidents.push(each)
            }
            if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                trip_deviations.push(each)
            }
            if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                loading_delay.push(each)
            }
            if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                unloading_delay.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                no_gps_data.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                no_gps_data_lifetime.push(each)
            }
        })

        setCountersActive({
            consignments: active_trips.length,
            transit_delays: active_transit_delay.length,
            // overspeeding: active_overspeeding.length,
            // night_driving: active_night_driving.length,
            stoppages: active_stoppages.length,
            accidents: active_accidents.length,
            trip_deviations: active_trip_deviations.length,
            loading_delay: active_loadingdelay.length,
            unloading_delay: active_unloadingdelay.length,
            no_gps_data: active_no_gps_data.length,
            no_gps_data_lifetime: active_no_gps_data_lifetime.length
        })
        setCountersCompleted({
            consignments: completed_trips.length,
            transit_delays: completed_transit_delay.length,
            // overspeeding: completed_overspeeding.length,
            // night_driving: completed_night_driving.length,
            stoppages: completed_stoppages.length,
            accidents: completed_accidents.length,
            trip_deviations: completed_trip_deviations.length,
            loading_delay: completed_loadingdelay.length,
            unloading_delay: completed_unloadingdelay.length,
            no_gps_data: completed_no_gps_data.length,
            no_gps_data_lifetime: completed_no_gps_data_lifetime.length,
            pod_pending: completed_pod_pending.length
        })
        setCountersAll({
            consignments: resp.length,
            transit_delays: transit_delay.length,
            // overspeeding: overspeeding.length,
            // night_driving: night_driving.length,
            stoppages: stoppages.length,
            accidents: accidents.length,
            trip_deviations: trip_deviations.length,
            loading_delay: loading_delay.length,
            unloading_delay: unloading_delay.length,
            no_gps_data: no_gps_data.length,
            no_gps_data_lifetime: no_gps_data_lifetime.length,
            cancelled: cancelled_trips.length
        })

        setActiveTrips({
            all: active_trips,
            transit_delays: active_transit_delay,
            // overspeeding: active_overspeeding,
            // night_driving: active_night_driving,
            stoppages: active_stoppages,
            accidents: active_accidents,
            trip_deviations: active_trip_deviations,
            loading_delay: active_loadingdelay,
            unloading_delay: active_unloadingdelay,
            no_gps_data: active_no_gps_data,
            no_gps_data_lifetime: active_no_gps_data_lifetime
        })
        setCompletedTrips({
            all: completed_trips,
            transit_delays: completed_transit_delay,
            // overspeeding: completed_overspeeding,
            // night_driving: completed_night_driving,
            stoppages: completed_stoppages,
            accidents: completed_accidents,
            trip_deviations: completed_trip_deviations,
            loading_delay: completed_loadingdelay,
            unloading_delay: completed_unloadingdelay,
            no_gps_data: completed_no_gps_data,
            no_gps_data_lifetime: completed_no_gps_data_lifetime,
            pod_pending: completed_pod_pending
        })
        setAllTrips({
            all: resp,
            transit_delays: transit_delay,
            // overspeeding: overspeeding,
            // night_driving: night_driving,
            stoppages: stoppages,
            accidents: accidents,
            trip_deviations: trip_deviations,
            loading_delay: loading_delay,
            unloading_delay: unloading_delay,
            no_gps_data: no_gps_data,
            no_gps_data_lifetime: no_gps_data_lifetime,
            cancelled: cancelled_trips
        })

        if (window.location.pathname.trim() == "/activeftlconsignments") {
            console.log(active_trips,"activeTripsactiveTrips")
            setTabName(tabOptions[0])
            setRowData(active_trips)
        }
        else if (window.location.pathname == "/deliveredftlconsignments") {
            setTabName(tabOptions[1])
            setRowData(completed_trips)
        }
        else if (window.location.pathname == "/allftlconsignments") {
            setTabName(tabOptions[2])
            setRowData(resp)
        }
    }
    

    const loadConsignmentsData = async () => {
        await redirectURL.post("consignments/getConsignments")
            .then(resp => {    
                if(resp.data.status === "success"){       
                    console.log(resp.data.consignments,"in consignments")
                    fragmentData([...resp.data.consignments])
                }     
            })
            .catch(err => console.log(err))
    }
    const resetFilters = () => {
        setSeachValue("");
        setLrNo({value:"", label:""});
        setSearchInvoice({value: "", label:""});
        setSearchVehicle({ value:"", label:"" });
        loadConsignmentsData()
    }
    const resetFilters1 = () => {
        setSearchConsigner([{ label: 'All', value: 'all' }]);
        setSearchTransporters({value: "", label: ""});
        setSearchStates({value: "", label: ""});
        setSearchCity({value:"", label: ""});
        setStartDate('');
        setEndDate('');
        loadConsignmentsData()
    }
    const getTruckConsignments = async (e) => {
        setLoader(true)
        setOverlay("show-m")
        e.preventDefault();
        let params = {}
        if(searchType && searchType.value === "truck_no"){
            params.truck_no = searchVehicle.value;
        } else if( searchType && searchType.value === "lr_no"){
            params.lr_no = lrNo.value;
        } else {
            params.invoice_no = searchInvoice.value;
        }
        console.log(params,"leftboxSubmitParams");
        await redirectURL.post("consignments/filterConsignments", params)
                .then(resp => {             
                    if(resp.data.consignments.length > 0){
                        console.log(resp.data.consignments,"ftlFirstBoxSubmit") ;  
                        fragmentData(resp.data.consignments)    
                        setSearchVehicle({value:"", label:""})
                        setOverlay("show-n")
                    }else {
                        setShow(true)
                        setTitle("No Records Found")
                        setType("danger")
                    }
                })
                .catch(err => console.log(err))
    }
    const saveConsignments = async (e) => {
        e.preventDefault();
        console.log("saveconsign")
        if (gridApi.current) {
            gridApi.current.stopEditing();
            const gridRowData = [];
            gridApi.current.forEachNode((node) => {
                // if (node.data.plant_code == "" || node.data.fo_number == "" || node.data.order_number == "" || node.data.invoice_date == "" || node.data.transporter_code == "" || node.data.dealer_code == "" || node.data.quantity == "" || node.data.execution_date == "" || node.data.expected_date == "" || node.data.expected_return_to_plant_date == "" || node.data.plant_code == undefined || node.data.fo_number == undefined || node.data.order_number == undefined || node.data.invoice_date == undefined || node.data.transporter_code == undefined || node.data.dealer_code == undefined || node.data.quantity == undefined || node.data.execution_date == undefined || node.data.expected_date == undefined || node.data.expected_return_to_plant_date == undefined) {
                //     setShow(true)
                //     setTitle("Please fill the required fields")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!plantData.some(e => e.consigner_code == node.data.plant_code)) {
                //     setShow(true)
                //     setTitle("Please give a valid Plant Code")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if ((!moment(node.data.invoice_date, "YYYY-MM-DD HH:mm:ss", true).isValid())) {
                //     setShow(true)
                //     setTitle("Please give a valid Invoice Date (YYYY-MM-DD HH:mm:ss)")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!transporters.some(e => e.transporter_code == node.data.transporter_code)) {
                //     setShow(true)
                //     setTitle("Please give a valid Plant Code")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!dealers.some(e => e.consignee_code == node.data.dealer_code)) {
                //     setShow(true)
                //     setTitle("Please give a valid Dealer Code")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (isNaN(node.data.quantity)) {
                //     setShow(true)
                //     setTitle("Please give a valid quantity")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!moment(node.data.execution_date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
                //     setShow(true)
                //     setTitle("Please give a valid Execution Date (YYYY-MM-DD HH:mm:ss)")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!moment(node.data.expected_date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
                //     setShow(true)
                //     setTitle("Please give a valid Expected Date (YYYY-MM-DD HH:mm:ss)")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!moment(node.data.expected_return_to_plant_date, "YYYY-MM-DD HH:mm:ss").isValid()) {
                //     setShow(true)
                //     setTitle("Please give a valid Expected Return to Plant Date (YYYY-MM-DD HH:mm:ss)")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (previousData.some(e => ((e.order_number == node.data.order_number) && (e.fo_number == node.data.fo_number)))) {
                //     setShow(true)
                //     setTitle("Order number and FO number combination already exist for previous consignments")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else
                    gridRowData.push(node.data)
            })
            if (gridRowData.length > 0) {
                await redirectURL.post("/bulkUploadConsignments", { consignments: gridRowData, email: "" })
                    .then(response => {
                        console.log(response, "resppp");
                        
                        if (response.data.status == "Success") {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("success")
                            setLoader(false)
                            setBulkUploadModal(false)
                            setModalLoadData([])
                            setOverlay("show-n")
                            loadConsignmentsData()
                        }
                        else {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("danger")
                            setLoader(false)
                        }
                    })
                    .catch(err => console.log(err))
            }
        }
    }
    const onConfirm = () => {
        setShow(false);
        setLoader(false)
        if (reloadPage.current) {
            window.location.reload()
        }
    };

    const onGetConsignments = async (event) => {
        let query = {}
        if (searchCity.value != '')
            query["consignee_city"] = searchCity.value
        if (startDate == '' || startDate == "NaN-NaN-NaN") {
            var sDate = "";
        }
        else {
            query["sdate"] = startDate
        }
        if (endDate == '' || startDate == "NaN-NaN-NaN") {
            var eDate = "";
        }
        else {
            query["edate"] = endDate
        }
        if (searchConsigner == null || searchConsigner[0]?.value == '' || searchConsigner[0]?.value == 'all') {
        }
        else {
            query["consigner_code"] = searchConsigner.map(e => e.value)
        }
        if (searchState.value != '') {
            query["consignee_state"] = searchState.value
        }
        if (searchTransporters.value != "") {
            query["transporter_name"] = searchTransporters.value
        }
        console.log(query,"querySecondBox")
        await redirectURL.post("consignments/filterConsignments", query)
            .then(resp => {
                if(resp.data.status === "success"){
                    console.log(resp.data.consignments,"ftlSecondBoxSubmit");
                    fragmentData(resp.data.consignments)
                }
            })
            .catch(err => console.log(err))
    }
    const convertDate = (isoDate) => {
        const date = new Date(isoDate);
        
        // Extract components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
      
        // Return the desired format
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };
      
      // Example usage
      const isoDate = "2024-09-25T18:30:00.000Z";
      const formattedDate = convertDate(isoDate);
      console.log(formattedDate); // Output: 2024-09-25 18:30:00
      
    const onClickShowForm=()=> {
        setOverlay("show-m")
        setSliderCreateConsignmentTranslate("slider-translate-30p")
	}
    const changeHandler = (event) => {
        const { name, value } = event.target;
        if (name === "driver_mobile_num" || name === "transit_days") {
            if (value !== "" && value !== undefined) {
                if (value > 0) {
                    setFormData(prevState => ({
                        ...prevState,
                        [name]: value.replace(/\D/g, '')
                    }));
                }
            } else {
                setFormData(prevState => ({
                    ...prevState,
                    [name]: value.replace(/\D/g, '')
                }));
            }
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };
    // const onClickHideAll=()=> {
	// 	var uploadfilebulk = $("#uploadfile").val(null)
	// 	this.setState({
	// 		loadshow: 'show-n',
	// 		overly: 'show-n',
	// 		slideuploadeway: '',
	// 		sliderRouteTranslate: '',
	// 		sliderSegmentTranslate: "",
	// 		tabsliderTranslate: '',
	// 		sliderTranslatesidebar: '',
	// 		sliderForceCloseTranslate: '',
	// 		sliderChangeDriverDetails:'',
	// 		sliderCommentTranslate: "",
	// 		bulkPrioritySlide: "",
	// 		sliderCreateConsignmentTranslate: "",
	// 		sliderRso:"",
	// 		sliderSimConsent:"",
	// 		uploadfilebulk:uploadfilebulk
	// 	});

	// }
    const onGridReady = useCallback((params) => {
        gridApi.current = params.api
    }, []);

    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const onClickHideManualUpload = () => {
        setshowAddForm("");
        setOverlay("show-n");
        setmanualUploadDetails((prev) => ({
          ...prev,
          lr_no: "",
          consignee_name: "",
          invoice_no: "",
          no_of_boxes: "",
          destination_pincode: "",
          destination_city: "",
          eway_bill_no:"",
          customer_mail_id:""
        }));
      };
    const redirectToPtl = () => {
        window.location.href = '/inactiveptlconsignments';
    }
      const onClickHideManualUpload1 = () => {
        setshowAddForm1("");
        setOverlay("show-n");
        setmanualUploadDetails1((prev) => ({
          ...prev,
         dispatch_time:''
        }));
      };
      const onClickHideManualUpload2 = () => {
        setshowAddForm2("");
        setOverlay("show-n");
        setDeliveredDate((prev) => ({
          ...prev,
         delivered_date:''
        }));
      };
      const onClickHideManualUpload3 = () => {
        setshowAddForm3("");
        setOverlay("show-n");
        setmanualUploadDetails1((prev) => ({
          ...prev,
        //  gate_out_time:''
        }));
      };
      const onClickUpdateConsignment = async(e) => {
        e.preventDefault()

       
        var update_params = {
            driver_number: manualUpdateConsignment.driver_number,
            source: manualUpdateConsignment.source,
            truck_no: manualUpdateConsignment.truck_no,
            truck_seal_no: manualUpdateConsignment.truck_seal_no,
            vehicle_type: manualUpdateConsignment.truck_type.value,
            courier_partner:manualUpdateConsignment.courier_partner,
            vehicle_capacity: manualUpdateConsignment.vehicle_capacity,
            consignee_name: manualUpdateConsignment.consignee_name,
            lr_no: manualUpdateConsignment.lr_no,
            invoice_no: manualUpdateConsignment.invoice_no,
            shipment_id:shipmentId
        }
       console.log(update_params, "update_params");
       

        redirectURL.post('/consignments/updateConsignmentdetails', update_params).then((resp) => {
            console.log(resp.data, '176')
            if (resp.data.status == 'Success') {
                setShow(true)
                setTitle("Consignment details has been successfully updated!")
                setType("success")
                setLoadShow('show-n')
                setOverlay('show-n')
                setshowAddForm1('')
                setshowAddForm2('')
                setShouldReload(true);                
            }
            else{
                setShow(true)
                setTitle("Please Upload Valid Details")
                setType("danger")
                setLoadShow('show-n')
                setOverlay('show-n')
            }
        })
        setManualUpdateConsignment((prev) => ({
            ...prev,
            driver_number: "",
            source: "",
            truck_no: "",
            truck_seal_no: "",
            vehicle_type: "",
            courier_partner:"",
            vehicle_capacity: "",
            consignee_name: "",
            lr_no: "",
            invoice_no: "",
          }));
        

    } 
    var filterClassName = "form-group col-xl-12 col-lg-12";

    

    const onsubmitdata1 = async(e) => {
        setGateOutSlide("")


        e.preventDefault()
        console.log(selected_row, "rowww");
        
        var data = {
            dispatch_time: manualUploadDetails1.dispatch_time,
            shipment_id:selected_row.shipment_id,
            truck_no:selected_row.truck_no,
           
        }
        console.log(data, 'data')
        // var rparams = {
        //     data: data,
        //     // row:selected_row
        // }
        // if(manualUploadDetails.transporter.value!='' && manualUploadDetails.transporter.value!=undefined){
            redirectURL.post('/consignments/updatedispatchtime', data).then((resp) => {
                console.log(resp.data, '176')
                if (resp.data.message == 'success') {
                    setShow(true)
                    setTitle("Dispatch time has been successfully updated!")
                    setType("success")
                    setLoadShow('show-n')
                    setOverlay('show-n')
                    setshowAddForm1('')
                    loadConsignmentsData()
                    // props.onRequest('2')
                    // setreloadcheck(true)
                }
                else{
                    setShow(true)
                    setTitle("Please Upload Valid Details")
                    setType("danger")
                    setLoadShow('show-n')
                    setOverlay('show-n')
                }
            })
        // }
        // else{
        //     setshow(true)
        //     setbasicTitle("Please Select Transporter")
        //     setbasicType("danger")
        //     setloadshow('show-n')
        //     setoverly('show-n')
        // }
        setmanualUploadDetails1((prev) => ({
            ...prev,
            dispatch_time: "",
          
          }));

    } 
    const onsubmitdata2 = (e) => {
        setDeliveredSlide("")
        setshowAddForm2('')

        e.preventDefault()
        console.log(selected_row, "rowww");
        const formattedDate = moment(deliveredDate.delivered_date).format("YYYY-MM-DD HH:mm:ss");

        
        var data = {
            date_time: formattedDate,
            shipment_id:selected_row.shipment_id,
            truck_no:selected_row.truck_no,
            // invoice_no:invoiceNumbersDetails.value,
            consignee_pincode:destinationPincodeDetails.value,
            current_location:manualUploadDetails2.current_location,
            delivered_status:manualUploadDetails2.delivered_status.value
        }
        console.log(data, 'data')
        // var rparams = {
        //     data: data,
        //     // row:selected_row
        // }
        // if(manualUploadDetails.transporter.value!='' && manualUploadDetails.transporter.value!=undefined){
            redirectURL.post('/consignments/updatedelivereddate', data).then((resp) => {
                console.log(resp.data, '176')
                if (resp.data.status == 'success') {
                    setShow(true)
                    setTitle("Delivered date has been successfully updated!")
                    setType("success")
                    setLoadShow('show-n')
                    setOverlay('show-n')
                    setshowAddForm2('')
                    loadConsignmentsData()
                    // window.location.reload();
                    // props.onRequest('2')
                    // setreloadcheck(true)
                }
                else{
                    setShow(true)
                    setTitle("Please Upload Valid Details")
                    setType("danger")
                    setLoadShow('show-n')
                    setOverlay('show-n')
                }
            })
        // }
        // else{
        //     setshow(true)
        //     setbasicTitle("Please Select Transporter")
        //     setbasicType("danger")
        //     setloadshow('show-n')
        //     setoverly('show-n')
        // }
        setDestinationPincodeDetails({ label: "", value: "" })


    } 
    var filterclassName = "form-group col-xl-12 col-lg-12";
    console.log(countersActive.transit_delays, "countersAtrs");
    const changeHandleDate = (date) => {
        // const formattedDate = moment(date).format("DD-MM-YYYY HH:mm:ss");
        setmanualUploadDetails1((prev) => ({
        ...prev,
        dispatch_time: date,
        }))
    
};
const changeHandleDate1 = (date) => {
    // const formattedDate = moment(date).format("DD-MM-YYYY HH:mm:ss");
    setDeliveredDate((prev) => ({
    ...prev,
    delivered_date: date,
    }))

};
const onClickEmail = (rowNode) => {
    console.log(rowNode, "rownode_123");
    setData(rowNode.data);
    setSliderEmailOpen(true)
}
const validateEmail = (email) => {
    if (!email || email ===""){
        return true
    }else{
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return re.test(String(email).toLowerCase());
    }
}
const validatePhoneNumber = (phoneNumber) => {
    console.log(phoneNumber, "phoneNumber");
    
    if (!phoneNumber || phoneNumber === ""){
        return true
    }else{
        const re = /^[0-9]{10}$/; // Adjust the regex pattern according to your requirements
        return re.test(String(phoneNumber));
    }
    
}
const handleEncrypt = (word) => {
    const plaintext = word;
    const key = CryptoJS.enc.Hex.parse('0123456789abcdef0123456789abcdef');
    const iv = CryptoJS.enc.Hex.parse('0102030405060708090a0b0c0d0e0f00');
    const encryptedBytes = CryptoJS.AES.encrypt(plaintext, key, {
        iv: iv
    });
    const encryptedBase64 = encryptedBytes.toString();
    const encryptedText = encodeURIComponent(encryptedBase64);
    return encryptedText;
};

const handleDecrypt = (word) => {
    const encryptedText = decodeURIComponent(word);
    const key = CryptoJS.enc.Hex.parse('0123456789abcdef0123456789abcdef');
    const iv = CryptoJS.enc.Hex.parse('0102030405060708090a0b0c0d0e0f00');
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedText, key, {
        iv: iv
    });
    const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedText;
};

var onSubmitEmail = async (props) => {
    console.log(props, "rownode_123");
    console.log(data, "data123");
    onCloseEmail();
    // (!email || !validateEmail(email)) 
    if (email && !validateEmail(email)) {
        setShow(true); 
        setTitle('Please Enter a Valid Email ID');
        setType('warning');
        return; // Stop the function if email validation fails
    }

    if (whatsapp_no && !validatePhoneNumber(whatsapp_no)) {
        setShow(true); 
        setTitle('Please Enter a Valid Phone Number');
        setType('warning');
        return; // Stop the function if phone number validation fails
    }

    setOverlay("show-m");
    await setLoadShow("show-m");

    var current_date = new Date()
    var current_date = new Date(current_date.setHours(current_date.getHours() - 1))


    var gateouttime = moment.parseZone(data.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
    if (!data.gate_out_time) {
        if (data.dispatch_date) {
            gateouttime = moment.parseZone(data.dispatch_date).format('YYYY-MM-DD HH:mm:ss');
        }
    }

    var end_date;
    var edate;
    if (data.status == 6) {
        if (data.force_closure_time) {
            let splitT = data.force_closure_time.split('T');
            let yMD = splitT[0];
            let hMS = splitT[1];
            let hms1 = hMS.split('.');
            let finalHms = hms1[0];
            let final_end_date = yMD + ' ' + finalHms;
            end_date = final_end_date;
            edate = final_end_date;
            console.log("edate", edate);
        }
    } else if (data.status == 2 || data.status == 3) {
        end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        edate = getHyphenDDMMYYYYHHMMSS(end_date);
    } else if (data.status == 5) {
        if (data.left_dealer_marked) {
            end_date = data.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").replace(".855", " ").trim();
            edate = getHyphenDDMMYYYYHHMMSS(data.left_dealer_marked);
        }
    } else if (data.status == 4) {
        if (data.recent_dealer_reported) {
            end_date = data.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
            edate = getHyphenDDMMYYYYHHMMSS(data.recent_dealer_reported);
        }
    } else {
        end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        edate = getHyphenDDMMYYYYHHMMSS(end_date);
        console.log("edate", edate);
    }

    if (!end_date) {
        end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
    }

    const encryptedVal = window.btoa(`${data.truck_no},${gateouttime},${end_date},${data.consignee_code},${data.consignment_code}`);
    var map_link = "http://localhost:3011/map/" + encryptedVal;
    console.log(encryptedVal, "encryptedVal")

    var event_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
    var event_date1 = getHyphenDDMMYYYYHHMMSS(event_date);

    if (email && validateEmail(email)){
        var reqData = {
            truck_no: data.truck_no,
            consignment_code: data.consignment_code,
            consignee_code: data.consignee_code,
            gate_out_time: gateouttime,
            seconddate: end_date,
            screen: "consignment",
            email: email,
            map_param: 1,
            map_link: map_link,
        };
        console.log("reqData", reqData);

        var emailLogs = {
            dept_code: localStorage.getItem("dept_code"),
            useremail: decode(localStorage.getItem("email")),
            role: decode(localStorage.getItem("role")),
            event_date: event_date1,
            screen: "FTL Consignments Email share link ",
            activity: "On sending tracking link to email",
            email_receiver:email
        }
        var combinedParams ={
            reqData,
            emailLogs
        }
    
        redirectURL.post("/consignments/sentemail", combinedParams)
            .then((response) => {
                setLoadShow("show-m");
                setOverlay("show-m");
                try {
                    var records = response.data;
                    console.log("12345_records", records);
                    if (records.status == "Failure") {
                        setShow(true);
                        setTitle("No Route data available");
                        setType("danger");
                        setOverlay("show-n");
                        setLoadShow("show-n");
                    } else {
                        setShow(true);
                        setTitle("Email Sent Successfully");
                        setType("success");
                        setLoadShow("show-n");
                        setOverlay("show-n");
                    }
                } catch (e) {
                    console.log("e ", e);
                    setShow(true);
                    setBasicTitle("No Route data available");
                    setBasicType("danger");
                } finally {
                    setLoadShow("show-n");
                    setOverlay("show-n");
                }
            });
    }
    if (whatsapp_no && validatePhoneNumber(whatsapp_no)){
        console.log("whatsappNo");
        console.log(expired_time, "expired_time123")
        
        
        if (whatsapp_no.length == 10) {
            console.log("whatsappNo1");
            expired_time = current_date.getTime() + (expired_time.value) * 24 * 60 * 60 * 1000
            let expired_date = moment.parseZone(new Date(expired_time)).format('YYYY-MM-DD HH:mm:ss')
            let expiry_date = await handleEncrypt(expired_date)
 
            var from_date = moment.parseZone(new Date(current_date)).format('YYYY-MM-DD HH:mm:ss')
            var from_date = await handleEncrypt(from_date)
 
            console.log(from_date, expiry_date, "3697")
            var link = `https://enmovil.io/truckdetails/sharelink/tptlogin/${data.truck_no}/${(from_date)}/${(expiry_date)}`
            // window.open(`/truckdetails/sharelink/tptlogin/${data.truck_no}/${from_date}/${expiry_date}`)
            // window.open(`/truckdetails/sharelink/tptlogin/${data.truck_no}`)
            // window.open(`https://api.whatsapp.com/send?text=${link}` , '_blank')
 
            window.open(`https://web.whatsapp.com/send?phone=${whatsapp_no}&text=${encodeURIComponent(link)}`)
            
            setShow(true);
            setTitle("Whatsapp Sent Successfully");
            setType("success");
            setLoadShow("show-n");
            setOverlay("show-n")
            setexpired_time({ label: "1 Day", value: 1 })
            setWhatsapp_no("")
        }
        else {
            setShow(true);
            setTitle("WhatApp Number should be 10 Digits");
            setType("danger");
            setLoadShow("show-n");
            setOverlay("show-n");
           
        }
 
    
    }
    
}

var changeEmail = (event) => {
    setEmail(event.target.value)
    console.log(email, "email");
}
var changeWhatsapp = (event) => {
    setWhatsapp_no(event.target.value)
    console.log(whatsapp_no, "whatsapp_no");
}
var changeExpiredTime = (event) => {
    setexpired_time({label:event.target.value, value:event.target.value})
    console.log(expired_time, "expired_time");
}

const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
        event.preventDefault();
        onSubmitEmail();
}
}
const onCloseEmail = () => {
    // Close the slider
    setSliderEmailOpen(false);
    setEmail("")
    setWhatsapp_no("")
  }
  const onCloseDocument = () => {
    // Close the slider
    setSliderDocumentOpen(false);
  }
  const onCloseSliderDiv = () => {
    setSliderShow('');
    setOverlay('show-n');
    document.getElementById("podDoc").value = "";
    document.getElementById("epodDoc").value = "";
    document.getElementById("File").value = "";

    setManualUploadSlider('show-n');
    setBulkMarkDeliverSlide('show-n');
    setShipmentSlider('show-n');
    setShipmentCsvContent([]);
    setShipmentFile('');
    setBulkSliderShow('show-n');
    setSliderScanShow('show-n');
    setSliderSupportShow('show-n');
    setSelectedRowNodes([]);
    setLoadShow('show-n');
    setMultiplePodDocs([]);
    setDeliveredDate1("");
    setPodRemarks("");
    setUpdateRowSlider("");
};
const onCloseSliderDiv1 = () => {
    setSliderShow1('');
    setOverlay('show-n');
    document.getElementById("uploadDoc").value = "";
    document.getElementById("File").value = "";
    setLoadShow('show-n');
    setPodRemarks("");
};
  
const uploadDocument = async(event) => {
    event.preventDefault();
    console.log("pod");
    if (podremarks === "") {
        setShow(true);
        setBasicType("warning");
        setBasicTitle("Please enter remarks");
        setPodRemarks("");
        setEpodDoc([]);
    } 
    else if (rownode.length > 0) { // for single pod upload
        console.log(podremarks,"podremarks")
            const rowid = rownode[0]._id;
            const shipment_id = rownode[0].shipment_id
            const rownodes = rownode;
            const formData = new FormData();
            formData.append("shipmentId", shipment_id);
            formData.append("podDoc", epodDoc);
            formData.append("podremarks", podremarks);
            formData.append("rowid", rowid);
            formData.append("rownodes", JSON.stringify(rownodes));
            formData.append("damage", damage);
            formData.append("short", short);
            formData.append("excess", excess);
            formData.append("pilferage", pilferage);

            console.log(epodDoc,"formm",formData)
            await redirectURL.post("/savepoddocument", formData, {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': "*",
                    'Access-Control-Allow-Methods': 'POST',
                    'Access-Control-Allow-Headers': 'Origin, Content-Type'
                }
            })
                .then((resp) => {
                    if (resp.data.status === 'success') {
                        document.getElementById("formPOD").reset();
                        // setRowNode([]);
                        setShow(true);
                        setEpodDoc([]);
                        // setSlider('show-n');
                        setTitle("Success.");
                        setType("success");
                        setPodRemarks("");
                        setSliderShow("");
                        setOverlay("show-n");
                        // setLoadshow('show-n');
                        window.location.reload();

                    }
                })
                .catch((error) => {
                    console.error("Error uploading document:", error);
                    // Handle error here, e.g., show a message
                });
        }
    
};
const onShowDocs = (e) => {
    setSliderDocumentOpen(true)
    let params = {
        uploaded_document: e.data.uploaded_document
    };
    console.log(params,"uploaded_document")
    
    redirectURL.post("/consignments/downloadUploadDocument", params
    //     , {
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': localStorage.getItem("userid")
    //     }
    // }
).then(res => {
    console.log("response", res);
    setDocuments(res.data); // Assuming res.data contains the URLs
}).catch(error => {
    console.error(error);
});
}

const uploadDocument1 = async(event) => {
    event.preventDefault();
    console.log("pod");
    if (docremarks === "") {
        setShow(true);
        setBasicType("warning");
        setBasicTitle("Please enter remarks");
        setDocRemarks("");
        setUploadDoc([]);
    } 
    else if (rownode.length > 0) { // for single pod upload
        console.log(docremarks,"docremarks")
            const rowid = rownode[0]._id;
            const rownodes = rownode;
            const formData = new FormData();

            uploadDoc.forEach((file) => {
                formData.append("uploadDocs", file);
            });            
            formData.append("docremarks", docremarks);
            formData.append("rowid", rowid);
            formData.append("rownodes", JSON.stringify(rownodes));

            console.log(uploadDoc,"formm",formData)
            await redirectURL.post("/saveuploaddocument", formData, {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': "*",
                    'Access-Control-Allow-Methods': 'POST',
                    'Access-Control-Allow-Headers': 'Origin, Content-Type'
                }
            })
                .then((resp) => {
                    if (resp.data.status === 'success') {
                        document.getElementById("formDocument").reset();
                        // setRowNode([]);
                        setShow(true);
                        setUploadDoc([]);
                        // setSlider('show-n');
                        setTitle("Success.");
                        setType("success");
                        setDocRemarks("");
                        setSliderShow1("");
                        setOverlay("show-n");
                        // setLoadshow('show-n');
                    }
                    // window.location.reload();
                })
                .catch((error) => {
                    console.error("Error uploading document:", error);
                    // Handle error here, e.g., show a message
                });
        }
    
};
const changeFileHandlerDoc = (event) => {
    try {
        const file = event.target.files[0];

        if (file) {
            // If you want to add a size limit, uncomment the following lines
            // if (file.size <= 102400) {
            setCustomerDocument(file);
            // } else {
            //     setShow(true);
            //     setBasicTitle("File Size exceeds 100kb");
            //     setBasicType("info");
            //     setCustomerDocument(null);
            //     document.getElementById("customer_lr_doc").value = "";
            // }
        }
    } catch (e) {
        setCustomerDocument(null);
        document.getElementById("customer_document_2").value = "";
    }
};
const changeFileHandlerForPod = (event) => {
    try {
        const files = event.target.files;

        if (files && files.length > 0) {
            // If you want to add a size limit, uncomment the following lines
            // if (files[0].size <= 102400) {
            console.log(files,"check_files876")
            setCustomerDocument1(files);
            setEpodDoc(files[0]);
            // } else {
            //     setShow(true);
            //     setBasicTitle("File Size exceeds 100kb");
            //     setBasicType("info");
            //     setCustomerDocument1(null);
            //     document.getElementById("customer_lr_doc").value = "";
            // }
        }
    } catch (e) {
        setCustomerDocument1(null);
        const fileInput = document.getElementById("customer_document_1");
        if (fileInput) {
            fileInput.value = "";
        } else {
            console.error("Element with ID 'customer_document_1' not found");
        }

        // document.getElementById("customer_document_1").value = "";
    }
};
const changeFileHandlerForUploadDoc = (event) => {
    try {
        const files = Array.from(event.target.files);
        console.log(files, "files")
        if (files && files.length > 0) {
            
            console.log(files,"check_files876")
            setCustomerDocument2(files);
            setUploadDoc(files);
           
        }
    } catch (e) {
        setCustomerDocument2(null);
        const fileInput = document.getElementById("customer_document_2");
        if (fileInput) {
            fileInput.value = "";
        } else {
            console.error("Element with ID 'customer_document_2' not found");
        }

        // document.getElementById("customer_document_2").value = "";
    }
};
const changeHandler1 = (event) => {
    
    const { name, value } = event.target;
    
    // Assuming you're using setFormData for other fields, make sure to handle podremarks separately
    if (name === "podremarks") {
        setPodRemarks(value);  // Update the podremarks state
    }else if (name ==="docremarks"){
        setDocRemarks(value);
    }
     else {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }
};
const hideSlideBlock = () => {
    // $("#podDoc").val("")
    document.getElementById("epodDoc").value = "";


//    this.setState({
//        delivered_date :""
//    })
    // document.getElementById("formBulkPOD").reset();
    document.getElementById("formPOD").reset();
    // document.getElementById("formBulkSingle").reset();
}
const hideSlideBlockForDocument = () => {
    // $("#podDoc").val("")
    document.getElementById("uploadDoc").value = "";


//    this.setState({
//        delivered_date :""
//    })
    // document.getElementById("formBulkPOD").reset();
    document.getElementById("formDocument").reset();
    // document.getElementById("formBulkSingle").reset();
}
const onClickGateOutUpdate = (e)=>{
    e.preventDefault();
    setGateOutSlide("slide95")
    setOverlay("show-m")
    setGateOutRow(e.data)
}
const hideGateoutSubmit = ()=>{
    console.log("closingconfirmation")
    setGateOutSlide("");
    setOverlay("show-n");

}
const onClickDeliveredSubmit = (e)=>{
    e.preventDefault();
    setDeliveredSlide("slide95")
    setOverlay("show-m")
    setDeliveredRow(e.data)
}
const hideDeliveredSubmit = ()=>{
    console.log("closingconfirmation")
    setDeliveredSlide("");
    setOverlay("show-n");

}
const onSelectDeliveredStatus = (e) => {
    setmanualUploadDetails2(prev => ({
        ...prev,
        delivered_status: { label: e.label, value: e.value }
    }))
}

const handleButtonClick = (e) => {
    e.stopPropagation(); // Prevent the row from being selected
    // setselected_row(e.data);
    // setshowAddForm("slide30");
    setmanualUploadDetails((prev)=>({
        ...prev,
        lr_no:selected_row.lr_no
    }))
    setAddDealer(!addDealer)// Call the provided function
};
const handleDispatchClick = (e) => {
    e.stopPropagation(); // Prevent the row from being selected
    // setselected_row(e.data);
    // setshowAddForm("slide30");
    
    setDispatchTime(!dispatchTime)// Call the provided function
};
const handleCurrentStatusClick = (e) => {
    e.stopPropagation(); // Prevent the row from being selected
    // setselected_row(e.data);
    // setshowAddForm("slide30");
    
    setCurrentStatus(!updateCurrentStatus)// Call the provided function
};

const validateMobileNumber = (number) => {
    const mobileRegex = /^\d{10}$/; // Adjust for your validation needs
    return mobileRegex.test(number);
};

const handleDriverNumberChange = (e) => {
    const { name, value } = e.target;
  
    // Allow only numeric input
    const numericValue = value.replace(/\D/g, '').slice(0, 10);
  
    // Validate the input length and content
    if (numericValue.length < 10) {
      setError1('Mobile number must be 10 digits long');
    } else if (numericValue.length === 10 && /^[6-9]\d{9}$/.test(numericValue)) {
      setError1(''); // Clear error if the number is valid
    } else if (numericValue.length === 10 && !/^[6-9]/.test(numericValue)) {
      setError1('Mobile number must start with a digit between 6 and 9');
    } else if (numericValue.length > 10) {
      setError1('Mobile number cannot exceed 10 digits');
    }
  
    // Update the state with the new value (allow only 10 digits max)
    if (numericValue.length < 10) {
      if (name === 'driver_number_update') {
        setManualUpdateConsignment((prev) => ({ ...prev, driver_number: numericValue }));
      } else if (name === 'driver_mobile_no') {
        setFormData((prev) => ({ ...prev, driver_mobile_no: numericValue }));
      }
    }
  };
  


  
const onClickCancelActiveCourierConsignemnts = (e) => {
    console.log(e,"selectedForCancellation");
    setCloseCancelModal(true)
    setRownode(selected_row)
    setReasonForCancellation("");
    let query = {
        truck_no: selected_row.truck_no,
        shipment_id: selected_row.shipment_id,
    }
    redirectURL.post('/consignments/getShipmentDetails', query)
    .then(resp => {
        console.log(resp, "respppppp")
        if (resp.data.consignments?.length > 0) {
            console.log(resp.data.consignments, "response")
            var records = resp.data.consignments

        const invoiceNos =    records.map(each => ({
                label:each.invoice_no,
                value: each.invoice_no
        }))
        console.log(invoiceNos, "invoiceNos");
        
        setInvoiceNoList(invoiceNos)
        }})
    // lrNoOption
    console.log(lrNoOptions,"331888888888888888888888");
    
    const filteredLrOptions = lrNoOptions.filter(m => {
        console.log(m,"MMMMMMMMMM");
        return m.label !== "undefined" && m.value === e.data.lr_no;
    });
    console.log(filteredLrOptions,"filteredLrOptions")
    setLrOptions(filteredLrOptions)
}
const closeCancelModal = (e) => {
    setCloseCancelModal(false)
    setReasonForCancellation('')
    setRownode([])
}
const cancelFormCloseHandler = (e) => {
    e.preventDefault();
    let invoices_list = invoiceNoList.map((e)=> e.label)
    let reqData = {
        truck_no: rownode.truck_no,
        invoices_selected: invoices_list,
        reasonForCancellation: reasonForCancellation
    }
    console.log(reqData,"reqData");
    redirectURL.post("/consignments/updateFtlConsignmentCancellation", reqData)
        .then(async (response) => {
            if (response.data.status == 'success') {
                setShow(true)
                setTitle(response.data.message)
                setType("success")
                closeCancelModal();
                setRownode([]);
                setLrOptions([]);
                setReasonForCancellation("");
                setshowAddForm3('')
                // window.location.reload();
            }
            else {
                setShow(true)
                setTitle(response.data.message)
                setType("danger")                    
                closeCancelModal();
            }
        })
        .catch(function (e) {
            console.log("Error ", e)
        })
}
const handleEwayDate = (date) => {
    if (!date) return; // Ensure a valid date is passed
    // Save the raw Date object for DatePicker
    setFormData(prev => ({ ...prev, eway_bill_expiry_date: date }));
};
const formatDateForSubmission = (date) => {
    const pad = (num) => num.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

  
    
    return (
        <div>
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                confirmBtnBsStyle={type}
                confirmBtnCssclassName="sweetButton"
                customclassName='sweetWidth'
                type={type}>
            </SweetAlert>
            <Modal
                onHide={closeForceCloseModal}
                dialogclassName="my-modal"
                show={forcecloseModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Force Close</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeForceCloseModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <div>
                        <form onSubmit={formForceCloseHandler}>
                            <div className="col-xl-12 col-lg-12">
                                <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                                <label className="custom-label">
                                    Reason For Force Close
                                </label>
                                <textarea
                                    type="text"
                                    value={reasonForceClose}
                                    onChange={e => setReasonForceClose(e.target.value)}
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end" }}>
                                <button type='submit' className='primary-button'>Submit</button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
            <h1 className='title-heading mb-10p' style={{marginTop:"-18px"}}>FTL Consignments</h1>
                <div className='row col-xl-12 col-lg-12 justify-content-between'>
                <div className="">
                    <button
                        onClick={(e) => { setTabName(tabOptions[0]); setRowData(activeTrips.all) }}
                        className={(tabName.value == "active") ? "btn btn-info" : "btn "}
                        style={{
                            display: (tabName.value == "active") ? "inline-flex" : ""
                        }}
                    >
                        Active
                    </button>
                    <button
                        onClick={(e) => { setTabName(tabOptions[1]); setRowData(completedTrips.all) }}
                        className={(tabName.value == "completed") ? "btn btn-info" : "btn "}
                        style={{
                            display: (tabName.value == "completed") ? "inline-flex" : ""
                        }}
                    >
                        Delivered
                    </button>
                    <button
                        onClick={(e) => { setTabName(tabOptions[2]); setRowData(allTrips.all) }}
                        className={(tabName.value == "all") ? "btn btn-info" : "btn "}
                        style={{
                            display: (tabName.value == "all") ? "inline-flex" : ""
                        }}
                    >
                        All
                    </button>
                    </div>

                    <div className="" style={{marginRight:"-36px"}}>
                    <div>

                        <a className={`${tabActive == "ftl" ? "tab-active" : ""}`}
                            aria-current="page"
                            onClick = {redirectToPtl}
                            style={{
                                color: tabActive === "ftl" ? "#c81e27" : "inherit",
                                borderTop: "none",
                                borderLeft: "none",
                                borderRight: "none",
                                cursor:"pointer",
                                fontSize:"16px",
                                marginRight:"20px",
                                verticalAlign: "middle",
                                lineHeight:"40px"
                            }}
                        >
                            PTL
                            <i style={{paddingLeft:"10px"}} className="fa fa-chevron-right"></i>
                        </a>
                        {tabName.value =="active" &&
                        <>
  
                        <button
                            title="Bulk Upload"
                            onClick={onClickOpenBulkUploadModal}
                            className={"float-right btn btn-warning ml-10p mr-10p"}
                            type="button">
                            <i className="fa fa-upload"></i>&nbsp;&nbsp;&nbsp;Upload Consignments
                        </button>
                        <button type="button" className="btn btn-warning float-right" onClick={onClickShowForm}>Add Consignment</button>

                        </>
                        }
                       
                        {/* <img className='mx-2' onClick={(e) => setFilterToggle(prev => !prev)} src={Filter} style={{ height: "33px", width: "33px", cursor: "pointer", float: "right" }} /> */}
                        {/* <i className="fa-regular fa-filter mx-2" onClick={(e) => setFilterToggle(prev => !prev)} style={{ height: "33px", width: "33px", cursor: "pointer", float: "right" }}></i> */}
                        <i className="icofont icofont-filter filter-styling" onClick={(e) => setFilterToggle(prev => !prev)}></i>    
                        </div>
                
                    </div>
                    </div>
                   
                
            <div className={filterToggle ? "filter-in" : "filter-out"}>
                {
                    filterToggle &&
                    <div className={filterToggle ? "row" : "row"}>
                        <div className={"col-xl-4 col-lg-4 "}>
                            <div className="card" style={filterCardStyle1}>
                                <div className="row card-body" style={{ padding: "10px 30px" }}>
                                    <form className="row" onSubmit={getTruckConsignments}>
                                        <div className={filterClassName}>
                                            <label>Select Type  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={searchType}
                                                onChange={e => setSearchType(e)}
                                                style={{ borderRadius: "0px" }}
                                                options={[
                                                    { label: "Vehicle", value: "truck_no" },
                                                    { label: "LR No", value: "lr_no" },
                                                    { label: "Invoice No", value: "invoice_no" },
                                                ]} required />
                                        </div>
                                        {searchType.value === "truck_no" ?                                             
                                            <div className={filterClassName}>
                                                {/* <label className="reason">Vehicle No</label>
                                                <input type="text" name="reason" autoComplete="off" class="form-control" id="inputTruckConsignment" value={searchValue} onChange={e => setSeachValue(e.target.value)} /> */}

                                                <label>Vehicle No</label>
                                                <Select
                                                    className="border-radius-0"
                                                    isMulti={false}
                                                    id="selectedVehicle"
                                                    style={{ borderRadius: "0px" }}
                                                    value={searchVehicle}
                                                    onChange={e => setSearchVehicle(e)}
                                                    options={filteredvehicles}
                                                />
                                            </div>
                                        : ""}
                                        {searchType.value === "invoice_no" ?
                                            <div className={filterClassName}>
                                                <label>Invoice No</label>
                                                <Select
                                                    className="border-radius-0"
                                                    isMulti={false}
                                                    id="selectedInvoice"
                                                    style={{ borderRadius: "0px" }}
                                                    value={searchInvoice}
                                                    onChange={e => setSearchInvoice(e)}
                                                    options={filteredInvoices}
                                                />
                                            </div>                                        
                                        : ""}
                                        {searchType.value === "lr_no" ?                                        
                                            <div className={filterClassName}>
                                                <label>LR No</label>
                                                <Select
                                                    className="border-radius-0"
                                                    isMulti={false}
                                                    id="selectedLr"
                                                    style={{ borderRadius: "0px" }}
                                                    value={lrNo}
                                                    onChange={e => setLrNo(e)}
                                                    options={filteredLrnos}
                                                />
                                            </div>
                                        : ""}
                                        <div className='col-xl-12 col-lg-12'></div>
                                        <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left" }}>
                                            <button type="submit" className="btn btn-success">Submit</button>
                                        </div>
                                        <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left" }}>
                                            <button type="button" onClick={resetFilters} className="btn btn-warning">Reset</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className={"col-xl-8 col-lg-8"}>
                            <div className="card" style={filterCardStyle1}>
                                <div className="row card-body" style={filterCardStyle2}>
                                    <div className="row col-xl-12 col-lg-12" style={mnFilterClass}>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Select Consigner </label>
                                            <Select placeholder={"All"} closeMenuOnSelect={false}
                                                value={searchConsigner}
                                                isMulti={true}
                                                className="border-radius-0"
                                                onChange={e => setSearchConsigner(e)}
                                                style={{ borderRadius: "0px" }}
                                                options={consignersList}
                                                required />

                                        </div>
                                        <div className="col-xl-4 col-lg-4 form-group">
                                            <div className="col-xl-12 col-lg-12"><label>From Date</label></div>
                                            <div className="col-xl-12 col-lg-12">
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={handleStartDateChange}
                                                    name="startDate"
                                                    className="datepicker-custom"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 form-group">
                                            <div className="col-xl-12 col-lg-12"> <label>To Date</label></div>
                                            <div className="col-xl-12 col-lg-12">
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={handleEndDateChange}
                                                    name="endDate"
                                                    className="datepicker-custom"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row col-xl-12 col-lg-12" style={{ marginLeft: "0px", padding: "0px" }}>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Consignee City</label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedCity"
                                                style={{ borderRadius: "0px" }}
                                                value={searchCity}
                                                onChange={e => setSearchCity(e)}
                                                options={filterCities}
                                            />
                                        </div>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Consignee State</label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedState"
                                                style={{ borderRadius: "0px" }}
                                                value={searchState}
                                                onChange={e => setSearchStates(e)}
                                                options={filterStates}
                                            />
                                        </div>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Transporter  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedTransporter"
                                                style={{ borderRadius: "0px" }}
                                                value={searchTransporters}
                                                onChange={(e) => setSearchTransporters(e)}
                                                options={filterTransporters}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left", maxWidth:"77px" }}>
                                        <button type="button" className="btn btn-success" onClick={onGetConsignments}>Submit</button>
                                    </div>
                                    <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left" }}>
                                        <button type="button" onClick={resetFilters1} className="btn btn-warning">Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>                
            <>
            {/* <div className="row" >
                <div className="col-xl-12 col-lg-12">
                    <div className="card">
                        <div className="card-header d-flex">                    
                            <div
                            onClick={userClickedTab} id="active"
                            className={`mr-10p p-10p dashboard1 ${tabName.value === "active" ? "activetab" : "inactivetab"}`}
                            >
                            <h5>Active</h5>
                            </div>
                            <div
                            onClick={userClickedTab} id="completed"
                            className={`mr-10p p-10p dashboard1 ${tabName.value === "completed" ? "activetab" : "inactivetab"}`}
                            >
                            <h5>Delivered</h5>
                            </div>
                            <div
                            onClick={userClickedTab} id="all"
                            className={`p-10p dashboard1 ${tabName.value === "all" ? "activetab" : "inactivetab"}`}
                            >
                            <h5>All</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="row" style={{ marginBottom: "1%" }}>
                {/* <div className="col-xl-12 col-lg-12">
                    <button
                        onClick={(e) => { setTabName(tabOptions[0]); setRowData(activeTrips.all) }}
                        className={(tabName.value == "active") ? "btn btn-info" : "btn "}
                        style={{
                            display: (tabName.value == "active") ? "inline-flex" : ""
                        }}
                    >
                        Active
                    </button>
                    <button
                        onClick={(e) => { setTabName(tabOptions[1]); setRowData(completedTrips.all) }}
                        className={(tabName.value == "completed") ? "btn btn-info" : "btn "}
                        style={{
                            display: (tabName.value == "completed") ? "inline-flex" : ""
                        }}
                    >
                        Delivered
                    </button>
                    <button
                        onClick={(e) => { setTabName(tabOptions[2]); setRowData(allTrips.all) }}
                        className={(tabName.value == "all") ? "btn btn-info" : "btn "}
                        style={{
                            display: (tabName.value == "all") ? "inline-flex" : ""
                        }}
                    >
                        All
                    </button>
                    </div> */}
             
            <div className={"slide-r " + (bulkUploadModal.bulkPrioritySlide)} style={{ overflow: "auto" }}>
                <h3 className="subH">Bulk Upload Consignments
                    <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeBulkUploadModal} >X</span>
                </h3>

                <div className="slide-r-body" style={{ position: "relative" }}>
                    <div className="container-fluid">
                        <form method="POST" id="upform" className="theme-form">
                            <div className="col-xl-6 col-lg-6 form-group">
                                <label className="">Upload File</label>
                                <input type="file" name="uploadFile" id="bulkUploadCritical" onChange={changeFileHandler} className="form-control" value={file ? undefined : ""} required />
                            </div>
                        </form>
                        <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <div className="form-group">
                                <a className="btn btn-primary" href={require('../../assets/files/FTL Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a>
                            </div>
                            <div className='form-group' style={{ marginRight: "8px" }}>
                                <div><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                {/* <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div> */}
                            </div>
                        </div>
                        <div className="ag-theme-balham mt-2" style={{ height: '58vh', width: '100%' }}>
                            <AgGridReact
                                columnDefs={columnDef}
                                rowData={modalloadData}
                                // rowData={rowData1}
                                defaultColDef={defaultColDef}
                                onGridReady={onGridReady}
                                pagination={true}
                                paginationPageSize={50}
                                enableRangeSelection={true}
                                enableCellContextMenu={true}
                                stopEditingWhenGridLosesFocus={true}
                                sideBar={{
                                    toolPanels: [
                                        {
                                            id: "columns",
                                            labelDefault: "Columns",
                                            labelKey: "columns",
                                            iconKey: "columns",
                                            toolPanel: "agColumnsToolPanel",
                                            toolPanelParams: {
                                                suppressPivotMode: true,
                                                suppressRowGroups: true,
                                                suppressValues: true,
                                            }
                                        },
                                        {
                                            id: "filters",
                                            labelDefault: "Filters",
                                            labelKey: "filters",
                                            iconKey: "filter",
                                            toolPanel: "agFiltersToolPanel"
                                        }
                                    ]
                                }}
                                statusBar={{
                                    statusPanels: [
                                        {
                                            statusPanel: "agTotalAndFilteredRowCountComponent",
                                            align: "left"
                                        },
                                        {
                                            statusPanel: "agTotalRowCountComponent",
                                            align: "center"
                                        },
                                        { statusPanel: "agFilteredRowCountComponent" },
                                        { statusPanel: "agSelectedRowCountComponent" },
                                        { statusPanel: "agAggregationComponent" }
                                    ]
                                }} />
                        </div>
                        <br />
                        <div className="form-group">
                            <button type="submit" className="btn btn-success" onClick={saveConsignments}>Submit</button>
                            <button type="button" onClick={closeBulkUploadModal} className="btn btn-default">Cancel</button>
                        </div>
                        <br />
                        <br />
                    </div>
                </div>
            </div>  
            </div>
          
                {
                    <div className={""}>
                        <MainCounters setCounter={CounterClick} data={tabName.value == "active" ? countersActive : (tabName.value == "completed" ? countersCompleted : countersAll)} tabName={tabName} componentType="ftl"/>
                    </div>
                }
            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <div className="card">
                        <div className="card-header">
                        <div>
                           
                            <div className="row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <h5>
                                <i className="icofont icofont-vehicle-delivery-van cus-i mt-100p ml-30p"></i> <span>{`${tabName?.label} - ${counter?.label}`}</span>
                            </h5>
                                <div className="mr-10p mb-10p">
                                
                                    {/* <span className="float-right" style={{ fontSize: "13px", fontWeight: "100" }}>
                                        <i className="icofont icofont-clock-time" style={{ color: "#ff0000", fontSize: "22px	" }}></i> - Transit Delays
                                        |&nbsp;<i className="icofont icofont-social-google-map txt-danger" style={{ fontSize: "22px" }}></i> - GPS Not Available
                                        {/* |&nbsp; */}
                                        {/* <i className="icofont icofont-social-google-map txt-secondary" style={{ fontSize: "22px" }}></i> - GPS Data Not Adequate */}
                                        {/* |&nbsp; */}
                                        {/* <span>
                                            <i className="fa fa-tachometer darkblue" style={{ fontSize: "22px" }}></i> - Overspeeding
                                        </span>|
                                        <span>
                                            <span>&nbsp;<i className="icofont icofont-full-night txt-primary" style={{ fontSize: "22px" }}></i> - Night Driving
                                            </span>
                                            <span>|&nbsp;<i className="icofont icofont-truck-alt darkorange" style={{ fontSize: "22px" }}></i> - Loading Delay
                                            </span>
                                            {
                                                tabName?.value == "completed" || tabName?.value == "all" ?
                                                    <span>|&nbsp;<i className="icofont icofont-vehicle-delivery-van mildgreen" style={{ fontSize: "22px" }}></i> - Unloading Delay
                                                    </span> :
                                                    <></>
                                            }
                                        </span> */}
                                        {/* |&nbsp;<i className="icofont icofont-pause maroon" style={{ fontSize: "22px" }}></i> - Stoppages
                                        <span> */}
                                            {/* |&nbsp; */}
                                            {/* <i className="icofont icofont-barricade txt-danger" style={{ fontSize: "22px" }}></i> - Probable Accident */}
                                        {/* </span> */}
                                    {/* </span>  */}
                                    <span className="float-right" style={{fontSize: "15px", fontWeight: 400, }}>
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-map-pins" style={{fontSize: "20px"}}></i>&nbsp;&nbsp;View Route </button>
                                        {/* <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-edit" style={{color:"#1cc88a",fontSize: "20px"}}></i>&nbsp;&nbsp;Dispatch Time Update </button>
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-edit" style={{color:"#28bad4",fontSize: "20px"}}></i>&nbsp;&nbsp;Status Update </button> */}
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-site-map" style={{fontSize: "20px"}}></i>&nbsp;&nbsp;Consignments </button>
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="fa fa-th" style={{fontSize: "15px", color:"#FF5370"}}></i>&nbsp;&nbsp;KPI's Triggered</button>
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-clock-time" style={{color: "rgb(255, 0, 0)", fontSize: "20px"}}></i>&nbsp;&nbsp;Transit Delays </button>
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-social-google-map txt-danger" style={{fontSize: "20px"}}></i>&nbsp;&nbsp;GPS Not Available </button>
                                        {/* <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-social-google-map txt-secondary" style="font-size: 20px;"></i>&nbsp;GPS Data Not Adequate </button>
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="fa fa-tachometer darkblue" style="font-size: 20px;"></i>&nbsp;&nbsp;Overspeeding </button>
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-full-night txt-primary" style="font-size: 20px;"></i>&nbsp;&nbsp;Night Driving </button>
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-truck-alt darkorange" style="font-size: 20px;"></i>&nbsp;&nbsp;Loading Delay </button>
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-vehicle-delivery-van mildgreen" style="font-size: 20px;"></i>&nbsp;&nbsp;Unloading Delay </button> */}
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-pause maroon" style={{fontSize: "20px"}}></i>&nbsp;&nbsp;Stoppages </button>
                                        {/* <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-upload-alt " style={{fontSize: "20px", color:"#387ff2"}}></i>&nbsp;&nbsp;Upload Document </button>
                                        <button type="button" className="btn btn-default mybtn">
                                        <i className="icofont icofont-document-folder " style={{fontSize: "20px", color:"#00C292"}}></i>&nbsp;&nbsp;View Documents </button> */}
                                    </span>
                                </div>

                                <div className={"col-xl-12 mb-10p "}>
                                    <span className="layoutbtns">
                                        <button className="float-right custom-btn white btn-danger"
                                            // onClick={this.onClickSaveGridState}
                                            onClick={saveGrid} style={{fontSize:"12px"}}
                                        >
                                            <i className="icofont icofont-save"></i> Save Grid Layout
                                        </button>
                                        <button className="float-right custom-btn white btn-info" style={{ marginRight: "10px",fontSize:"12px" }}
                                            // onClick={this.resetState}
                                            onClick={resetGrid}
                                        >
                                            <i className="icofont icofont-refresh"></i> Reset Default Layout
                                        </button>
                                        {/* <div className="float-right">
                                            <button
                                                title="Bulk Upload"                                                onClick={onClickOpenBulkUploadModal}
                                                className={"float-right custom-btn white btn-danger mr-2"}
                                                type="button">
                                                <i className="fa fa-upload"></i>&nbsp;&nbsp;&nbsp;Upload Consignments
                                            </button>
                                        </div> */}
                                    </span>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="card-body pt-10px" >
                           
                            <div className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                <AgGridReact
                                    columnDefs={columnwithDefs}
                                    rowData={rowData}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    paginationPageSize={50}
                                    onGridReady={onGridReadyConsignments}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    masterDetail={true}
                                    detailCellRendererParams={detailCellRendererParams}
                                    // frameworkComponents ={{AddDealer:AddDealerConsignments}}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }}
                                    // context={{
                                        
                                    //     onClickActive
                                    //   }}
                                    />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {openMap.sliderRouteTranslate != '' ?
                <div className={"slide-r " + (openMap.sliderRouteTranslate)} style={{ overflow: "auto" }}>
                    <div className="slide-r-title">
                        <h4>
                            {(openMap.consignment_code)}
                            <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeMapModal} >X</span>
                        </h4>
                    </div>
                    <div className="slide-r-body" style={{ position: "relative" }}>
                        <div className="row col-xl-12 col-lg-12 ml-0p n-p-0">
                            <DrawMap
                                rownode={openMap.rownode}
                                mapFor={"consignment"}
                                tolls={openMap.tolls}
                                googleroutes={openMap.googelRoutes}
                                truckno={openMap.maptruckno}
                                dealer={openMap.dealer}
                                mapinfo={openMap.mapinfo}
                                deptcode={openMap.deptcode}
                                defTransitCoords={openMap.defTransitCoords}
                                baseRouteCoords={openMap.baseRouteCoords}
                                geofence_coordinates={openMap.geofence_coordinates}
                                parking_coordinates={openMap.parking_coordinates}
                            />
                            <div className="col-xl-12 col-lg-12 n-p-0">
                                <div className="crm-numbers pb-0">
                                    <h3 className="subH">{openMap.sidebarSubHeader}</h3>
                                    <div className="col-xl-12 col-lg-12 row">
                                        <div className="col route-block">
                                            <label className="sidebar-label">Truck No</label>
                                            <div>{openMap.routeTruck.truck_no}</div>
                                        </div>
                                        <div className="col route-block">
                                            <label className="sidebar-label">Start Time</label>
                                            <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.start_time) : "-"}</div>
                                        </div>
                                        <div className="col route-block">
                                            <label className="sidebar-label">End Time</label>
                                            <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.end_time) : "-"}</div>
                                        </div>

                                        <div className="col route-block">
                                            <label className="sidebar-label">GPS Distance</label>
                                            <div>{(!isEmpty(openMap.mapinfo.route_details)) ? Math.round(openMap.mapinfo.route_details.distance_without_google / 1000) : "0"} Kms</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                : ""
            }
            <div className={"slide-r " + (bulkUploadModal.bulkPrioritySlide)} style={{ overflow: "auto" }}>
                <h3 className="subH">Bulk Upload Consignments
                    <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeBulkUploadModal} >X</span>
                </h3>

                <div className="slide-r-body" style={{ position: "relative" }}>

                    <div className="container-fluid">
                        <form method="POST" id="upform" className="theme-form">
                            <div className="col-xl-6 col-lg-6 form-group">
                                <label className="">Upload File</label>
                                <input type="file" name="uploadFile" id="bulkUploadCritical" onChange={changeFileHandler} className="form-control" value={file ? undefined : ""} required />
                            </div>
                        </form>
                        <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <div className="form-group">
                                <a className="btn btn-primary" href={require('../../assets/files/FTL Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a>
                            </div>
                            <div className='form-group' style={{ marginRight: "8px" }}>
                                <div><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                {/* <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div> */}
                            </div>
                        </div>
                        <div className="ag-theme-balham mt-2" style={{ height: '58vh', width: '100%' }}>
                            <AgGridReact
                                columnDefs={columnDef}
                                rowData={modalloadData}
                                // rowData={rowData1}
                                defaultColDef={defaultColDef}
                                onGridReady={onGridReady}
                                pagination={true}
                                paginationPageSize={50}
                                enableRangeSelection={true}
                                enableCellContextMenu={true}
                                stopEditingWhenGridLosesFocus={true}
                                sideBar={{
                                    toolPanels: [
                                        {
                                            id: "columns",
                                            labelDefault: "Columns",
                                            labelKey: "columns",
                                            iconKey: "columns",
                                            toolPanel: "agColumnsToolPanel",
                                            toolPanelParams: {
                                                suppressPivotMode: true,
                                                suppressRowGroups: true,
                                                suppressValues: true,
                                            }
                                        },
                                        {
                                            id: "filters",
                                            labelDefault: "Filters",
                                            labelKey: "filters",
                                            iconKey: "filter",
                                            toolPanel: "agFiltersToolPanel"
                                        }
                                    ]
                                }}
                                statusBar={{
                                    statusPanels: [
                                        {
                                            statusPanel: "agTotalAndFilteredRowCountComponent",
                                            align: "left"
                                        },
                                        {
                                            statusPanel: "agTotalRowCountComponent",
                                            align: "center"
                                        },
                                        { statusPanel: "agFilteredRowCountComponent" },
                                        { statusPanel: "agSelectedRowCountComponent" },
                                        { statusPanel: "agAggregationComponent" }
                                    ]
                                }} />
                        </div>
                        <br />
                        <div className="form-group">
                            <button type="submit" className="btn btn-success" onClick={saveConsignments}>Submit</button>
                            <button type="button" onClick={closeBulkUploadModal} className="btn btn-default">Cancel</button>
                        </div>
                        <br />
                        <br />
                    </div>
                </div>
            </div>
            <div className={"slide-r " + (sliderCreateConsignmentTranslate)} style={{ overflow: "auto" }}>
					<div className="slide-r-title">
						<h4>
							Add Consignment
							<span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={onClickHideAll1} >X</span>

						</h4>
					</div>
                    <div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12"></div>

							<form method="POST" className="theme-form col-xl-12 col-lg-12" onSubmit={saveConsignmentData}>
                            <div className="slide-body">
                                <div className='row'>
                            <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Driver Mobile No.<span style={{color:'red'}}>*</span> </label>
									<input
										// placeholder={"Enter Truck No"}
										type="text"
										className="form-control ml-3"
                                        onChange ={(e)=>  {
                                            const numericValue = e.target.value.replace(/\D/g, '').slice(0,10);
                                            setFormData((prev) => ({ ...prev, driver_mobile_no: numericValue }))}}
										onBlur={handleDriverNumberChange}
										value={formData.driver_mobile_no}
										name="driver_mobile_no"
										autoComplete='off'
									/>
                                    {error1 && <span style={{ color: 'red', fontSize:"10px", margin:"10px 0px 0px 20px" }}>{error1}</span>}                    

								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Source<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={(e)=> setFormData(prev =>({...prev, source:e.target.value}))}
										value={formData.source}
										name="source"
										autoComplete='off'
									/>
								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Truck No<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={(e)=> setFormData(prev =>({...prev, truck_no:e.target.value}))}
										value={formData.truck_no}
										name="truck_no"
										autoComplete='off'
									/>
								</div>
                                <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Truck Seal No<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={(e)=> setFormData(prev =>({...prev, truck_seal_no:e.target.value}))}
										value={formData.truck_seal_no}
										name="truck_seal_no"
										autoComplete='off'
									/>
								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Entity  </label>
									<input
										type="text"
										className="form-control ml-3"
                                        onChange={(e)=>setFormData(prev=>({...prev, entity: e.target.value}))}
										value={formData.entity}
										id="entity"
										name="entity"
										autoComplete='off'
									/>
								</div>
								{/* <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Vehicle Type<span style={{color:'red'}}>*</span>  </label>
									
                                    <Select
                                                    className="border-radius-0"
                                                    isMulti={false}
                                                    id="truck_type"
                                                    style={{ borderRadius: "0px" }}
                                                    value={formData.vehicle_type}
                                                    onChange={e => setFormData.vehicle_type(e)}
                                                    options={vehicleTypeList}
                                                />
								</div> */}
                                <div className="form-group col-xl-12 col-lg-12">
                                <label className="mb-5p">
                      Vehicle Type<span style={{color:'red'}}>*</span>
                    </label>
                    <Select
                      closeMenuOnSelect={true}
                      value={formData.vehicle_type}
                      // multi={true}
                      // className={"border-radius-0"}
                      
                        onChange={(e)=>
                        setFormData((prev)=>({
                            ...prev, 
                            vehicle_type:{label:e.label, value: e.value}
                        }))
                    }
                     className='custom-field-width'
                      style={{ borderRadius: "0px", maxWidth:"415px" }}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          fontSize: "0.8rem",
                          color: "#6e707e",
                        }),
                        singleValue: (provided, state) => ({
                          ...provided,
                          fontSize: "0.9rem",
                        }),
                      }}
                      options={vehicleTypeList}
                    />
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                                <label className="mb-5p">
                      Courier Partner<span style={{color:'red'}}>*</span>
                    </label>
                    <Select
                      closeMenuOnSelect={true}
                      value={formData.courier_partner}
                      // multi={true}
                      // className={"border-radius-0"}
                      
                        onChange={(e)=>
                        setFormData((prev)=>({
                            ...prev, 
                            courier_partner:{label:e.label, value: e.value}
                        }))
                    }
                      className='custom-field-width'
                      style={{ borderRadius: "0px" }}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          fontSize: "0.8rem",
                          color: "#6e707e",
                        }),
                        singleValue: (provided, state) => ({
                          ...provided,
                          fontSize: "0.9rem",
                        }),
                      }}
                      options={courierPartnerList}
                    />
                  </div>
								
								

								
                                <div className="form-group col-xl-12 col-lg-12">
                                <label className="mb-5p">
                                E-Way Bill Expiry date
                                </label>
                            <div id="datepicker1">
                                    <DatePicker
                                selected={formData.eway_bill_expiry_date}
                                onChange={handleEwayDate}
                                // onChange={(date)=>setFormData(prev=> ({...prev, eway_bill_expiry_date: date}))}
                                name="eway_bill_expiry_date"
                                className="datepicker-custom-ptl form-control"
                                showTimeSelect
                                timeFormat="HH:mm:ss"
                                timeIntervals={15} // Adjust this if you want different time intervals
                                timeCaption="Time"
                                dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                                // placeholderText="Date" // Equivalent to placeholder in the original
                                id="eway_bill_expiry_date"
                                autoComplete='off'

                                // style={{width:"100%"}}
                                // required
                                />
                            </div>
                            
                            </div>
                            <div className="form-group col-xl-12 col-lg-12">
                                <label className="mb-5p">
                                Vehicle capacity<span style={{color:'red'}}>*</span>
                    </label>
                    <Select
                      closeMenuOnSelect={true}
                      value={formData.vehicle_capacity}
                      // multi={true}
                      // className={"border-radius-0"}
                      className='custom-field-width'
                        onChange={(e)=>
                        setFormData((prev)=>({
                            ...prev, 
                            vehicle_capacity:{label:e.label, value: e.value}
                        }))
                    }

                      style={{ borderRadius: "0px" }}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          fontSize: "0.8rem",
                          color: "#6e707e",
                        }),
                        singleValue: (provided, state) => ({
                          ...provided,
                          fontSize: "0.9rem",
                        }),
                      }}
                      options={vehicleCapacityList}
                    />
                  </div>

								{/* <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Vehicle capacity<span style={{color:'red'}}>*</span>  </label>

									<input
										type="text"
										className="form-control ml-3"
										onChange={(e)=> setFormData(prev => ({...prev, vehicle_capacity:e.target.value }))}
										value={formData.vehicle_capacity}
										name="vehicle_capacity"
										autoComplete='off'
									/>
								</div>
								 */}
								
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Consignee name<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={(e)=> setFormData(prev => ({...prev, consignee_name:e.target.value }))}
										value={formData.consignee_name}
										name="consignee_name"
										autoComplete='off'
									/>
									
								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Movement Type<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={(e)=> setFormData(prev => ({...prev, movement_type:e.target.value }))}
										value={formData.movement_type}
										name="movement_type"
										autoComplete='off'
									/>
									
								</div>
								
                                <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">LR No.<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={(e)=> setFormData(prev => ({...prev, lr_no:e.target.value }))}
										value={formData.lr_no}
										name="lr_no"
										autoComplete='off'
									/>
								</div>
                                <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Invoice No.<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={(e)=> setFormData(prev => ({...prev, invoice_no:e.target.value }))}
										value={formData.invoice_no}
										name="invoice_no"
										autoComplete='off'
									/>
								</div>
                                <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Number of Boxes  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={(e)=> setFormData(prev => ({...prev, number_of_boxes:e.target.value }))}
										value={formData.number_of_boxes}
										name="number_of_boxes"
										autoComplete='off'
									/>
								</div>
                                <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Destination Pincode<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={(e)=> setFormData(prev => ({...prev, destination_pincode:e.target.value }))}
										value={formData.destination_pincode}
										name="destination_pincode"
										autoComplete='off'
									/>
								</div>
                                <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Destination City<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={(e)=> setFormData(prev => ({...prev, destination_city:e.target.value }))}
										value={formData.destination_city}
										name="destination_city"
										autoComplete='off'
									/>
								</div>
                                <div className="col-xl-12 col-lg-12 row form-group">

                                <button
            type="button"
            className="btn btn-primary" // You can customize the button style
            onClick={handleButtonClick}
            style={{ padding: '5px 10px', fontSize: '12px', cursor: 'pointer', marginLeft:"22px" }} // Adjust the button style if needed
        >
            Add Drop Point
        </button>
        
            <div style={{padding:"5px"}}>
                   { addDealer && (  
                        <div style={{padding:"20px"}}>
                        <div className="slide-body">
                <div className="row p-20p">                   
                
                 <div className="form-group col-xl-12 col-lg-12">
                        <label className="mb-5p">
                          LR No.<span style={{color:'red'}}>*</span>
                        </label>
                        <input
                                                type="text"
                                                name="lr_no"
                                                id="lr_no"
                                                value={manualUploadDetails.lr_no}
                                                className="form-control"
                                                onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, lr_no: e.target.value }))}
                                                required
                                            /> 
                     
                      </div>
                      <div className="form-group col-xl-12 col-lg-12">
                        <label className="mb-5p">
                          Consignee Name<span style={{color:'red'}}>*</span>
                        </label>
                        <input
                                                type="text"
                                                name="lr_no"
                                                id="lr_no"
                                                value={manualUploadDetails.consignee_name}
                                                className="form-control"
                                                onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, consignee_name: e.target.value }))}
                                                required
                                            /> 
                     
                      </div>
                      <div className="form-group col-xl-12 col-lg-12">
                        <label className="mb-5p">
                          Invoice No.<span style={{color:'red'}}>*</span>
                        </label>
                        <input
                                                type="text"
                                                name="lr_no"
                                                id="lr_no"
                                                value={manualUploadDetails.invoice_no}
                                                className="form-control"
                                                onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, invoice_no: e.target.value }))}
                                                required
                                            /> 
                     
                      </div>
                      <div className="form-group col-xl-12 col-lg-12">
                        <label className="mb-5p">
                          Number Of Boxes
                        </label>
                        <input
                                                type="text"
                                                name="lr_no"
                                                id="lr_no"
                                                value={manualUploadDetails.no_of_boxes}
                                                className="form-control"
                                                onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, no_of_boxes: e.target.value }))}
                                                // required
                                            /> 
                     
                      </div>
                      <div className="form-group col-xl-12 col-lg-12">
                        <label className="mb-5p">
                          Destination Pincode<span style={{color:'red'}}>*</span>
                        </label>
                        <input
                                                type="text"
                                                name="lr_no"
                                                id="lr_no"
                                                value={manualUploadDetails.destination_pincode}
                                                className="form-control"
                                                onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, destination_pincode: e.target.value }))}
                                                required
                                            /> 
                     
                      </div>
                      <div className="form-group col-xl-12 col-lg-12">
                        <label className="mb-5p">
                          Destination City<span style={{color:'red'}}>*</span>
                        </label>
                        <input
                                                type="text"
                                                name="lr_no"
                                                id="lr_no"
                                                value={manualUploadDetails.destination_city}
                                                className="form-control"
                                                onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, destination_city: e.target.value }))}
                                                required
                                            /> 
                     
                      </div>
                      {/* <div className="form-group col-xl-12 col-lg-12">
                        <label className="mb-5p">
                          E Way Bill No<span style={{color:'red'}}>*</span>
                        </label>
                        <input
                                                type="text"
                                                name="lr_no"
                                                id="lr_no"
                                                value={manualUploadDetails.eway_bill_no}
                                                className="form-control"
                                                onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, eway_bill_no: e.target.value }))}
                                                required
                                            /> 
                     
                      </div>
                      <div className="form-group col-xl-12 col-lg-12">
                        <label className="mb-5p">
                          Customer Mail Id<span style={{color:'red'}}>*</span>
                        </label>
                        <input
                                                type="text"
                                                name="lr_no"
                                                id="lr_no"
                                                value={manualUploadDetails.customer_mail_id}
                                                className="form-control"
                                                onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, customer_mail_id: e.target.value }))}
                                                required
                                            /> 
                     
                      </div> */}
                      </div>
                      </div>
                      </div>
                      )}
                      </div>
                      </div>

								<div className="col-xl-12 col-lg-12 form-group">
									<button type="submit" className="btn btn-success">Submit</button>
								</div>
                                </div>
                                </div>
							</form>
						</div>
				</div>
                <div
        className={"slide-r " + showAddForm}
        style={{ overflow: "auto",  }}
      >
        <div className="slide-r-title">
          <h4>Add Drop Point<span className="float-right closebtn" style={{ marginRight: "25px"}} onClick={onClickHideManualUpload} >X</span></h4>
          

        </div>
        <div className="row" style={{padding:"20px"}}>
          <div className="col-sm-12">
            <form 
            // onSubmit={onsubmitdata}
            >
              <div className="slide-body">
                <div className="row p-20p">
                  <div className="form-group col-xl-12 col-lg-12">
                    {/* <p className="mb-5p">
                      LR No: {selected_row.lr_no}
                    </p> */}
                  </div>{" "}
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      LR No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.lr_no}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, lr_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Consignee Name<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.consignee_name}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, consignee_name: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Invoice No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.invoice_no}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, invoice_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Number Of Boxes<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.no_of_boxes}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, no_of_boxes: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Destination Pincode<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.destination_pincode}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, destination_pincode: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Destination City<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.destination_city}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, destination_city: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      E Way Bill No<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.eway_bill_no}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, eway_bill_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Customer Mail Id<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.customer_mail_id}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, customer_mail_id: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                  <div className="form-group col-sm-12 mb-20p text-center">
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div> 
      <div
        className={"slide-r " + showAddForm1}
        style={{ overflow: "auto",  }}
      >
        <div className="slide-r-title">
          <h4>Update Details<span className="float-right closebtn" style={{ marginRight: "25px"}} onClick={onClickHideManualUpload1} >X</span></h4>
          

        </div>
        <button
            type="button"
            className="btn btn-primary" // You can customize the button style
            onClick={handleDispatchClick}
            style={{ padding: '5px 10px', fontSize: '12px', cursor: 'pointer', margin:"10px 0px 0px 22px" }} // Adjust the button style if needed
        >
            Update Dispatch Time
        </button>
        <div style={{padding:"5px"}}>
        {dispatchTime && (<div className="row" style={{padding:"20px"}}>
          <div className="col-sm-12">
            <form 
            onSubmit={onClickGateOutUpdate}
            >
              <div className="slide-body">
                <div className="row p-20p">
                  <div className="form-group col-xl-12 col-lg-12">
                    {/* <p className="mb-5p">
                      LR No: {selected_row.lr_no}
                    </p> */}
                  </div>{" "}
                 
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Dispatch Time<span style={{color:'red'}}>*</span>
                    </label>
                  <div id="datepicker1">
                        <DatePicker
                    selected={manualUploadDetails1.dispatch_time}
                    onChange={changeHandleDate}
                    name="dispatch_time"
                    className="datepicker-custom-ptl form-control"
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15} // Adjust this if you want different time intervals
                    timeCaption="Time"
                    dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                    // placeholderText="Date" // Equivalent to placeholder in the original
                    id="dispatch_time"
                    autoComplete='off'
                    // style={{width:"100%"}}
                    required
                    />
                  </div>
                  
                  </div>
                 
                  {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                  <div className="form-group col-sm-12 mb-20p text-center">
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>)}
        <div className="row" style={{padding:"0px 20px 20px 20px"}}>
          <div className="col-sm-12">
            <form 
            onSubmit={onClickUpdateConsignment}
            >
              <div className="slide-body">
                <div className="row p-20p">
                  <div className="form-group col-xl-12 col-lg-12">
                    {/* <p className="mb-5p">
                      LR No: {selected_row.lr_no}
                    </p> */}
                  </div>{" "}
                
                  {/* <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Gate Out Time<span style={{color:'red'}}>*</span>
                    </label>
                  <div id="datepicker1">
                        <DatePicker
                    selected={manualUploadDetails1.gate_out_time}
                    onChange={changeHandleDate}
                    name="gate_out_time"
                    className="datepicker-custom-ptl form-control"
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15} // Adjust this if you want different time intervals
                    timeCaption="Time"
                    dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                    // placeholderText="Date" // Equivalent to placeholder in the original
                    id="gate_out_time"
                    autoComplete='off'
                    // style={{width:"100%"}}
                    required
                    />
                  </div>
                  
                  </div> */}
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Driver Mobile No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="driver_number_update"
                                            id="driver_number_update"
                                            value={manualUpdateConsignment.driver_number}
                                            className="form-control"
                                            onChange={handleDriverNumberChange}
                                            required
                                        /> 
                     {error1 && <span style={{ color: 'red', fontSize:"10px" }}>{error1}</span>}                    
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Source<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.source}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, source: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Truck No<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.truck_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, truck_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Truck Seal No<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.truck_seal_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, truck_seal_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Vehicle Type<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.vehicle_type}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, vehicle_type: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Courier Partner<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.courier_partner}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, courier_partner: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Vehicle Capacity<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.vehicle_capacity}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, vehicle_capacity: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Consignee Name<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.consignee_name}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, consignee_name: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      LR No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.lr_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, lr_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Invoice No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.invoice_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, invoice_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                  <button onClick={onClickCancelActiveCourierConsignemnts} className="btn btn-danger custom-btn f12 label label-success" 
                        title="Add Dealer" >Disable</button>
                        </div>
                  {/* <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Destination Pincode<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.lr_no}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, lr_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Destination City<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.lr_no}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, lr_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div> */}
               
                 
                  {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                  <div className="form-group col-sm-12 mb-20p text-center">
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        </div>
      </div> 
      <div
        className={"slide-r " + showAddForm3}
        style={{ overflow: "auto",  }}
      >
        <div className="slide-r-title">
          <h4>Update Details<span className="float-right closebtn" style={{ marginRight: "25px"}} onClick={onClickHideManualUpload3} >X</span></h4>
          
        </div>
        <div className="row" style={{padding:"20px"}}>
          <div className="col-sm-12">
            <form 
            onSubmit={onClickUpdateConsignment}
            >
              <div className="slide-body">
                <div className="row p-20p">
                  <div className="form-group col-xl-12 col-lg-12">
                    {/* <p className="mb-5p">
                      LR No: {selected_row.lr_no}
                    </p> */}
                  </div>{" "}
                
                  {/* <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Gate Out Time<span style={{color:'red'}}>*</span>
                    </label>
                  <div id="datepicker1">
                        <DatePicker
                    selected={manualUploadDetails1.gate_out_time}
                    onChange={changeHandleDate}
                    name="gate_out_time"
                    className="datepicker-custom-ptl form-control"
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15} // Adjust this if you want different time intervals
                    timeCaption="Time"
                    dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                    // placeholderText="Date" // Equivalent to placeholder in the original
                    id="gate_out_time"
                    autoComplete='off'
                    // style={{width:"100%"}}
                    required
                    />
                  </div>
                  
                  </div> */}
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Driver Mobile No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="driver_number_update"
                                            id="driver_number_update"
                                            value={manualUpdateConsignment.driver_number}
                                            className="form-control"
                                            onChange={handleDriverNumberChange}
                                            required
                                        /> 
                     {error1 && <span style={{ color: 'red', fontSize:"10px" }}>{error1}</span>}                    
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Source<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.source}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, source: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Truck No<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.truck_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, truck_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Truck Seal No<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.truck_seal_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, truck_seal_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Vehicle Type<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.vehicle_type}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, vehicle_type: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Courier Partner<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.courier_partner}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, courier_partner: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Vehicle Capacity<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.vehicle_capacity}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, vehicle_capacity: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Consignee Name<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.consignee_name}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, consignee_name: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      LR No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.lr_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, lr_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Invoice No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.invoice_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, invoice_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                  <button onClick={onClickCancelActiveCourierConsignemnts} className="btn btn-danger custom-btn f12 label label-success" 
                        title="Add Dealer" >Disable</button>
                        </div>
                  {/* <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Destination Pincode<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.lr_no}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, lr_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Destination City<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.lr_no}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, lr_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div> */}
               
                 
                  {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                  <div className="form-group col-sm-12 mb-20p text-center">
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div> 
      <div
        className={"slide-r " + showAddForm2}
        style={{ overflow: "auto",  }}
      >
        <div className="slide-r-title">
          <h4>Update Details<span className="float-right closebtn" style={{ marginRight: "25px"}} onClick={onClickHideManualUpload2} >X</span></h4>
          

        </div>
        <button
            type="button"
            className="btn btn-primary" // You can customize the button style
            onClick={handleCurrentStatusClick}
            style={{ padding: '5px 10px', fontSize: '12px', cursor: 'pointer', margin:"10px 0px 0px 22px" }} // Adjust the button style if needed
        >
            Update Status
        </button>
        <div style={{padding:"5px"}}>
            {updateCurrentStatus && (<div className="row" style={{padding:"20px"}}>
          <div className="col-sm-12">
            <form 
            onSubmit={onClickDeliveredSubmit}
            >
              <div className="slide-body">
                <div className="row p-20p">
                  <div className="form-group col-xl-12 col-lg-12">
                    {/* <p className="mb-5p">
                      LR No: {selected_row.lr_no}
                    </p> */}
                  </div>{" "}
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Status<span style={{color:'red'}}>*</span>
                    </label>
                    <Select
                      closeMenuOnSelect={true}
                      value={manualUploadDetails2.delivered_status}
                      // multi={true}
                      // className={"border-radius-0"}
                      onChange={(e) =>
                        onSelectDeliveredStatus(e)
                      }
                      style={{ borderRadius: "0px" }}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          fontSize: "0.8rem",
                          color: "#6e707e",
                        }),
                        singleValue: (provided, state) => ({
                          ...provided,
                          fontSize: "0.9rem",
                        }),
                      }}
                      options={deliveredStatusList}
                    />
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Current Location<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails2.current_location}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails2(prev => ({ ...prev, current_location: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                    Date Time<span style={{color:'red'}}>*</span>
                    </label>
                  <div id="datepicker1">
                        <DatePicker
                    selected={deliveredDate.delivered_date}
                    onChange={changeHandleDate1}
                    name="delivered_date"
                    className="datepicker-custom-ptl form-control"
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15} // Adjust this if you want different time intervals
                    timeCaption="Time"
                    dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                    // placeholderText="Date" // Equivalent to placeholder in the original
                    id="delivered_date"
                    autoComplete='off'
                    // style={{width:"100%"}}
                    required
                   
                    />
                  </div>
                  
                  </div>
                 
                  {invoiceCount &&  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Destination Pincode<span style={{color:'red'}}>*</span>
                    </label>
                    <Select
                      closeMenuOnSelect={true}
                      value={destinationPincodeDetails}
                      // multi={true}
                      // className={"border-radius-0"}
                      onChange={(e) =>
                        setDestinationPincodeDetails({label: e.label, value:e.value})
                      }
                      style={{ borderRadius: "0px" }}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          fontSize: "0.8rem",
                          color: "#6e707e",
                        }),
                        singleValue: (provided, state) => ({
                          ...provided,
                          fontSize: "0.9rem",
                        }),
                      }}
                      options={destinationPincodeList}
                    />
                  </div>}
                 
                  {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                  <div className="form-group col-sm-12 mb-20p text-center">
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>)}
        
        </div>
        <div className="row" style={{padding:"0px 20px 20px 20px"}}>
          <div className="col-sm-12">
            <form 
            onSubmit={onClickUpdateConsignment}
            >
              <div className="slide-body">
                <div className="row p-20p">
                  <div className="form-group col-xl-12 col-lg-12">
                    {/* <p className="mb-5p">
                      LR No: {selected_row.lr_no}
                    </p> */}
                  </div>{" "}
                
                  {/* <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Gate Out Time<span style={{color:'red'}}>*</span>
                    </label>
                  <div id="datepicker1">
                        <DatePicker
                    selected={manualUploadDetails1.gate_out_time}
                    onChange={changeHandleDate}
                    name="gate_out_time"
                    className="datepicker-custom-ptl form-control"
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15} // Adjust this if you want different time intervals
                    timeCaption="Time"
                    dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                    // placeholderText="Date" // Equivalent to placeholder in the original
                    id="gate_out_time"
                    autoComplete='off'
                    // style={{width:"100%"}}
                    required
                    />
                  </div>
                  
                  </div> */}
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Driver Mobile No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="driver_number_update"
                                            id="driver_number_update"
                                            value={manualUpdateConsignment.driver_number}
                                            className="form-control"
                                            onChange={handleDriverNumberChange}
                                            required
                                        /> 
                     {error1 && <span style={{ color: 'red', fontSize:"10px" }}>{error1}</span>}                    
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Source<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.source}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, source: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Truck No<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.truck_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, truck_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Truck Seal No<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.truck_seal_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, truck_seal_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Vehicle Type<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.vehicle_type}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, vehicle_type: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Courier Partner<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.courier_partner}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, courier_partner: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Vehicle Capacity<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.vehicle_capacity}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, vehicle_capacity: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Consignee Name<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.consignee_name}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, consignee_name: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      LR No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.lr_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, lr_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Invoice No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUpdateConsignment.invoice_no}
                                            className="form-control"
                                            onChange={(e) => setManualUpdateConsignment(prev => ({ ...prev, invoice_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                  <button onClick={onClickCancelActiveCourierConsignemnts} className="btn btn-danger custom-btn f12 label label-success" 
                        title="Add Dealer" >Disable</button>
                        </div>
                  {/* <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Destination Pincode<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.lr_no}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, lr_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Destination City<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.lr_no}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, lr_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div> */}
               
                 
                  {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                  <div className="form-group col-sm-12 mb-20p text-center">
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        
      </div>     
            <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}
                onClick={onClickHideAll}
            ></div>
            <div className={"dataLoadpage " + (loadshow)}></div>
            <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
                    </>
                    <CustomDialog
        isOpen={isSliderEmailOpen}
        onClose={onCloseEmail}
        onSubmitEmail={onSubmitEmail}
        email={email}
        changeEmail={changeEmail}
        whatsapp_no={whatsapp_no}
        changeWhatsapp={changeWhatsapp}
        expired_time={expired_time}
        changeExpiredTime={changeExpiredTime}
        handleKeyDown={handleKeyDown}
      /> 
            <CustomDialogForDocumentsViewing
        isOpen={isSliderDocumentOpen}
        onClose={onCloseDocument}
        documents={documents}
      /> 
        <Modal
                onHide={closeCancelModal}
                dialogClassName="my-modal"
                show={cancelModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Disable Shipment</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeCancelModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <div>
                        <form onSubmit={cancelFormCloseHandler}>
                            <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                <label className="reason">Vehicle No</label>
                                <input type="text" name="reason" autoComplete="off" class="form-control" id="lrno" value={rownode.truck_no} />                                
                            </div>
                            <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                <label>Selected Invoices </label>
                                <Select 
                                    closeMenuOnSelect={false}
                                    value={invoiceNoList}
                                    isMulti={true}
                                    className="border-radius-0"
                                    style={{ borderRadius: "0px" }}
                                    required 
                                />
                            </div>
                            <div className="col-xl-12 col-lg-12" style={{marginBottom:"20px"}}>
                                <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                                <label className="custom-label">
                                    Reason For Withdrawel
                                </label>
                                <textarea
                                    type="text"
                                    value={reasonForCancellation}
                                    onChange={e => setReasonForCancellation(e.target.value)}
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end" }}>
                                <button type='submit' className='primary-button'>Submit</button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        <div className={"slide-r " + (sliderShow)}>
                    <div className="slide-r-title">
                        <h4>Upload POD
                            <span
                                  className="float-right closebtn"
                                  style={{ marginRight: "25px" }}
                                  onClick={onCloseSliderDiv}          
                                        >
                                 X
                            </span>
                        </h4>
                    </div>
                    

                    <div className="col-sm-12">
                        <div className="slide-r-body">
                            <form className="theme-form" method="POST" id="formPOD" enctype="multipart/form-data" onSubmit={uploadDocument}>
                                <div className="row p-20p">
                                    {/* <div className="form-group col-sm-12 mb-20p">
                                        <label>Delivered Date<span cl
                                        assName="rclr fbold">*</span></label>
                                        <input type="text" name="startDate" className="form-control" value={this.state.delivered_date} required />

                                    </div> */}
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Upload Document<span className="rclr fbold">*</span></label>
                                        <input type="file" name="epodDoc" id="epodDoc" className="form-control" onChange={changeFileHandlerForPod} required />
                                    </div>
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label className="custom-label">
                                            Damage
                                        </label><br />
                                        <input type='number' value={damage} onChange={(e) => setDamage(e.target.value)} />
                                     </div>
                                     <div className="form-group col-sm-12 mb-20p">
                                        <label className="custom-label">
                                            Excess
                                        </label><br />
                                        <input type='number' value={excess} onChange={(e) => setExcess(e.target.value)} />
                                     </div>
                                     <div className="form-group col-sm-12 mb-20p">
                                        <label className="custom-label">
                                            Pilferage
                                        </label><br />
                                        <input type='number' value={pilferage} onChange={(e) => setPilferage(e.target.value)} />
                                     </div>
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label className="custom-label">
                                            Short
                                        </label><br />
                                        <input type='number' value={short} onChange={(e) => setShort(e.target.value)} />
                                     </div>
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Remarks<span className="rclr fbold">*</span></label>
                                        <textarea name="podremarks" id="podremarks" rows="3" value={podremarks} onChange={changeHandler1} className="form-control" ></textarea>
                                    </div> 
                                    
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button type="submit" className="btn btn-success">Upload</button>
                                        <button type="button" className="btn btn-default" onClick={hideSlideBlock}>Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={"slide-r " + (sliderShow1)}>
                    <div className="slide-r-title">
                        <h4>Upload Document
                            <span
                                  className="float-right closebtn"
                                  style={{ marginRight: "25px" }}
                                  onClick={onCloseSliderDiv1}          
                                        >
                                 X
                            </span>
                        </h4>
                    </div>
                    

                    <div className="col-sm-12">
                        <div className="slide-r-body">
                            <form className="theme-form" method="POST" id="formDocument" enctype="multipart/form-data" onSubmit={uploadDocument1}>
                                <div className="row p-20p">
                                    {/* <div className="form-group col-sm-12 mb-20p">
                                        <label>Delivered Date<span cl
                                        assName="rclr fbold">*</span></label>
                                        <input type="text" name="startDate" className="form-control" value={this.state.delivered_date} required />

                                    </div> */}
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Upload Document<span className="rclr fbold">*</span></label>
                                        <input type="file" name="uploadDoc" id="uploadDoc" className="form-control"  multiple onChange={changeFileHandlerForUploadDoc} required />
                                    </div>
                                  
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Remarks<span className="rclr fbold">*</span></label>
                                        <textarea name="docremarks" id="docremarks" rows="3" value={docremarks} onChange={changeHandler1} className="form-control" ></textarea>
                                    </div> 
                                    
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button type="submit" className="btn btn-success">Upload</button>
                                        <button type="button" className="btn btn-default" onClick={hideSlideBlockForDocument}>Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>        
                {gateOutSlide
                 && 
                 <div className={"sliderBlock3 " + (gateOutSlide)} >
                <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideGateoutSubmit} >
                    <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                </span>

                <div className='d-flex mt-60p' style={{marginLeft:"42px"}}>
                            <div className='d-flex flex-column ml-20p'>
                                <h1 className='confirm-heading'>Are you sure you want to submit ?</h1>
                            </div>
                </div>

                
                <div className='d-flex flex-row ml-30p mt-20p'>
                    <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideGateoutSubmit} >Cancel</button>
                    <button className='btn_hover7' onClick={onsubmitdata1}>Submit</button>
                </div>

            </div>}
            {deliveredSlide
                 && 
                 <div className={"sliderBlock3 " + (deliveredSlide)} >
                <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideDeliveredSubmit} >
                    <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                </span>

                <div className='d-flex mt-60p' style={{marginLeft:"42px"}}>
                            <div className='d-flex flex-column ml-20p'>
                                <h1 className='confirm-heading'>Are you sure you want to submit ?</h1>
                            </div>
                </div>

                
                <div className='d-flex flex-row ml-30p mt-20p'>
                    <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideDeliveredSubmit} >Cancel</button>
                    <button className='btn_hover7' onClick={onsubmitdata2}>Submit</button>
                </div>

            </div>}
                    </div>

                    );
}

export default FTLConsignments;

function loadScript(url) {
    var index = window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src = url
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}
function secondsToString(seconds) {
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays + " days " + numhours + " hours " + numminutes + " minutes ";
}

function secondsToDays(seconds) {
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays;
}

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
} 
function dateComparator(date1, date2) {
	// console.log("dateComparator");
	// console.log(date1.length);
	if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
		// console.log(date1,date2);
		var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
		date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
		var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
		date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
		// console.log(date1,date2);
		var date1Number = monthToComparableNumber(date1);
		var date2Number = monthToComparableNumber(date2);
		// console.log(date1Number,date2Number);
		if (date1Number === null && date2Number === null) {
			return 0;
		}
		if (date1Number === null) {
			return -1;
		}
		if (date2Number === null) {
			return 1;
		}
		return date1Number - date2Number;
	}
}
function getMonthNumber(monthName) {
	var months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May',
		'Jun', 'Jul', 'Aug', 'Sep',
		'Oct', 'Nov', 'Dec'
	];
	var monthNum = months.indexOf(monthName) + 1;
	if (monthNum < 10) {
		monthNum = "0" + monthNum.toString();
	}
	return monthNum;
}
function monthToComparableNumber(date) {
	// console.log(date,date.length);
	if (date === undefined || date === null || date.length !== 16) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	//console.log(yearNumber,monthNumber,dayNumber);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}
